
// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => { 
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({ 
//     emp_id: "", 
//     content: "", 
//     accomplished: "", 
//     improvements: "" 
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`; 

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);

//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview 
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation 
//       ? '/gt-api/save_probation_notice.php' 
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;
//     if (!acc[name]) acc[name] = { emp_id: sub.emp_id, years: {} };
//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);
//     return acc;
//   }, {});

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);
//     let nextWorkflowStatus = '';
//     if (customStatus) {
//         nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//         nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//         nextWorkflowStatus = 'Sign_Off';
//     }

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(selected.okr_details),
//           workflow_status: nextWorkflowStatus 
//         })
//       });
//       const res = await response.json();
//       if (res.success) {
//         window.location.reload();
//       }
//     } catch (err) { alert("🚨 Sync failed"); }
//     finally { setIsUpdating(false); }
//   };

//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{maxWidth: '600px', margin: '0 auto'}}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
//             <div className="form-group">
//               <label style={{color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block'}}>SELECT EMPLOYEE</label>
//               <select 
//                 className="modern-select" 
//                 style={{width: '100%', padding: '10px'}}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({...mgmtSelection, emp_id: e.target.value})}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block'}}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea 
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px'}}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({...mgmtSelection, accomplished: e.target.value})}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block'}}>IMPROVEMENT NEEDED</label>
//                   <textarea 
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px'}}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({...mgmtSelection, improvements: e.target.value})}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block'}}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px', 
//                   background: 'rgba(0,188,212,0.08)', 
//                   border: '1px solid #00bcd4', 
//                   borderRadius: '8px', 
//                   color: '#fff', 
//                   fontSize: '13px', 
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block'}}>MESSAGE / NOTICE</label>
//                 <textarea 
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px'}}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({...mgmtSelection, content: e.target.value})}
//                 />
//               </div>
//             )}

//             <button 
//               className="btn-primary" 
//               style={{marginTop: '10px', width: '100%'}}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderOKRTrackerTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;

//     if (selected) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <div className="viewer-nav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
//             <button className="back-action-btn" onClick={() => setSelected(null)}>← BACK TO TEAM</button>
//             <div style={{ display: 'flex', gap: '10px' }}>
//               {selected.workflow_status === 'Management_Review' && (
//                   <button className="btn-primary" style={{background: '#4CAF50'}} onClick={() => updateOKRStatus('Scoring')} disabled={isUpdating}>
//                     {isUpdating ? "PROCESSING..." : "APPROVE & RETURN FOR SCORING"}
//                   </button>
//               )}
//               {selected.workflow_status === 'Manager_Scoring_Review' && (
//                   <button className="btn-primary" style={{background: '#2196F3'}} onClick={() => updateOKRStatus('Sign_Off')} disabled={isUpdating}>
//                     {isUpdating ? "SAVING..." : "FINALIZE SCORES & SEND FOR SIGN-OFF"}
//                   </button>
//               )}
//               {selected.workflow_status === 'Locked' && (
//                   <span className="status-pill-mini locked">VIEW ONLY (LOCKED)</span>
//               )}
//               {(selected.workflow_status === 'Scoring' || selected.workflow_status === 'Sign_Off') && (
//                   <span className="status-pill-mini" style={{background: 'rgba(255,152,0,0.1)', color: '#ff9800', border: '1px solid #ff9800'}}>
//                       WAITING FOR EMPLOYEE ACTION
//                   </span>
//               )}
//             </div>
//           </div>

//           <div className="glass-report-container">
//             <header className="report-header-section">
//               <div className="user-profile-header">
//                 <div className="avatar-circle">{selected.emp_name?.charAt(0)}</div>
//                 <div className="user-text">
//                   <h2 className="emp-name-display">{selected.emp_name}</h2>
//                   <p className="emp-meta-display">
//                       ID: {selected.emp_id} | 
//                       <span className="blue-gradient-text"> {selected.quarter} {selected.year}</span> | 
//                       <span style={{color: '#00bcd4', marginLeft: '5px'}}>[{selected.department}]</span> |
//                       <span style={{color: '#ff9800', marginLeft: '5px'}}> STAGE: {selected.workflow_status.replace(/_/g, ' ')}</span>
//                   </p>
//                 </div>
//               </div>
//             </header>

//             <div className="report-table-scroll">
//               <table className="sequencer-table-view">
//                 <thead>
//                   <tr>
//                     <th width="30%">OBJECTIVE</th>
//                     <th width="50%">KEY RESULTS</th>
//                     <th width="20%">SCORE</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {Array.isArray(selected.okr_details) && selected.okr_details.map((obj, oIdx) => (
//                     <React.Fragment key={oIdx}>
//                       {obj.keyResults?.map((kr, kIdx) => (
//                         <tr key={`${oIdx}-${kIdx}`} className={kIdx === 3 ? "obj-block-end" : ""}>
//                           {kIdx === 0 && <td rowSpan={obj.keyResults.length} className="obj-main-cell"><p className="obj-text-content">{obj.objective}</p></td>}
//                           <td className="kr-main-cell"><p className="kr-text-content">{kr.text}</p></td>
//                           <td className="center-cell">
//                             <select className="modern-select" value={kr.result || 'Pending'} 
//                               disabled={selected.workflow_status !== 'Manager_Scoring_Review'}
//                               onChange={(e) => handleStatusChange(oIdx, kIdx, e.target.value)}>
//                               {resultOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
//                             </select>
//                           </td>
//                         </tr>
//                       ))}
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '15px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>OKR <span className="blue-gradient-text">Management</span></h2>
//           </div>

//           <div className="directory-grid" style={{ display: 'grid', gap: '20px' }}>
//             {Object.entries(groupedData).map(([empName, data]) => (
//               <div key={empName} className="employee-card" style={{
//                 background: 'rgba(255,255,255,0.03)',
//                 borderRadius: '12px',
//                 border: '1px solid rgba(255,255,255,0.08)',
//                 padding: '20px'
//               }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.03)', paddingBottom: '10px' }}>
//                   <div className="avatar-circle" style={{ width: '40px', height: '40px', fontSize: '16px' }}>{empName.charAt(0)}</div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#00bcd4' }}>{empName}</h3>
//                     <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
//                       <p style={{ margin: 0, fontSize: '10px', opacity: 0.4 }}>ID: {data.emp_id}</p>
//                       <span style={{fontSize: '9px', background: 'rgba(0,188,212,0.1)', color: '#00bcd4', padding: '1px 5px', borderRadius: '3px'}}>
//                           {data.years[Object.keys(data.years)[0]][0].department}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                   {Object.keys(data.years).sort((a,b) => b-a).map(year => (
//                     <div key={year} style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
//                       <div style={{ minWidth: '70px', fontSize: '14px', fontWeight: 'bold', color: '#fff', paddingTop: '8px' }}>{year}</div>
//                       <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
//                         {data.years[year].map(sub => (
//                           <button 
//                             key={sub.id} 
//                             onClick={() => {
//                               const details = typeof sub.okr_details === 'string' ? JSON.parse(sub.okr_details) : sub.okr_details;
//                               setSelected({...sub, okr_details: details});
//                             }}
//                             className="btn-view-sequence"
//                             style={{
//                               background: sub.workflow_status === 'Locked' ? 'rgba(255,255,255,0.03)' : 'rgba(0,188,212,0.1)',
//                               border: sub.workflow_status === 'Locked' ? '1px solid #444' : (['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status) ? '1px solid #ff9800' : '1px solid #00bcd4'),
//                               color: sub.workflow_status === 'Locked' ? '#666' : '#00bcd4',
//                               borderRadius: '4px',
//                               padding: '8px 15px',
//                               fontSize: '11px',
//                               cursor: 'pointer',
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: '6px'
//                             }}
//                           >
//                             {sub.quarter} {sub.workflow_status === 'Locked' ? '🔒' : (['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status) ? '🔔' : '●')}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{marginTop: '20px', padding: '30px'}}>
//             <h2 className="blue-gradient-text" style={{fontSize: '1.8rem'}}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{opacity: 0.6}}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0'}} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{marginBottom: '25px'}}>
//                 <h4 style={{color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem'}}>{section.label.toUpperCase()}</h4>
//                 <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5'}}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{opacity: 0.4}}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{color: '#ff9800', fontSize: '12px'}}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{color: '#00bcd4', fontWeight: 'bold'}}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{textAlign: 'center', padding: '40px', opacity: 0.5}}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => { 
//               setActiveTab(tab); 
//               setSelected(null); 
//               setSelectedReview(null); 
//               setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" }); 
//             }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>
//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>
//   );
// };

// export default ManagementOKRViewer;





















// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);

//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;
//     if (!acc[name]) acc[name] = { emp_id: sub.emp_id, years: {} };
//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);
//     return acc;
//   }, {});

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);
//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(selected.okr_details),
//           workflow_status: nextWorkflowStatus
//         })
//       });
//       const res = await response.json();
//       if (res.success) {
//         window.location.reload();
//       }
//     } catch (err) { alert("🚨 Sync failed"); }
//     finally { setIsUpdating(false); }
//   };

//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderOKRTrackerTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;

//     // if (selected) {
//     //   return (
//     //     <div className="okr-viewer-wrapper animate-fade">
//     //       <div className="viewer-nav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
//     //         <button className="back-action-btn" onClick={() => setSelected(null)}>← BACK TO TEAM</button>
//     //         <div style={{ display: 'flex', gap: '10px' }}>
//     //           {selected.workflow_status === 'Management_Review' && (
//     //             <button className="btn-primary" style={{ background: '#4CAF50' }} onClick={() => updateOKRStatus('Scoring')} disabled={isUpdating}>
//     //               {isUpdating ? "PROCESSING..." : "APPROVE & RETURN FOR SCORING"}
//     //             </button>
//     //           )}
//     //           {selected.workflow_status === 'Manager_Scoring_Review' && (
//     //             <button className="btn-primary" style={{ background: '#2196F3' }} onClick={() => updateOKRStatus('Sign_Off')} disabled={isUpdating}>
//     //               {isUpdating ? "SAVING..." : "FINALIZE SCORES & SEND FOR SIGN-OFF"}
//     //             </button>
//     //           )}
//     //           {selected.workflow_status === 'Locked' && (
//     //             <span className="status-pill-mini locked">VIEW ONLY (LOCKED)</span>
//     //           )}
//     //           {(selected.workflow_status === 'Scoring' || selected.workflow_status === 'Sign_Off') && (
//     //             <span className="status-pill-mini" style={{ background: 'rgba(255,152,0,0.1)', color: '#ff9800', border: '1px solid #ff9800' }}>
//     //               WAITING FOR EMPLOYEE ACTION
//     //             </span>
//     //           )}
//     //         </div>
//     //       </div>

//     //       <div className="glass-report-container">
//     //         <header className="report-header-section">
//     //           <div className="user-profile-header">
//     //             <div className="avatar-circle">{selected.emp_name?.charAt(0)}</div>
//     //             <div className="user-text">
//     //               <h2 className="emp-name-display">{selected.emp_name}</h2>
//     //               <p className="emp-meta-display">
//     //                 ID: {selected.emp_id} |
//     //                 <span className="blue-gradient-text"> {selected.quarter} {selected.year}</span> |
//     //                 <span style={{ color: '#00bcd4', marginLeft: '5px' }}>[{selected.department}]</span> |
//     //                 <span style={{ color: '#ff9800', marginLeft: '5px' }}> STAGE: {selected.workflow_status.replace(/_/g, ' ')}</span>
//     //               </p>
//     //             </div>
//     //           </div>
//     //         </header>

//     //         <div className="report-table-scroll">
//     //           <table className="sequencer-table-view">
//     //             <thead>
//     //               <tr>
//     //                 <th width="30%">OBJECTIVE</th>
//     //                 <th width="50%">KEY RESULTS</th>
//     //                 <th width="20%">SCORE</th>
//     //               </tr>
//     //             </thead>
//     //             <tbody>
//     //               {Array.isArray(selected.okr_details) && selected.okr_details.map((obj, oIdx) => (
//     //                 <React.Fragment key={oIdx}>
//     //                   {obj.keyResults?.map((kr, kIdx) => (
//     //                     <tr key={`${oIdx}-${kIdx}`} className={kIdx === 3 ? "obj-block-end" : ""}>
//     //                       {kIdx === 0 && <td rowSpan={obj.keyResults.length} className="obj-main-cell"><p className="obj-text-content">{obj.objective}</p></td>}
//     //                       <td className="kr-main-cell"><p className="kr-text-content">{kr.text}</p></td>
//     //                       <td className="center-cell">
//     //                         <select className="modern-select" value={kr.result || 'Pending'}
//     //                           disabled={selected.workflow_status !== 'Manager_Scoring_Review'}
//     //                           onChange={(e) => handleStatusChange(oIdx, kIdx, e.target.value)}>
//     //                           {resultOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
//     //                         </select>
//     //                       </td>
//     //                     </tr>
//     //                   ))}
//     //                 </React.Fragment>
//     //               ))}
//     //             </tbody>
//     //           </table>
//     //         </div>
//     //       </div>
//     //     </div>
//     //   );
//     // }

//     if (selected) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           {/* TOP NAVIGATION BAR */}
//           <div className="viewer-nav-glass">
//             <button className="back-action-btn" onClick={() => setSelected(null)}>
//               <span className="icon">←</span> BACK TO DIRECTORY
//             </button>

//             <div className="action-group">
//               {selected.workflow_status === 'Management_Review' && (
//                 <button className="btn-glow-success" onClick={() => updateOKRStatus('Scoring')} disabled={isUpdating}>
//                   {isUpdating ? "PROCESSING..." : "APPROVE FOR SCORING"}
//                 </button>
//               )}
//               {selected.workflow_status === 'Manager_Scoring_Review' && (
//                 <button className="btn-glow-primary" onClick={() => updateOKRStatus('Sign_Off')} disabled={isUpdating}>
//                   {isUpdating ? "SAVING..." : "FINALIZE & SIGN-OFF"}
//                 </button>
//               )}
//               {selected.workflow_status === 'Locked' && (
//                 <div className="status-indicator locked">READ ONLY MODE</div>
//               )}
//             </div>
//           </div>

//           {/* COMPACT PROFILE HEADER */}
//           <div className="report-profile-card">
//             <div className="profile-main">
//               <div className="avatar-hex">{selected.emp_name?.charAt(0)}</div>
//               <div className="info">
//                 <h2 className="name">{selected.emp_name}</h2>
//                 <div className="meta-pills">
//                   <span className="pill">ID: {selected.emp_id}</span>
//                   <span className="pill cyan">{selected.quarter} {selected.year}</span>
//                   <span className="pill department">{selected.department}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="status-badge-container">
//               <label>CURRENT STAGE</label>
//               <div className="status-text">{selected.workflow_status.replace(/_/g, ' ')}</div>
//             </div>
//           </div>

//           {/* OBJECTIVE STREAM (No Table) */}
//           <div className="objective-stream">
//             {Array.isArray(selected.okr_details) && selected.okr_details.map((obj, oIdx) => (
//               <div key={oIdx} className="objective-card">
//                 <div className="obj-header">
//                   <div className="obj-number">0{oIdx + 1}</div>
//                   <h3 className="obj-title">{obj.objective}</h3>
//                 </div>

//                 <div className="kr-list">
//                   {obj.keyResults?.map((kr, kIdx) => (
//                     <div key={`${oIdx}-${kIdx}`} className="kr-row">

//                       {/* 🔢 NUMBER */}
//                       <div className="kr-index">
//                         {kIdx + 1}
//                       </div>

//                       {/* 📝 TEXT */}
//                       <div className="kr-content">
//                         {kr.text}
//                       </div>

//                       {/* 🎯 SCORE */}
//                       <div className="kr-score-zone">
//                         <label>SCORE</label>
//                         <select
//                           className="minimal-select"
//                           value={kr.result || 'Pending'}
//                           disabled={selected.workflow_status !== 'Manager_Scoring_Review'}
//                           onChange={(e) => handleStatusChange(oIdx, kIdx, e.target.value)}
//                         >
//                           {resultOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
//                         </select>
//                       </div>

//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     // return (
//     //   <div className="okr-genesis-container animate-fade">
//     //     <div className="okr-glass-card">
//     //       <div className="list-header" style={{ marginBottom: '30px', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '15px' }}>
//     //         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>OKR <span className="blue-gradient-text">Management</span></h2>
//     //       </div>

//     //       <div className="directory-grid" style={{ display: 'grid', gap: '20px' }}>
//     //         {Object.entries(groupedData).map(([empName, data]) => (
//     //           <div key={empName} className="employee-card" style={{
//     //             background: 'rgba(255,255,255,0.03)',
//     //             borderRadius: '12px',
//     //             border: '1px solid rgba(255,255,255,0.08)',
//     //             padding: '20px'
//     //           }}>
//     //             <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.03)', paddingBottom: '10px' }}>
//     //               <div className="avatar-circle" style={{ width: '40px', height: '40px', fontSize: '16px' }}>{empName.charAt(0)}</div>
//     //               <div>
//     //                 <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#00bcd4' }}>{empName}</h3>
//     //                 <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
//     //                   <p style={{ margin: 0, fontSize: '10px', opacity: 0.4 }}>ID: {data.emp_id}</p>
//     //                   <span style={{fontSize: '9px', background: 'rgba(0,188,212,0.1)', color: '#00bcd4', padding: '1px 5px', borderRadius: '3px'}}>
//     //                       {data.years[Object.keys(data.years)[0]][0].department}
//     //                   </span>
//     //                 </div>
//     //               </div>
//     //             </div>

//     //             <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//     //               {Object.keys(data.years).sort((a,b) => b-a).map(year => (
//     //                 <div key={year} style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
//     //                   <div style={{ minWidth: '70px', fontSize: '14px', fontWeight: 'bold', color: '#fff', paddingTop: '8px' }}>{year}</div>
//     //                   <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
//     //                     {data.years[year].map(sub => (
//     //                       <button 
//     //                         key={sub.id} 
//     //                         onClick={() => {
//     //                           const details = typeof sub.okr_details === 'string' ? JSON.parse(sub.okr_details) : sub.okr_details;
//     //                           setSelected({...sub, okr_details: details});
//     //                         }}
//     //                         className="btn-view-sequence"
//     //                         style={{
//     //                           background: sub.workflow_status === 'Locked' ? 'rgba(255,255,255,0.03)' : 'rgba(0,188,212,0.1)',
//     //                           border: sub.workflow_status === 'Locked' ? '1px solid #444' : (['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status) ? '1px solid #ff9800' : '1px solid #00bcd4'),
//     //                           color: sub.workflow_status === 'Locked' ? '#666' : '#00bcd4',
//     //                           borderRadius: '4px',
//     //                           padding: '8px 15px',
//     //                           fontSize: '11px',
//     //                           cursor: 'pointer',
//     //                           display: 'flex',
//     //                           alignItems: 'center',
//     //                           gap: '6px'
//     //                         }}
//     //                       >
//     //                         {sub.quarter} {sub.workflow_status === 'Locked' ? '🔒' : (['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status) ? '🔔' : '●')}
//     //                       </button>
//     //                     ))}
//     //                   </div>
//     //                 </div>
//     //               ))}
//     //             </div>
//     //           </div>
//     //         ))}
//     //       </div>
//     //     </div>
//     //   </div>


//     // );

//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0', // Centered padding for the content
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div style={{ marginBottom: '40px' }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#00bcd4', fontSize: '12px', fontWeight: 'bold', letterSpacing: '1px', marginBottom: '8px' }}>
//               <span style={{ opacity: 0.5 }}>DIRECTORY</span>
//               <span>/</span>
//               <span>OVERVIEW</span>
//             </div>
//             <h1 style={{ margin: 0, fontSize: '2.2rem', fontWeight: '800', color: '#1a202c' }}>
//               Employee <span style={{ color: '#00bcd4' }}>Performance</span> Hub
//             </h1>
//           </div>

//           {/* FULL WIDTH LIST */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {Object.entries(groupedData).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '16px',
//                   padding: '24px 30px',
//                   display: 'grid',
//                   gridTemplateColumns: '300px 1fr',
//                   alignItems: 'center',
//                   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//                 }}
//               >

//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
//                   <div style={{
//                     width: '56px', height: '56px', borderRadius: '14px',
//                     background: 'linear-gradient(135deg, #00bcd4 0%, #00838f 100%)',
//                     display: 'grid', placeItems: 'center', fontSize: '20px', color: '#fff', fontWeight: 'bold',
//                     boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)'
//                   }}>
//                     {empName.charAt(0)}
//                   </div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>{empName}</h3>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
//                       <span style={{ fontSize: '13px', color: '#718096', fontWeight: '600' }}>ID: {data.emp_id}</span>
//                       <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#cbd5e0' }}></span>
//                       <span style={{ fontSize: '13px', color: '#00bcd4', fontWeight: '700', textTransform: 'uppercase' }}>
//                         {data.years[Object.keys(data.years)[0]][0].department}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: OKR TIMELINE WRAPPER */}
//                 <div style={{ paddingLeft: '40px', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: '40px' }}>
//                   {Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                     <div key={year} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//                       {/* Year Label with vertical line */}
//                       <div style={{ borderLeft: '3px solid #edf2f7', paddingLeft: '15px' }}>
//                         <div style={{ fontSize: '12px', color: '#eef5ff', fontWeight: '800', marginBottom: '10px' }}>FY {year}</div>

//                         <div style={{ display: 'flex', gap: '10px' }}>
//                           {data.years[year].map(sub => {
//                             const isLocked = sub.workflow_status === 'Locked';
//                             const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                             return (
//                               <button
//                                 key={sub.id}
//                                 onClick={() => {
//                                   const details = typeof sub.okr_details === 'string' ? JSON.parse(sub.okr_details) : sub.okr_details;
//                                   setSelected({ ...sub, okr_details: details });
//                                 }}
//                                 style={{
//                                   background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                   border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                   color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                   padding: '8px 16px',
//                                   borderRadius: '10px',
//                                   fontSize: '12px',
//                                   fontWeight: '700',
//                                   cursor: 'pointer',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: '8px',
//                                   transition: 'all 0.2s ease'
//                                 }}
//                               >
//                                 {sub.quarter}
//                                 <span style={{ fontSize: '14px' }}>
//                                   {isLocked ? '🔒' : (isReview ? '⏳' : '→')}
//                                 </span>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );

//   };

//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>
//   );
// };

// export default ManagementOKRViewer;




















// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);

//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };

//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;
//     if (!acc[name]) acc[name] = { emp_id: sub.emp_id, years: {} };
//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);
//     return acc;
//   }, {});

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };
//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);
//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(selected.okr_details),
//           workflow_status: nextWorkflowStatus
//         })
//       });
//       const res = await response.json();
//       if (res.success) {
//         window.location.reload();
//       }
//     } catch (err) { alert("🚨 Sync failed"); }
//     finally { setIsUpdating(false); }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderOKRTrackerTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;

//     // if (selected) {
//     //   return (
//     //     <div className="okr-viewer-wrapper animate-fade">
//     //       <div className="viewer-nav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
//     //         <button className="back-action-btn" onClick={() => setSelected(null)}>← BACK TO TEAM</button>
//     //         <div style={{ display: 'flex', gap: '10px' }}>
//     //           {selected.workflow_status === 'Management_Review' && (
//     //             <button className="btn-primary" style={{ background: '#4CAF50' }} onClick={() => updateOKRStatus('Scoring')} disabled={isUpdating}>
//     //               {isUpdating ? "PROCESSING..." : "APPROVE & RETURN FOR SCORING"}
//     //             </button>
//     //           )}
//     //           {selected.workflow_status === 'Manager_Scoring_Review' && (
//     //             <button className="btn-primary" style={{ background: '#2196F3' }} onClick={() => updateOKRStatus('Sign_Off')} disabled={isUpdating}>
//     //               {isUpdating ? "SAVING..." : "FINALIZE SCORES & SEND FOR SIGN-OFF"}
//     //             </button>
//     //           )}
//     //           {selected.workflow_status === 'Locked' && (
//     //             <span className="status-pill-mini locked">VIEW ONLY (LOCKED)</span>
//     //           )}
//     //           {(selected.workflow_status === 'Scoring' || selected.workflow_status === 'Sign_Off') && (
//     //             <span className="status-pill-mini" style={{ background: 'rgba(255,152,0,0.1)', color: '#ff9800', border: '1px solid #ff9800' }}>
//     //               WAITING FOR EMPLOYEE ACTION
//     //             </span>
//     //           )}
//     //         </div>
//     //       </div>

//     //       <div className="glass-report-container">
//     //         <header className="report-header-section">
//     //           <div className="user-profile-header">
//     //             <div className="avatar-circle">{selected.emp_name?.charAt(0)}</div>
//     //             <div className="user-text">
//     //               <h2 className="emp-name-display">{selected.emp_name}</h2>
//     //               <p className="emp-meta-display">
//     //                 ID: {selected.emp_id} |
//     //                 <span className="blue-gradient-text"> {selected.quarter} {selected.year}</span> |
//     //                 <span style={{ color: '#00bcd4', marginLeft: '5px' }}>[{selected.department}]</span> |
//     //                 <span style={{ color: '#ff9800', marginLeft: '5px' }}> STAGE: {selected.workflow_status.replace(/_/g, ' ')}</span>
//     //               </p>
//     //             </div>
//     //           </div>
//     //         </header>

//     //         <div className="report-table-scroll">
//     //           <table className="sequencer-table-view">
//     //             <thead>
//     //               <tr>
//     //                 <th width="30%">OBJECTIVE</th>
//     //                 <th width="50%">KEY RESULTS</th>
//     //                 <th width="20%">SCORE</th>
//     //               </tr>
//     //             </thead>
//     //             <tbody>
//     //               {Array.isArray(selected.okr_details) && selected.okr_details.map((obj, oIdx) => (
//     //                 <React.Fragment key={oIdx}>
//     //                   {obj.keyResults?.map((kr, kIdx) => (
//     //                     <tr key={`${oIdx}-${kIdx}`} className={kIdx === 3 ? "obj-block-end" : ""}>
//     //                       {kIdx === 0 && <td rowSpan={obj.keyResults.length} className="obj-main-cell"><p className="obj-text-content">{obj.objective}</p></td>}
//     //                       <td className="kr-main-cell"><p className="kr-text-content">{kr.text}</p></td>
//     //                       <td className="center-cell">
//     //                         <select className="modern-select" value={kr.result || 'Pending'}
//     //                           disabled={selected.workflow_status !== 'Manager_Scoring_Review'}
//     //                           onChange={(e) => handleStatusChange(oIdx, kIdx, e.target.value)}>
//     //                           {resultOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
//     //                         </select>
//     //                       </td>
//     //                     </tr>
//     //                   ))}
//     //                 </React.Fragment>
//     //               ))}
//     //             </tbody>
//     //           </table>
//     //         </div>
//     //       </div>
//     //     </div>
//     //   );
//     // }

//     // if (selected) {
//     //   return (
//     //     <div className="okr-viewer-wrapper animate-fade">
//     //       {/* TOP NAVIGATION BAR */}
//     //       <div className="viewer-nav-glass">
//     //         <button className="back-action-btn" onClick={() => setSelected(null)}>
//     //           <span className="icon">←</span> BACK TO DIRECTORY
//     //         </button>

//     //         <div className="action-group">
//     //           {selected.workflow_status === 'Management_Review' && (
//     //             <button className="btn-glow-success" onClick={() => updateOKRStatus('Scoring')} disabled={isUpdating}>
//     //               {isUpdating ? "PROCESSING..." : "APPROVE FOR SCORING"}
//     //             </button>
//     //           )}
//     //           {selected.workflow_status === 'Manager_Scoring_Review' && (
//     //             <button className="btn-glow-primary" onClick={() => updateOKRStatus('Sign_Off')} disabled={isUpdating}>
//     //               {isUpdating ? "SAVING..." : "FINALIZE & SIGN-OFF"}
//     //             </button>
//     //           )}
//     //           {selected.workflow_status === 'Locked' && (
//     //             <div className="status-indicator locked">READ ONLY MODE</div>
//     //           )}

//     //           <button
//     //             className="btn-delete-okr"
//     //             onClick={handleDeleteEntireOKR}
//     //           >
//     //             DELETE OKR
//     //           </button>
//     //         </div>
//     //       </div>

//     //       {/* COMPACT PROFILE HEADER */}
//     //       <div className="report-profile-card">
//     //         <div className="profile-main">
//     //           <div className="avatar-hex">{selected.emp_name?.charAt(0)}</div>
//     //           <div className="info">
//     //             <h2 className="name">{selected.emp_name}</h2>
//     //             <div className="meta-pills">
//     //               <span className="pill">ID: {selected.emp_id}</span>
//     //               <span className="pill cyan">{selected.quarter} {selected.year}</span>
//     //               <span className="pill department">{selected.department}</span>
//     //             </div>
//     //           </div>
//     //         </div>
//     //         <div className="status-badge-container">
//     //           <label>CURRENT STAGE</label>
//     //           <div className="status-text">{selected.workflow_status.replace(/_/g, ' ')}</div>
//     //         </div>
//     //       </div>

//     //       {/* OBJECTIVE STREAM (No Table) */}
//     //       <div className="objective-stream">
//     //         {Array.isArray(selected.okr_details) &&
//     //           selected.okr_details.map((obj, oIdx) => (

//     //             <div key={oIdx} className="objective-card">

//     //               {/* 🔷 OBJECTIVE HEADER */}
//     //               <div className="obj-header">
//     //                 <div className="obj-number">0{oIdx + 1}</div>
//     //                 <h3 className="obj-title">{obj.objective}</h3>
//     //               </div>

//     //               {/* 🔷 KEY RESULTS LIST */}
//     //               <div className="kr-list">
//     //                 {obj.keyResults?.map((kr, kIdx) => {

//     //                   const isLocked = selected.workflow_status === 'Locked';
//     //                   const isScoreEditable = selected.workflow_status === 'Manager_Scoring_Review';

//     //                   return (
//     //                     <div key={`${oIdx}-${kIdx}`} className="kr-row">

//     //                       {/* 🔢 KR NUMBER */}
//     //                       <div className="kr-index">
//     //                         {kIdx + 1}
//     //                       </div>

//     //                       {/* 📝 KR TEXT (EDITABLE) */}
//     //                       <textarea
//     //                         value={kr.text}
//     //                         disabled={isLocked}
//     //                         onChange={(e) =>
//     //                           handleKRTextChange(oIdx, kIdx, e.target.value)
//     //                         }
//     //                         className="kr-textarea"
//     //                         rows={2}
//     //                       />

//     //                       {/* 🎯 SCORE */}
//     //                       <div className="kr-score-zone">
//     //                         <label>SCORE</label>
//     //                         <select
//     //                           className="minimal-select"
//     //                           value={kr.result || 'Pending'}
//     //                           disabled={!isScoreEditable}
//     //                           onChange={(e) =>
//     //                             handleStatusChange(oIdx, kIdx, e.target.value)
//     //                           }
//     //                         >
//     //                           {resultOptions.map((opt) => (
//     //                             <option key={opt} value={opt}>
//     //                               {opt}
//     //                             </option>
//     //                           ))}
//     //                         </select>
//     //                       </div>

//     //                       {/* ❌ DELETE BUTTON */}
//     //                       <button
//     //                         className="kr-delete-btn"
//     //                         disabled={isLocked}
//     //                         onClick={() => handleDeleteKR(oIdx, kIdx)}
//     //                         title="Delete Key Result"
//     //                       >
//     //                         🗑
//     //                       </button>

//     //                     </div>
//     //                   );
//     //                 })}
//     //               </div>

//     //             </div>
//     //           ))}
//     //       </div>
//     //     </div>
//     //   );
//     // }


//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>
//             <div className="profile-pill">
//               <div className="p-avatar">{selected.emp_name?.charAt(0)}</div>
//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">{selected.workflow_status.replace(/_/g, ' ')}</span>
//               </div>
//             </div>
//             <div className="nav-actions">

//               {/* ✅ STEP 1: APPROVE (Management → Scoring) */}
//               {selected.workflow_status === 'Management_Review' && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus('Scoring')}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "PROCESSING..." : "APPROVE"}
//                 </button>
//               )}

//               {/* ✅ STEP 2: FINALIZE (Manager Review → Sign Off) */}
//               {selected.workflow_status === 'Manager_Scoring_Review' && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus('Sign_Off')}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {/* ✅ STEP 3: LOCKED STATE */}
//               {selected.workflow_status === 'Locked' && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               {/* ❌ DELETE (UNCHANGED) */}
//               <button
//                 className="btn-delete-minimal"
//                 onClick={handleDeleteEntireOKR}
//               >
//                 🗑
//               </button>

//             </div>

//           </div>

//           {/* OBJECTIVE VERTICAL LIST */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div key={oIdx} className={`obj-reveal-group ${isExpanded ? 'is-active' : ''}`}>

//                     {/* 🔷 OBJECTIVE HEADER (CLICKABLE) */}
//                     <div
//                       className="obj-header-row"
//                       onClick={() => setActiveObjective(isExpanded ? null : oIdx)}
//                     >
//                       <div className="obj-hex-id">0{oIdx + 1}</div>
//                       <div className="obj-text-content">
//                         <label>OBJECTIVE</label>
//                         <h3>{obj.objective}</h3>
//                       </div>
//                       <div className={`obj-status-indicator ${isExpanded ? 'open' : ''}`}>
//                         {isExpanded ? 'CLOSE' : 'REVEAL RESULTS'}
//                       </div>
//                     </div>

//                     {/* 🔷 KEY RESULTS - LINE BY LINE */}
//                     {/* 🔷 KEY RESULTS - LINE BY LINE */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked = selected.workflow_status === 'Locked';
//                         const isScoreEditable = selected.workflow_status === 'Manager_Scoring_Review';

//                         return (
//                           <div key={`${oIdx}-${kIdx}`} className="kr-line-item">
//                             <div className="kr-body-wrap">
//                               {/* Custom numbering format: 1) */}
//                               <span className="kr-index-inline">{kIdx + 1})</span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) => handleKRTextChange(oIdx, kIdx, e.target.value)}
//                                   className="kr-text-minimal"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) => {
//                                     // Automatically adjusts height to fit content exactly
//                                     e.target.style.height = 'inherit';
//                                     e.target.style.height = `${e.target.scrollHeight}px`;
//                                   }}
//                                   ref={(el) => {
//                                     // This ensures it starts at the right height on load
//                                     if (el) {
//                                       el.style.height = 'inherit';
//                                       el.style.height = `${el.scrollHeight}px`;
//                                     }
//                                   }}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || 'Pending'}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) => handleStatusChange(oIdx, kIdx, e.target.value)}
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>{opt}</option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => { e.stopPropagation(); handleDeleteKR(oIdx, kIdx); }}
//                               >🗑</button>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>

//                   </div>
//                 );
//               })}
//           </div>
//         </div>
//       );
//     }




//     // return (
//     //   <div className="okr-genesis-container animate-fade">
//     //     <div className="okr-glass-card">
//     //       <div className="list-header" style={{ marginBottom: '30px', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '15px' }}>
//     //         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>OKR <span className="blue-gradient-text">Management</span></h2>
//     //       </div>

//     //       <div className="directory-grid" style={{ display: 'grid', gap: '20px' }}>
//     //         {Object.entries(groupedData).map(([empName, data]) => (
//     //           <div key={empName} className="employee-card" style={{
//     //             background: 'rgba(255,255,255,0.03)',
//     //             borderRadius: '12px',
//     //             border: '1px solid rgba(255,255,255,0.08)',
//     //             padding: '20px'
//     //           }}>
//     //             <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px', borderBottom: '1px solid rgba(255,255,255,0.03)', paddingBottom: '10px' }}>
//     //               <div className="avatar-circle" style={{ width: '40px', height: '40px', fontSize: '16px' }}>{empName.charAt(0)}</div>
//     //               <div>
//     //                 <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#00bcd4' }}>{empName}</h3>
//     //                 <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
//     //                   <p style={{ margin: 0, fontSize: '10px', opacity: 0.4 }}>ID: {data.emp_id}</p>
//     //                   <span style={{fontSize: '9px', background: 'rgba(0,188,212,0.1)', color: '#00bcd4', padding: '1px 5px', borderRadius: '3px'}}>
//     //                       {data.years[Object.keys(data.years)[0]][0].department}
//     //                   </span>
//     //                 </div>
//     //               </div>
//     //             </div>

//     //             <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//     //               {Object.keys(data.years).sort((a,b) => b-a).map(year => (
//     //                 <div key={year} style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
//     //                   <div style={{ minWidth: '70px', fontSize: '14px', fontWeight: 'bold', color: '#fff', paddingTop: '8px' }}>{year}</div>
//     //                   <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
//     //                     {data.years[year].map(sub => (
//     //                       <button 
//     //                         key={sub.id} 
//     //                         onClick={() => {
//     //                           const details = typeof sub.okr_details === 'string' ? JSON.parse(sub.okr_details) : sub.okr_details;
//     //                           setSelected({...sub, okr_details: details});
//     //                         }}
//     //                         className="btn-view-sequence"
//     //                         style={{
//     //                           background: sub.workflow_status === 'Locked' ? 'rgba(255,255,255,0.03)' : 'rgba(0,188,212,0.1)',
//     //                           border: sub.workflow_status === 'Locked' ? '1px solid #444' : (['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status) ? '1px solid #ff9800' : '1px solid #00bcd4'),
//     //                           color: sub.workflow_status === 'Locked' ? '#666' : '#00bcd4',
//     //                           borderRadius: '4px',
//     //                           padding: '8px 15px',
//     //                           fontSize: '11px',
//     //                           cursor: 'pointer',
//     //                           display: 'flex',
//     //                           alignItems: 'center',
//     //                           gap: '6px'
//     //                         }}
//     //                       >
//     //                         {sub.quarter} {sub.workflow_status === 'Locked' ? '🔒' : (['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status) ? '🔔' : '●')}
//     //                       </button>
//     //                     ))}
//     //                   </div>
//     //                 </div>
//     //               ))}
//     //             </div>
//     //           </div>
//     //         ))}
//     //       </div>
//     //     </div>
//     //   </div>


//     // );

//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0', // Centered padding for the content
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div style={{ marginBottom: '40px' }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#00bcd4', fontSize: '12px', fontWeight: 'bold', letterSpacing: '1px', marginBottom: '8px' }}>
//               <span style={{ opacity: 0.5 }}>DIRECTORY</span>
//               <span>/</span>
//               <span>OVERVIEW</span>
//             </div>
//             <h1 style={{ margin: 0, fontSize: '2.2rem', fontWeight: '800', color: '#1a202c' }}>
//               Employee <span style={{ color: '#00bcd4' }}>Performance</span> Hub
//             </h1>
//           </div>

//           {/* FULL WIDTH LIST */}
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {Object.entries(groupedData).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '16px',
//                   padding: '24px 30px',
//                   display: 'grid',
//                   gridTemplateColumns: '300px 1fr',
//                   alignItems: 'center',
//                   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//                 }}
//               >

//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
//                   <div style={{
//                     width: '56px', height: '56px', borderRadius: '14px',
//                     background: 'linear-gradient(135deg, #00bcd4 0%, #00838f 100%)',
//                     display: 'grid', placeItems: 'center', fontSize: '20px', color: '#fff', fontWeight: 'bold',
//                     boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)'
//                   }}>
//                     {empName.charAt(0)}
//                   </div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>{empName}</h3>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
//                       <span style={{ fontSize: '13px', color: '#718096', fontWeight: '600' }}>ID: {data.emp_id}</span>
//                       <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#cbd5e0' }}></span>
//                       <span style={{ fontSize: '13px', color: '#00bcd4', fontWeight: '700', textTransform: 'uppercase' }}>
//                         {data.years[Object.keys(data.years)[0]][0].department}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: OKR TIMELINE WRAPPER */}
//                 <div style={{ paddingLeft: '40px', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: '40px' }}>
//                   {Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                     <div key={year} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//                       {/* Year Label with vertical line */}
//                       <div style={{ borderLeft: '3px solid #edf2f7', paddingLeft: '15px' }}>
//                         <div style={{ fontSize: '12px', color: '#eef5ff', fontWeight: '800', marginBottom: '10px' }}>FY {year}</div>

//                         <div style={{ display: 'flex', gap: '10px' }}>
//                           {data.years[year].map(sub => {
//                             const isLocked = sub.workflow_status === 'Locked';
//                             const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                             return (
//                               <button
//                                 key={sub.id}
//                                 onClick={() => {
//                                   const details = typeof sub.okr_details === 'string' ? JSON.parse(sub.okr_details) : sub.okr_details;
//                                   setSelected({ ...sub, okr_details: details });
//                                 }}
//                                 style={{
//                                   background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                   border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                   color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                   padding: '8px 16px',
//                                   borderRadius: '10px',
//                                   fontSize: '12px',
//                                   fontWeight: '700',
//                                   cursor: 'pointer',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: '8px',
//                                   transition: 'all 0.2s ease'
//                                 }}
//                               >
//                                 {sub.quarter}
//                                 <span style={{ fontSize: '14px' }}>
//                                   {isLocked ? '🔒' : (isReview ? '⏳' : '→')}
//                                 </span>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );

//   };

//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>
//   );
// };

// export default ManagementOKRViewer;


























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };

//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.ProfilePicture   // ✅ ADD THIS
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };
//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);
//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(selected.okr_details),
//           workflow_status: nextWorkflowStatus
//         })
//       });
//       const res = await response.json();
//       if (res.success) {
//         window.location.reload();
//       }
//     } catch (err) { alert("🚨 Sync failed"); }
//     finally { setIsUpdating(false); }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderOKRTrackerTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)", // orange

//       "linear-gradient(to right, #16a34a, #22c55e)", // green
//       // purple
//       "linear-gradient(to right, #dc2626, #ef4444)"  // red
//     ];
//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;

//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );

//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>
//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.ProfilePicture ? (
//                   <img
//                     src={selected.ProfilePicture}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.ProfilePicture)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>
//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">{selected.workflow_status.replace(/_/g, ' ')}</span>
//               </div>
//             </div>
//             <div className="nav-actions">

//               {/* ✅ STEP 1: APPROVE (Management → Scoring) */}
//               {selected.workflow_status === 'Management_Review' && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus('Scoring')}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "PROCESSING..." : "APPROVE"}
//                 </button>
//               )}

//               {/* ✅ STEP 2: FINALIZE (Manager Review → Sign Off) */}
//               {selected.workflow_status === 'Manager_Scoring_Review' && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus('Sign_Off')}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {/* ✅ STEP 3: LOCKED STATE */}
//               {selected.workflow_status === 'Locked' && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               {/* ❌ DELETE (UNCHANGED) */}
//               <button
//                 className="btn-delete-minimal"
//                 onClick={handleDeleteEntireOKR}
//               >
//                 🗑
//               </button>

//             </div>

//           </div>

//           {/* OBJECTIVE VERTICAL LIST */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div key={oIdx} className={`obj-reveal-group ${isExpanded ? 'is-active' : ''}`}>

//                     {/* 🔷 OBJECTIVE HEADER (CLICKABLE) */}
//                     <div
//                       className="obj-header-row"
//                       onClick={() => setActiveObjective(isExpanded ? null : oIdx)}
//                     >
//                       {/* <div className="obj-hex-id">0{oIdx + 1}</div> */}
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>

//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background: flagColors[oIdx % flagColors.length]
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, '0')}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         {/* <label>OBJECTIVE</label>
//                         <h3>{obj.objective}</h3> */}
//                         <h3 className="objective-title">{obj.objective}</h3>
//                       </div>
//                       <div className={`obj-status-indicator ${isExpanded ? 'open' : ''}`}>
//                         {isExpanded ? 'CLOSE' : 'CLICK TO REVEAL RESULTS'}
//                       </div>
//                     </div>

//                     {/* 🔷 KEY RESULTS - LINE BY LINE */}
//                     {/* 🔷 KEY RESULTS - LINE BY LINE */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked = selected.workflow_status === 'Locked';
//                         const isScoreEditable = selected.workflow_status === 'Manager_Scoring_Review';

//                         return (
//                           <div key={`${oIdx}-${kIdx}`} className="kr-line-item">
//                             <div className="kr-body-wrap">
//                               {/* Custom numbering format: 1) */}
//                               <span className="kr-index-inline">{kIdx + 1})</span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) => handleKRTextChange(oIdx, kIdx, e.target.value)}
//                                   className="kr-text-minimal"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) => {
//                                     // Automatically adjusts height to fit content exactly
//                                     e.target.style.height = 'inherit';
//                                     e.target.style.height = `${e.target.scrollHeight}px`;
//                                   }}
//                                   ref={(el) => {
//                                     // This ensures it starts at the right height on load
//                                     if (el) {
//                                       el.style.height = 'inherit';
//                                       el.style.height = `${el.scrollHeight}px`;
//                                     }
//                                   }}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || 'Pending'}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) => handleStatusChange(oIdx, kIdx, e.target.value)}
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>{opt}</option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => { e.stopPropagation(); handleDeleteKR(oIdx, kIdx); }}
//                               >🗑</button>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>

//                   </div>
//                 );
//               })}
//           </div>
//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}

//         </div>

//       );

//     }

//     const filteredSubmitted = Object.entries(groupedData).filter(([empName, data]) => {
//       const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//       const dept = data?.years
//         ? data.years[Object.keys(data.years)[0]][0].department
//         : "";

//       const matchesDept = selectedDept ? dept === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });

//     const filteredMissing = missingEmployees.filter(emp => {
//       const matchesSearch = emp.full_name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesDept = selectedDept ? emp.team === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });






//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0', // Centered padding for the content
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* 🔍 SEARCH + FILTER BAR */}
//           <div style={{
//             display: 'flex',
//             gap: '15px',
//             marginBottom: '12px',
//             flexWrap: 'wrap'
//           }}>
//             {/* Search */}
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '10px 14px',
//                 borderRadius: '8px',
//                 border: '1px solid #ccc',
//                 minWidth: '250px'
//               }}
//             />

//             {/* Department Filter */}
//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//             >
//               <option value="">All Departments</option>

//               {[...new Set(
//                 submissions.map(sub => sub.department)
//               )].map((dept, idx) => (
//                 <option key={idx} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div className="hub-header-compact">
//             <div className="breadcrumb-mini">
//               {/* <span>DIRECTORY</span> / <span>OVERVIEW</span> */}
//             </div>

//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* FULL WIDTH LIST */}

//           {/* 🔘 SUBMITTED / MISSING TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "submitted" ? "2px solid #00bcd4" : "1px solid #ccc",
//                 background: viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "missing" ? "2px solid #ff4d4f" : "1px solid #ccc",
//                 background: viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map(emp => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '16px',
//                   padding: '14px 18px',

//                   display: 'grid',
//                   gridTemplateColumns: '240px 1fr',
//                   alignItems: 'center',
//                   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//                 }}
//               >

//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
//                   <div className="emp-avatar clickable-avatar">
//                     {data.profile_image || data.ProfilePicture ? (
//                       <img
//                         src={data.profile_image || data.ProfilePicture}
//                         alt={empName}
//                         onClick={() =>
//                           setPreviewImage(data.profile_image || data.ProfilePicture)
//                         }
//                       />
//                     ) : (
//                       <span>{empName.charAt(0)}</span>
//                     )}
//                   </div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>{empName}</h3>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
//                       <span style={{ fontSize: '12px', color: '#718096', fontWeight: '600' }}>ID: {data.emp_id}</span>
//                       <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#cbd5e0' }}></span>
//                       <span style={{ fontSize: '13px', color: '#00bcd4', fontWeight: '700', textTransform: 'uppercase' }}>
//                         {data?.years
//                           ? data.years[Object.keys(data.years)[0]][0].department
//                           : (data.team || "No Submission")}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: OKR TIMELINE WRAPPER */}
//                 <div style={{ paddingLeft: '40px', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: '40px' }}>

//                   {data?.years ? (
//                     Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                       <div key={year} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

//                         <div style={{ borderLeft: '3px solid #edf2f7', paddingLeft: '15px' }}>

//                           <div style={{ fontSize: '12px', color: '#eef5ff', fontWeight: '800', marginBottom: '10px' }}>
//                             FY {year}
//                           </div>

//                           <div style={{ display: 'flex', gap: '10px' }}>
//                             {data.years[year].map(sub => {
//                               const isLocked = sub.workflow_status === 'Locked';
//                               const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                               return (
//                                 <button
//                                   key={sub.id}
//                                   onClick={() => {
//                                     const details = typeof sub.okr_details === 'string'
//                                       ? JSON.parse(sub.okr_details)
//                                       : sub.okr_details;
//                                     setSelected({ ...sub, okr_details: details });
//                                   }}
//                                   style={{
//                                     background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                     border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                     color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                     padding: '8px 16px',
//                                     borderRadius: '10px',
//                                     fontSize: '12px',
//                                     fontWeight: '700',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '8px'
//                                   }}
//                                 >
//                                   {sub.quarter}
//                                   <span>{isLocked ? '🔒' : (isReview ? '⏳' : '→')}</span>
//                                 </button>
//                               );
//                             })}
//                           </div>

//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{
//                       color: '#ff4d4f',
//                       fontWeight: '700',
//                       fontSize: '13px'
//                     }}>
//                       Not Submitted
//                     </div>
//                   )}

//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>

//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}

//       </div>
//     );



//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [activeAR, setActiveAR] = useState(null);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };

//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.ProfilePicture   // ✅ ADD THIS
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);

//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     const cleanedOKR = selected.okr_details.map(obj => ({
//       ...obj,
//       keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//           delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//         }

//         return newKR;
//       })
//     }));

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(cleanedOKR),
//           workflow_status: nextWorkflowStatus
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         setSelected(prev => ({
//           ...prev,
//           okr_details: cleanedOKR,
//           workflow_status: nextWorkflowStatus
//         }));
//         window.location.reload();
//       }
//     } catch (err) {
//       alert("🚨 Sync failed");
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderOKRTrackerTab = () => {


//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)", // orange

//       "linear-gradient(to right, #16a34a, #22c55e)", // green
//       // purple
//       "linear-gradient(to right, #dc2626, #ef4444)"  // red
//     ];
//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;

//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };


//     const autoResize = (el) => {
//       if (!el) return;
//       el.style.height = 'auto';
//       el.style.height = `${el.scrollHeight}px`;
//     };
//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );
//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>

//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.ProfilePicture ? (
//                   <img
//                     src={selected.ProfilePicture}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.ProfilePicture)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>

//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">
//                   {selected.workflow_status.replace(/_/g, " ")}
//                 </span>
//               </div>
//             </div>

//             <div className="nav-actions">

//               {selected.workflow_status === "Management_Review" && (
//                 <>
//                   <button
//                     className="btn-approve-cyan"
//                     onClick={() => updateOKRStatus("Scoring")}
//                     disabled={isUpdating}
//                   >
//                     {isUpdating ? "PROCESSING..." : "APPROVE"}
//                   </button>

//                   <button
//                     className="btn-warning"
//                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                     disabled={isUpdating}
//                     style={{
//                       marginLeft: "10px",
//                       background: "#ff9800",
//                       color: "#000",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                   </button>
//                 </>
//               )}

//               {selected.workflow_status === "Manager_Scoring_Review" && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus("Sign_Off")}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {selected.workflow_status === "Locked" && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               <button className="btn-delete-minimal" onClick={handleDeleteEntireOKR}>
//                 🗑
//               </button>
//             </div>
//           </div>

//           {/* OBJECTIVES */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div
//                     key={oIdx}
//                     className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                   >
//                     <div
//                       className="obj-header-row"
//                       onClick={() =>
//                         setActiveObjective(isExpanded ? null : oIdx)
//                       }
//                     >
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>
//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background:
//                               flagColors[oIdx % flagColors.length],
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, "0")}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         <h3 className="objective-title">
//                           {obj.objective}
//                         </h3>
//                       </div>

//                       <div
//                         className={`obj-status-indicator ${isExpanded ? "open" : ""
//                           }`}
//                       >
//                         {isExpanded
//                           ? "CLOSE"
//                           : "CLICK TO REVEAL RESULTS"}
//                       </div>
//                     </div>

//                     {/* KEY RESULTS */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked =
//                           selected.workflow_status === "Locked";
//                         const isScoreEditable =
//                           selected.workflow_status ===
//                           "Manager_Scoring_Review";

//                         return (
//                           <div
//                             key={`${oIdx}-${kIdx}`}
//                             className={`kr-line-item ${kr.ar_comment && kr.ar_comment.trim()
//                                 ? "has-ar"
//                                 : ""
//                               }`}
//                           >
//                             <div className="kr-body-wrap">
//                               <span className="kr-index-inline">
//                                 {kIdx + 1})
//                               </span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) =>
//                                     handleKRTextChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                   className="kr-text-minimal auto-expand"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) =>
//                                     autoResize(e.target)
//                                   }
//                                   ref={(el) => el && autoResize(el)}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || "Pending"}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) =>
//                                     handleStatusChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>

//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleDeleteKR(oIdx, kIdx);
//                                 }}
//                               >
//                                 🗑
//                               </button>
//                             </div>

//                             {/* ✏️ AR BUTTON */}
//                             {selected.workflow_status ===
//                               "Management_Review" && (
//                                 <div style={{ marginTop: "8px" }}>
//                                   {activeAR !== `${oIdx}-${kIdx}` ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         setActiveAR(`${oIdx}-${kIdx}`)
//                                       }
//                                       style={{
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         color: "#ff9800",
//                                         fontSize: "13px",
//                                         fontWeight: "600",
//                                       }}
//                                     >
//                                       {kr.ar_comment
//                                         ? "✏️ Edit AR"
//                                         : "✏️ Add AR"}
//                                     </button>
//                                   ) : (
//                                     <textarea
//                                       value={kr.ar_comment || ""}
//                                       onChange={(e) => {
//                                         const updated = {
//                                           ...selected,
//                                         };
//                                         updated.okr_details[oIdx].keyResults[
//                                           kIdx
//                                         ].ar_comment =
//                                           e.target.value;
//                                         setSelected(updated);
//                                       }}
//                                       rows={2}
//                                       autoFocus
//                                       onBlur={() => setActiveAR(null)}
//                                       style={{
//                                         width: "100%",
//                                         marginTop: "6px",
//                                         padding: "8px",
//                                         borderRadius: "6px",
//                                         border: "1px solid #ff9800",
//                                         background:
//                                           "rgba(255,152,0,0.05)",
//                                         fontSize: "13px",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                               )}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }
//     const filteredSubmitted = Object.entries(groupedData).filter(([empName, data]) => {
//       const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//       const dept = data?.years
//         ? data.years[Object.keys(data.years)[0]][0].department
//         : "";

//       const matchesDept = selectedDept ? dept === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });

//     const filteredMissing = missingEmployees.filter(emp => {
//       const matchesSearch = emp.full_name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesDept = selectedDept ? emp.team === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });






//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0', // Centered padding for the content
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* 🔍 SEARCH + FILTER BAR */}
//           <div style={{
//             display: 'flex',
//             gap: '15px',
//             marginBottom: '12px',
//             flexWrap: 'wrap'
//           }}>
//             {/* Search */}
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '10px 14px',
//                 borderRadius: '8px',
//                 border: '1px solid #ccc',
//                 minWidth: '250px'
//               }}
//             />

//             {/* Department Filter */}
//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//             >
//               <option value="">All Departments</option>

//               {[...new Set(
//                 submissions.map(sub => sub.department)
//               )].map((dept, idx) => (
//                 <option key={idx} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div className="hub-header-compact">
//             <div className="breadcrumb-mini">
//               {/* <span>DIRECTORY</span> / <span>OVERVIEW</span> */}
//             </div>

//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* FULL WIDTH LIST */}

//           {/* 🔘 SUBMITTED / MISSING TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "submitted" ? "2px solid #00bcd4" : "1px solid #ccc",
//                 background: viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "missing" ? "2px solid #ff4d4f" : "1px solid #ccc",
//                 background: viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map(emp => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '16px',
//                   padding: '14px 18px',

//                   display: 'grid',
//                   gridTemplateColumns: '240px 1fr',
//                   alignItems: 'center',
//                   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//                 }}
//               >

//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
//                   <div className="emp-avatar clickable-avatar">
//                     {data.profile_image || data.ProfilePicture ? (
//                       <img
//                         src={data.profile_image || data.ProfilePicture}
//                         alt={empName}
//                         onClick={() =>
//                           setPreviewImage(data.profile_image || data.ProfilePicture)
//                         }
//                       />
//                     ) : (
//                       <span>{empName.charAt(0)}</span>
//                     )}
//                   </div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>{empName}</h3>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
//                       <span style={{ fontSize: '12px', color: '#718096', fontWeight: '600' }}>ID: {data.emp_id}</span>
//                       <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#cbd5e0' }}></span>
//                       <span style={{ fontSize: '13px', color: '#00bcd4', fontWeight: '700', textTransform: 'uppercase' }}>
//                         {data?.years
//                           ? data.years[Object.keys(data.years)[0]][0].department
//                           : (data.team || "No Submission")}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: OKR TIMELINE WRAPPER */}
//                 <div style={{ paddingLeft: '40px', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: '40px' }}>

//                   {data?.years ? (
//                     Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                       <div key={year} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

//                         <div style={{ borderLeft: '3px solid #edf2f7', paddingLeft: '15px' }}>

//                           <div style={{ fontSize: '12px', color: '#eef5ff', fontWeight: '800', marginBottom: '10px' }}>
//                             FY {year}
//                           </div>

//                           <div style={{ display: 'flex', gap: '10px' }}>
//                             {data.years[year].map(sub => {
//                               const isLocked = sub.workflow_status === 'Locked';
//                               const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                               return (
//                                 <button
//                                   key={sub.id}
//                                   onClick={() => {
//                                     const details = typeof sub.okr_details === 'string'
//                                       ? JSON.parse(sub.okr_details)
//                                       : sub.okr_details;
//                                     setSelected({ ...sub, okr_details: details });
//                                   }}
//                                   style={{
//                                     background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                     border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                     color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                     padding: '8px 16px',
//                                     borderRadius: '10px',
//                                     fontSize: '12px',
//                                     fontWeight: '700',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '8px'
//                                   }}
//                                 >
//                                   {sub.quarter}
//                                   <span>{isLocked ? '🔒' : (isReview ? '⏳' : '→')}</span>
//                                 </button>
//                               );
//                             })}
//                           </div>

//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{
//                       color: '#ff4d4f',
//                       fontWeight: '700',
//                       fontSize: '13px'
//                     }}>
//                       Not Submitted
//                     </div>
//                   )}

//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>

//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}

//       </div>
//     );



//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;


























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [activeAR, setActiveAR] = useState(null);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//         console.log("OKR DATA:", okrData.data);
//         console.log("FIRST SUBMISSION:", okrData.data[0]);

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };




//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.profile_image
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);

//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     const cleanedOKR = selected.okr_details.map(obj => ({
//       ...obj,
//       keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//           delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//         }

//         return newKR;
//       })
//     }));

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(cleanedOKR),
//           workflow_status: nextWorkflowStatus
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         setSelected(prev => ({
//           ...prev,
//           okr_details: cleanedOKR,
//           workflow_status: nextWorkflowStatus
//         }));
//         window.location.reload();
//       }
//     } catch (err) {
//       alert("🚨 Sync failed");
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderOKRTrackerTab = () => {


//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)", // orange

//       "linear-gradient(to right, #16a34a, #22c55e)", // green
//       // purple
//       "linear-gradient(to right, #dc2626, #ef4444)"  // red
//     ];
//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;

//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };


//     const autoResize = (el) => {
//       if (!el) return;
//       el.style.height = 'auto';
//       el.style.height = `${el.scrollHeight}px`;
//     };
//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );
//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>

//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.profile_image ? (
//                   <img
//                     src={selected.profile_image}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.profile_image)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>

//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">
//                   {selected.workflow_status.replace(/_/g, " ")}
//                 </span>
//               </div>
//             </div>

//             <div className="nav-actions">

//               {selected.workflow_status === "Management_Review" && (
//                 <>
//                   <button
//                     className="btn-approve-cyan"
//                     onClick={() => updateOKRStatus("Scoring")}
//                     disabled={isUpdating}
//                   >
//                     {isUpdating ? "PROCESSING..." : "APPROVE"}
//                   </button>

//                   <button
//                     className="btn-warning"
//                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                     disabled={isUpdating}
//                     style={{
//                       marginLeft: "10px",
//                       background: "#ff9800",
//                       color: "#000",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                   </button>
//                 </>
//               )}

//               {selected.workflow_status === "Manager_Scoring_Review" && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus("Sign_Off")}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {selected.workflow_status === "Locked" && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               <button className="btn-delete-minimal" onClick={handleDeleteEntireOKR}>
//                 🗑
//               </button>
//             </div>
//           </div>

//           {/* OBJECTIVES */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div
//                     key={oIdx}
//                     className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                   >
//                     <div
//                       className="obj-header-row"
//                       onClick={() =>
//                         setActiveObjective(isExpanded ? null : oIdx)
//                       }
//                     >
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>
//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background:
//                               flagColors[oIdx % flagColors.length],
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, "0")}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         <h3 className="objective-title">
//                           {obj.objective}
//                         </h3>
//                       </div>

//                       <div
//                         className={`obj-status-indicator ${isExpanded ? "open" : ""
//                           }`}
//                       >
//                         {isExpanded
//                           ? "CLOSE"
//                           : "CLICK TO REVEAL RESULTS"}
//                       </div>
//                     </div>

//                     {/* KEY RESULTS */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked =
//                           selected.workflow_status === "Locked";
//                         const isScoreEditable =
//                           selected.workflow_status ===
//                           "Manager_Scoring_Review";

//                         return (
//                           <div
//                             key={`${oIdx}-${kIdx}`}
//                             className={`kr-line-item ${kr.ar_comment && kr.ar_comment.trim()
//                               ? "has-ar"
//                               : ""
//                               }`}
//                           >
//                             <div className="kr-body-wrap">
//                               <span className="kr-index-inline">
//                                 {kIdx + 1})
//                               </span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) =>
//                                     handleKRTextChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                   className="kr-text-minimal auto-expand"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) =>
//                                     autoResize(e.target)
//                                   }
//                                   ref={(el) => el && autoResize(el)}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || "Pending"}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) =>
//                                     handleStatusChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>

//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleDeleteKR(oIdx, kIdx);
//                                 }}
//                               >
//                                 🗑
//                               </button>
//                             </div>

//                             {/* ✏️ AR BUTTON */}
//                             {selected.workflow_status ===
//                               "Management_Review" && (
//                                 <div style={{ marginTop: "8px" }}>
//                                   {activeAR !== `${oIdx}-${kIdx}` ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         setActiveAR(`${oIdx}-${kIdx}`)
//                                       }
//                                       style={{
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         color: "#ff9800",
//                                         fontSize: "13px",
//                                         fontWeight: "600",
//                                       }}
//                                     >
//                                       {kr.ar_comment
//                                         ? "✏️ Edit AR"
//                                         : "✏️ Add AR"}
//                                     </button>
//                                   ) : (
//                                     <textarea
//                                       value={kr.ar_comment || ""}
//                                       onChange={(e) => {
//                                         const updated = {
//                                           ...selected,
//                                         };
//                                         updated.okr_details[oIdx].keyResults[
//                                           kIdx
//                                         ].ar_comment =
//                                           e.target.value;
//                                         setSelected(updated);
//                                       }}
//                                       rows={2}
//                                       autoFocus
//                                       onBlur={() => setActiveAR(null)}
//                                       style={{
//                                         width: "100%",
//                                         marginTop: "6px",
//                                         padding: "8px",
//                                         borderRadius: "6px",
//                                         border: "1px solid #ff9800",
//                                         background:
//                                           "rgba(255,152,0,0.05)",
//                                         fontSize: "13px",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                               )}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }
//     const filteredSubmitted = Object.entries(groupedData).filter(([empName, data]) => {
//       const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//       const dept = data?.years
//         ? data.years[Object.keys(data.years)[0]][0].department
//         : "";

//       const matchesDept = selectedDept ? dept === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });

//     const filteredMissing = missingEmployees.filter(emp => {
//       const matchesSearch = emp.full_name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesDept = selectedDept ? emp.team === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });






//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0', // Centered padding for the content
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* 🔍 SEARCH + FILTER BAR */}
//           <div style={{
//             display: 'flex',
//             gap: '15px',
//             marginBottom: '12px',
//             flexWrap: 'wrap'
//           }}>
//             {/* Search */}
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '10px 14px',
//                 borderRadius: '8px',
//                 border: '1px solid #ccc',
//                 minWidth: '250px'
//               }}
//             />

//             {/* Department Filter */}
//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//             >
//               <option value="">All Departments</option>

//               {[...new Set(
//                 submissions.map(sub => sub.department)
//               )].map((dept, idx) => (
//                 <option key={idx} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div className="hub-header-compact">
//             <div className="breadcrumb-mini">
//               {/* <span>DIRECTORY</span> / <span>OVERVIEW</span> */}
//             </div>

//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* FULL WIDTH LIST */}

//           {/* 🔘 SUBMITTED / MISSING TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "submitted" ? "2px solid #00bcd4" : "1px solid #ccc",
//                 background: viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "missing" ? "2px solid #ff4d4f" : "1px solid #ccc",
//                 background: viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map(emp => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '16px',
//                   padding: '14px 18px',

//                   display: 'grid',
//                   gridTemplateColumns: '240px 1fr',
//                   alignItems: 'center',
//                   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//                 }}
//               >

//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
//                   <div className="emp-avatar clickable-avatar">
//                     {data.profile_image ? (
//                       <img
//                         src={data.profile_image}
//                         alt={empName}
//                         onClick={() => setPreviewImage(data.profile_image)}
//                       />
//                     ) : (
//                       <span>{empName.charAt(0)}</span>
//                     )}
//                   </div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>{empName}</h3>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
//                       <span style={{ fontSize: '12px', color: '#718096', fontWeight: '600' }}>ID: {data.emp_id}</span>
//                       <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#cbd5e0' }}></span>
//                       <span style={{ fontSize: '13px', color: '#00bcd4', fontWeight: '700', textTransform: 'uppercase' }}>
//                         {data?.years
//                           ? data.years[Object.keys(data.years)[0]][0].department
//                           : (data.team || "No Submission")}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: OKR TIMELINE WRAPPER */}
//                 <div style={{ paddingLeft: '40px', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: '40px' }}>

//                   {data?.years ? (
//                     Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                       <div key={year} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

//                         <div style={{ borderLeft: '3px solid #edf2f7', paddingLeft: '15px' }}>

//                           <div style={{ fontSize: '12px', color: '#eef5ff', fontWeight: '800', marginBottom: '10px' }}>
//                             FY {year}
//                           </div>

//                           <div style={{ display: 'flex', gap: '10px' }}>
//                             {data.years[year].map(sub => {
//                               const isLocked = sub.workflow_status === 'Locked';
//                               const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                               return (
//                                 <button
//                                   key={sub.id}
//                                   onClick={() => {
//                                     const details = typeof sub.okr_details === 'string'
//                                       ? JSON.parse(sub.okr_details)
//                                       : sub.okr_details;
//                                     setSelected({ ...sub, okr_details: details });
//                                   }}
//                                   style={{
//                                     background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                     border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                     color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                     padding: '8px 16px',
//                                     borderRadius: '10px',
//                                     fontSize: '12px',
//                                     fontWeight: '700',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '8px'
//                                   }}
//                                 >
//                                   {sub.quarter}
//                                   <span>{isLocked ? '🔒' : (isReview ? '⏳' : '→')}</span>
//                                 </button>
//                               );
//                             })}
//                           </div>

//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{
//                       color: '#ff4d4f',
//                       fontWeight: '700',
//                       fontSize: '13px'
//                     }}>
//                       Not Submitted
//                     </div>
//                   )}

//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>

//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}

//       </div>
//     );



//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;


























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [activeAR, setActiveAR] = useState(null);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//         console.log("OKR DATA:", okrData.data);
//         console.log("FIRST SUBMISSION:", okrData.data[0]);

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };




//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.profile_image
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);

//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     const cleanedOKR = selected.okr_details.map(obj => ({
//       ...obj,
//       keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//           delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//         }

//         return newKR;
//       })
//     }));

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(cleanedOKR),
//           workflow_status: nextWorkflowStatus
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         setSelected(prev => ({
//           ...prev,
//           okr_details: cleanedOKR,
//           workflow_status: nextWorkflowStatus
//         }));
//         window.location.reload();
//       }
//     } catch (err) {
//       alert("🚨 Sync failed");
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderOKRTrackerTab = () => {


//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)", // orange

//       "linear-gradient(to right, #16a34a, #22c55e)", // green
//       // purple
//       "linear-gradient(to right, #dc2626, #ef4444)"  // red
//     ];
//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;

//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };


//     const autoResize = (el) => {
//       if (!el) return;
//       el.style.height = 'auto';
//       el.style.height = `${el.scrollHeight}px`;
//     };
//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );
//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>

//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.profile_image ? (
//                   <img
//                     src={selected.profile_image}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.profile_image)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>

//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">
//                   {selected.workflow_status.replace(/_/g, " ")}
//                 </span>
//               </div>
//             </div>

//             <div className="nav-actions">

//               {selected.workflow_status === "Management_Review" && (
//                 <>
//                   <button
//                     className="btn-approve-cyan"
//                     onClick={() => updateOKRStatus("Scoring")}
//                     disabled={isUpdating}
//                   >
//                     {isUpdating ? "PROCESSING..." : "APPROVE"}
//                   </button>

//                   <button
//                     className="btn-warning"
//                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                     disabled={isUpdating}
//                     style={{
//                       marginLeft: "10px",
//                       background: "#ff9800",
//                       color: "#000",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                   </button>
//                 </>
//               )}

//               {selected.workflow_status === "Manager_Scoring_Review" && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus("Sign_Off")}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {selected.workflow_status === "Locked" && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               <button className="btn-delete-minimal" onClick={handleDeleteEntireOKR}>
//                 🗑
//               </button>
//             </div>
//           </div>

//           {/* OBJECTIVES */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div
//                     key={oIdx}
//                     className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                   >
//                     <div
//                       className="obj-header-row"
//                       onClick={() =>
//                         setActiveObjective(isExpanded ? null : oIdx)
//                       }
//                     >
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>
//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background:
//                               flagColors[oIdx % flagColors.length],
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, "0")}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         <h3 className="objective-title">
//                           {obj.objective}
//                         </h3>
//                       </div>

//                       <div
//                         className={`obj-status-indicator ${isExpanded ? "open" : ""
//                           }`}
//                       >
//                         {isExpanded
//                           ? "CLOSE"
//                           : "CLICK TO REVEAL RESULTS"}
//                       </div>
//                     </div>

//                     {/* KEY RESULTS */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked =
//                           selected.workflow_status === "Locked";
//                         const isScoreEditable =
//                           selected.workflow_status ===
//                           "Manager_Scoring_Review";

//                         return (
//                           <div
//                             key={`${oIdx}-${kIdx}`}
//                             className={`kr-line-item ${kr.ar_comment && kr.ar_comment.trim()
//                               ? "has-ar"
//                               : ""
//                               }`}
//                           >
//                             <div className="kr-body-wrap">
//                               <span className="kr-index-inline">
//                                 {kIdx + 1})
//                               </span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) =>
//                                     handleKRTextChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                   className="kr-text-minimal auto-expand"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) =>
//                                     autoResize(e.target)
//                                   }
//                                   ref={(el) => el && autoResize(el)}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || "Pending"}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) =>
//                                     handleStatusChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>

//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleDeleteKR(oIdx, kIdx);
//                                 }}
//                               >
//                                 🗑
//                               </button>
//                             </div>

//                             {/* ✏️ AR BUTTON */}
//                             {selected.workflow_status ===
//                               "Management_Review" && (
//                                 <div style={{ marginTop: "8px" }}>
//                                   {activeAR !== `${oIdx}-${kIdx}` ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         setActiveAR(`${oIdx}-${kIdx}`)
//                                       }
//                                       style={{
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         color: "#ff9800",
//                                         fontSize: "13px",
//                                         fontWeight: "600",
//                                       }}
//                                     >
//                                       {kr.ar_comment
//                                         ? "✏️ Edit AR"
//                                         : "✏️ Add AR"}
//                                     </button>
//                                   ) : (
//                                     <textarea
//                                       value={kr.ar_comment || ""}
//                                       onChange={(e) => {
//                                         const updated = {
//                                           ...selected,
//                                         };
//                                         updated.okr_details[oIdx].keyResults[
//                                           kIdx
//                                         ].ar_comment =
//                                           e.target.value;
//                                         setSelected(updated);
//                                       }}
//                                       rows={2}
//                                       autoFocus
//                                       onBlur={() => setActiveAR(null)}
//                                       style={{
//                                         width: "100%",
//                                         marginTop: "6px",
//                                         padding: "8px",
//                                         borderRadius: "6px",
//                                         border: "1px solid #ff9800",
//                                         background:
//                                           "rgba(255,152,0,0.05)",
//                                         fontSize: "13px",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                               )}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }
//     const filteredSubmitted = Object.entries(groupedData).filter(([empName, data]) => {
//       const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//       const dept = data?.years
//         ? data.years[Object.keys(data.years)[0]][0].department
//         : "";

//       const matchesDept = selectedDept ? dept === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });

//     const filteredMissing = missingEmployees.filter(emp => {
//       const matchesSearch = emp.full_name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesDept = selectedDept ? emp.team === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });






//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0', // Centered padding for the content
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* 🔍 SEARCH + FILTER BAR */}
//           <div style={{
//             display: 'flex',
//             gap: '15px',
//             marginBottom: '12px',
//             flexWrap: 'wrap'
//           }}>
//             {/* Search */}
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '10px 14px',
//                 borderRadius: '8px',
//                 border: '1px solid #ccc',
//                 minWidth: '250px'
//               }}
//             />

//             {/* Department Filter */}
//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//             >
//               <option value="">All Departments</option>

//               {[...new Set(
//                 submissions.map(sub => sub.department)
//               )].map((dept, idx) => (
//                 <option key={idx} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div className="hub-header-compact">
//             <div className="breadcrumb-mini">
//               {/* <span>DIRECTORY</span> / <span>OVERVIEW</span> */}
//             </div>

//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* FULL WIDTH LIST */}

//           {/* 🔘 SUBMITTED / MISSING TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "submitted" ? "2px solid #00bcd4" : "1px solid #ccc",
//                 background: viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "missing" ? "2px solid #ff4d4f" : "1px solid #ccc",
//                 background: viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map(emp => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '16px',
//                   padding: '14px 18px',

//                   display: 'grid',
//                   gridTemplateColumns: '240px 1fr',
//                   alignItems: 'center',
//                   transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//                 }}
//               >

//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
//                   <div className="emp-avatar clickable-avatar">
//                     {data.profile_image ? (
//                       <img
//                         src={data.profile_image}
//                         alt={empName}
//                         onClick={() => setPreviewImage(data.profile_image)}
//                       />
//                     ) : (
//                       <span>{empName.charAt(0)}</span>
//                     )}
//                   </div>
//                   <div>
//                     <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#2d3748', fontWeight: '700' }}>{empName}</h3>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
//                       <span style={{ fontSize: '12px', color: '#718096', fontWeight: '600' }}>ID: {data.emp_id}</span>
//                       <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#cbd5e0' }}></span>
//                       <span style={{ fontSize: '13px', color: '#00bcd4', fontWeight: '700', textTransform: 'uppercase' }}>
//                         {data?.years
//                           ? data.years[Object.keys(data.years)[0]][0].department
//                           : (data.team || "No Submission")}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: OKR TIMELINE WRAPPER */}
//                 <div style={{ paddingLeft: '40px', display: 'flex', alignItems: 'center', overflowX: 'auto', gap: '40px' }}>

//                   {data?.years ? (
//                     Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                       <div key={year} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

//                         <div style={{ borderLeft: '3px solid #edf2f7', paddingLeft: '15px' }}>

//                           <div style={{ fontSize: '12px', color: '#eef5ff', fontWeight: '800', marginBottom: '10px' }}>
//                             FY {year}
//                           </div>

//                           <div style={{ display: 'flex', gap: '10px' }}>
//                             {data.years[year].map(sub => {
//                               const isLocked = sub.workflow_status === 'Locked';
//                               const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                               return (
//                                 <button
//                                   key={sub.id}
//                                   onClick={() => {
//                                     const details = typeof sub.okr_details === 'string'
//                                       ? JSON.parse(sub.okr_details)
//                                       : sub.okr_details;
//                                     setSelected({ ...sub, okr_details: details });
//                                   }}
//                                   style={{
//                                     background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                     border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                     color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                     padding: '8px 16px',
//                                     borderRadius: '10px',
//                                     fontSize: '12px',
//                                     fontWeight: '700',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '8px'
//                                   }}
//                                 >
//                                   {sub.quarter}
//                                   <span>{isLocked ? '🔒' : (isReview ? '⏳' : '→')}</span>
//                                 </button>
//                               );
//                             })}
//                           </div>

//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{
//                       color: '#ff4d4f',
//                       fontWeight: '700',
//                       fontSize: '13px'
//                     }}>
//                       Not Submitted
//                     </div>
//                   )}

//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>

//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}

//       </div>
//     );



//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;
























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [activeAR, setActiveAR] = useState(null);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//         console.log("OKR DATA:", okrData.data);
//         console.log("FIRST SUBMISSION:", okrData.data[0]);

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };




//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.profile_image
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);

//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     const cleanedOKR = selected.okr_details.map(obj => ({
//       ...obj,
//       keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//           delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//         }

//         return newKR;
//       })
//     }));

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(cleanedOKR),
//           workflow_status: nextWorkflowStatus
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         setSelected(prev => ({
//           ...prev,
//           okr_details: cleanedOKR,
//           workflow_status: nextWorkflowStatus
//         }));
//         window.location.reload();
//       }
//     } catch (err) {
//       alert("🚨 Sync failed");
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderOKRTrackerTab = () => {


//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)", // orange

//       "linear-gradient(to right, #16a34a, #22c55e)", // green
//       // purple
//       "linear-gradient(to right, #dc2626, #ef4444)"  // red
//     ];
//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;

//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };


//     const autoResize = (el) => {
//       if (!el) return;
//       el.style.height = 'auto';
//       el.style.height = `${el.scrollHeight}px`;
//     };
//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );
//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>

//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.profile_image ? (
//                   <img
//                     src={selected.profile_image}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.profile_image)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>

//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">
//                   {selected.workflow_status.replace(/_/g, " ")}
//                 </span>
//               </div>
//             </div>

//             <div className="nav-actions">

//               {selected.workflow_status === "Management_Review" && (
//                 <>
//                   <button
//                     className="btn-approve-cyan"
//                     onClick={() => updateOKRStatus("Scoring")}
//                     disabled={isUpdating}
//                   >
//                     {isUpdating ? "PROCESSING..." : "APPROVE"}
//                   </button>

//                   <button
//                     className="btn-warning"
//                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                     disabled={isUpdating}
//                     style={{
//                       marginLeft: "10px",
//                       background: "#ff9800",
//                       color: "#000",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                   </button>
//                 </>
//               )}

//               {selected.workflow_status === "Manager_Scoring_Review" && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus("Sign_Off")}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {selected.workflow_status === "Locked" && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               <button className="btn-delete-minimal" onClick={handleDeleteEntireOKR}>
//                 🗑
//               </button>
//             </div>
//           </div>

//           {/* OBJECTIVES */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div
//                     key={oIdx}
//                     className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                   >
//                     <div
//                       className="obj-header-row"
//                       onClick={() =>
//                         setActiveObjective(isExpanded ? null : oIdx)
//                       }
//                     >
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>
//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background:
//                               flagColors[oIdx % flagColors.length],
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, "0")}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         <h3 className="objective-title">
//                           {obj.objective}
//                         </h3>
//                       </div>

//                       <div
//                         className={`obj-status-indicator ${isExpanded ? "open" : ""
//                           }`}
//                       >
//                         {isExpanded
//                           ? "CLOSE"
//                           : "CLICK TO REVEAL RESULTS"}
//                       </div>
//                     </div>

//                     {/* KEY RESULTS */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked =
//                           selected.workflow_status === "Locked";
//                         const isScoreEditable =
//                           selected.workflow_status ===
//                           "Manager_Scoring_Review";

//                         return (
//                           <div
//                             key={`${oIdx}-${kIdx}`}
//                             className={`kr-line-item ${kr.ar_comment && kr.ar_comment.trim()
//                               ? "has-ar"
//                               : ""
//                               }`}
//                           >
//                             <div className="kr-body-wrap">
//                               <span className="kr-index-inline">
//                                 {kIdx + 1})
//                               </span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) =>
//                                     handleKRTextChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                   className="kr-text-minimal auto-expand"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) =>
//                                     autoResize(e.target)
//                                   }
//                                   ref={(el) => el && autoResize(el)}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || "Pending"}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) =>
//                                     handleStatusChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>

//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleDeleteKR(oIdx, kIdx);
//                                 }}
//                               >
//                                 🗑
//                               </button>
//                             </div>


//                             {selected.workflow_status ===
//                               "Management_Review" && (
//                                 <div style={{ marginTop: "8px" }}>
//                                   {activeAR !== `${oIdx}-${kIdx}` ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         setActiveAR(`${oIdx}-${kIdx}`)
//                                       }
//                                       style={{
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         color: "#ff9800",
//                                         fontSize: "13px",
//                                         fontWeight: "600",
//                                       }}
//                                     >
//                                       {kr.ar_comment
//                                         ? "✏️ Edit AR"
//                                         : "✏️ Add AR"}
//                                     </button>
//                                   ) : (
//                                     <textarea
//                                       value={kr.ar_comment || ""}
//                                       onChange={(e) => {
//                                         const updated = {
//                                           ...selected,
//                                         };
//                                         updated.okr_details[oIdx].keyResults[
//                                           kIdx
//                                         ].ar_comment =
//                                           e.target.value;
//                                         setSelected(updated);
//                                       }}
//                                       rows={2}
//                                       autoFocus
//                                       onBlur={() => setActiveAR(null)}
//                                       style={{
//                                         width: "100%",
//                                         marginTop: "6px",
//                                         padding: "8px",
//                                         borderRadius: "6px",
//                                         border: "1px solid #ff9800",
//                                         background:
//                                           "rgba(255,152,0,0.05)",
//                                         fontSize: "13px",
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                               )}




//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }
//     const filteredSubmitted = Object.entries(groupedData).filter(([empName, data]) => {
//       const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//       const dept = data?.years
//         ? data.years[Object.keys(data.years)[0]][0].department
//         : "";

//       const matchesDept = selectedDept ? dept === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });

//     const filteredMissing = missingEmployees.filter(emp => {
//       const matchesSearch = emp.full_name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesDept = selectedDept ? emp.team === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });





//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0',
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* 🔍 SEARCH + FILTER BAR */}
//           <div style={{
//             display: 'flex',
//             gap: '15px',
//             marginBottom: '12px',
//             flexWrap: 'wrap'
//           }}>
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '10px 14px',
//                 borderRadius: '8px',
//                 border: '1px solid #ccc',
//                 minWidth: '250px'
//               }}
//             />

//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//             >
//               <option value="">All Departments</option>
//               {[...new Set(submissions.map(sub => sub.department))].map((dept, idx) => (
//                 <option key={idx} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div className="hub-header-compact">
//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* 🔘 SUBMITTED / MISSING TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "submitted" ? "2px solid #00bcd4" : "1px solid #ccc",
//                 background: viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "missing" ? "2px solid #ff4d4f" : "1px solid #ccc",
//                 background: viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>

//           {/* ⚡ UPDATED: SPLIT-COLUMN GRID CONTAINER */}
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map(emp => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '12px',
//                   padding: '12px 16px',
//                   display: 'grid',
//                   gridTemplateColumns: '180px 1fr',
//                   alignItems: 'center',
//                   background: '#fff',
//                   border: '1px solid #eef2f6',
//                   minHeight: '75px',
//                   boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
//                 }}
//               >
//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '15px', display: 'flex', alignItems: 'center', gap: '12px' }}>
//                   <div className="emp-avatar clickable-avatar" style={{ width: '38px', height: '38px', flexShrink: 0 }}>
//                     {data.profile_image ? (
//                       <img
//                         src={data.profile_image}
//                         alt={empName}
//                         onClick={() => setPreviewImage(data.profile_image)}
//                         style={{ borderRadius: '50%', width: '100%', height: '100%', objectFit: 'cover' }}
//                       />
//                     ) : (
//                       <div style={{ width: '100%', height: '100%', background: '#f0f0f0', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 'bold' }}>
//                         {empName.charAt(0)}
//                       </div>
//                     )}
//                   </div>
//                   <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//                     <h3 style={{
//                       margin: 0,
//                       fontSize: '0.95rem',
//                       color: '#2d3748',
//                       fontWeight: '700',
//                       /* Changed: Allow wrapping but limit to 2 lines for consistency */
//                       display: '-webkit-box',
//                       WebkitLineClamp: '2',
//                       WebkitBoxOrient: 'vertical',
//                       overflow: 'hidden',
//                       lineHeight: '1.2',
//                       wordBreak: 'break-word'
//                     }}>
//                       {empName}
//                     </h3>
//                     <p style={{
//                       margin: 0,
//                       fontSize: '12px',
//                       color: '#718096',
//                       marginTop: '4px',
//                       fontWeight: '500'
//                     }}>
//                       ID: {viewType === "submitted" ? data.emp_id : data.empid}
//                     </p>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: STACKED YEAR & QUARTER TIMELINE */}
//                 <div style={{ paddingLeft: '15px', display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
//                   {data?.years ? (
//                     Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                       /* STACKED: Year on top, Quarters below */
//                       <div key={year} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
//                         <span style={{ fontSize: '13px', fontWeight: '800', color: '#94a3b8', letterSpacing: '0.5px' }}>
//                           {year}
//                         </span>
//                         <div style={{ display: 'flex', gap: '5px' }}>
//                           {data.years[year].map(sub => {
//                             const isLocked = sub.workflow_status === 'Locked';
//                             const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                             return (
//                               <button
//                                 key={sub.id}
//                                 onClick={() => {
//                                   const details = typeof sub.okr_details === 'string'
//                                     ? JSON.parse(sub.okr_details)
//                                     : sub.okr_details;
//                                   setSelected({ ...sub, okr_details: details });
//                                 }}
//                                 style={{
//                                   background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                   border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                   color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                   padding: '4px 10px',
//                                   borderRadius: '6px',
//                                   fontSize: '12px',
//                                   fontWeight: '600',
//                                   cursor: 'pointer',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: '4px',
//                                   whiteSpace: 'nowrap'
//                                 }}
//                               >
//                                 {sub.quarter}
//                                 <span>{isLocked ? '🔒' : (isReview ? '⏳' : '→')}</span>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{ color: '#ff4d4f', fontWeight: '600', fontSize: '12px' }}>
//                       Not Submitted
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* IMAGE PREVIEW MODAL */}
//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}
//       </div>
//     );

//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;



















// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [activeAR, setActiveAR] = useState([]);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//         console.log("OKR DATA:", okrData.data);
//         console.log("FIRST SUBMISSION:", okrData.data[0]);

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };




//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.profile_image
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);

//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     const cleanedOKR = selected.okr_details.map(obj => ({
//       ...obj,
//       keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//           delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//         }

//         return newKR;
//       })
//     }));

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(cleanedOKR),
//           workflow_status: nextWorkflowStatus
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         setSelected(prev => ({
//           ...prev,
//           okr_details: cleanedOKR,
//           workflow_status: nextWorkflowStatus
//         }));
//         window.location.reload();
//       }
//     } catch (err) {
//       alert("🚨 Sync failed");
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderOKRTrackerTab = () => {


//     if (loading) return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)", // orange

//       "linear-gradient(to right, #16a34a, #22c55e)", // green
//       // purple
//       "linear-gradient(to right, #dc2626, #ef4444)"  // red
//     ];
//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;

//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };


//     const autoResize = (el) => {
//       if (!el) return;
//       el.style.height = 'auto';
//       el.style.height = `${el.scrollHeight}px`;
//     };
//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );
//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* TOP HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>

//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.profile_image ? (
//                   <img
//                     src={selected.profile_image}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.profile_image)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>

//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">
//                   {selected.workflow_status.replace(/_/g, " ")}
//                 </span>
//               </div>
//             </div>

//             <div className="nav-actions">

//               {selected.workflow_status === "Management_Review" && (
//                 <>
//                   <button
//                     className="btn-approve-cyan"
//                     onClick={() => updateOKRStatus("Scoring")}
//                     disabled={isUpdating}
//                   >
//                     {isUpdating ? "PROCESSING..." : "APPROVE"}
//                   </button>

//                   <button
//                     className="btn-warning"
//                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                     disabled={isUpdating}
//                     style={{
//                       marginLeft: "10px",
//                       background: "#ff9800",
//                       color: "#000",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                   </button>
//                 </>
//               )}

//               {selected.workflow_status === "Manager_Scoring_Review" && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus("Sign_Off")}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {selected.workflow_status === "Locked" && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               <button className="btn-delete-minimal" onClick={handleDeleteEntireOKR}>
//                 🗑
//               </button>
//             </div>
//           </div>

//           {/* OBJECTIVES */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div
//                     key={oIdx}
//                     className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                   >
//                     <div
//                       className="obj-header-row"
//                       onClick={() =>
//                         setActiveObjective(isExpanded ? null : oIdx)
//                       }
//                     >
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>
//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background:
//                               flagColors[oIdx % flagColors.length],
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, "0")}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         <h3 className="objective-title">
//                           {obj.objective}
//                         </h3>
//                       </div>

//                       <div
//                         className={`obj-status-indicator ${isExpanded ? "open" : ""
//                           }`}
//                       >
//                         {isExpanded
//                           ? "CLOSE"
//                           : "CLICK TO REVEAL RESULTS"}
//                       </div>
//                     </div>

//                     {/* KEY RESULTS */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked =
//                           selected.workflow_status === "Locked";
//                         const isScoreEditable =
//                           selected.workflow_status ===
//                           "Manager_Scoring_Review";

//                         return (
//                           <div
//                             key={`${oIdx}-${kIdx}`}
//                             className={`kr-line-item ${kr.ar_comment && kr.ar_comment.trim()
//                               ? "has-ar"
//                               : ""
//                               }`}
//                           >
//                             <div className="kr-body-wrap">
//                               <span className="kr-index-inline">
//                                 {kIdx + 1})
//                               </span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) =>
//                                     handleKRTextChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                   className="kr-text-minimal auto-expand"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) =>
//                                     autoResize(e.target)
//                                   }
//                                   ref={(el) => el && autoResize(el)}
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || "Pending"}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) =>
//                                     handleStatusChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>

//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleDeleteKR(oIdx, kIdx);
//                                 }}
//                               >
//                                 🗑
//                               </button>
//                             </div>


//                             {selected.workflow_status === "Management_Review" && (
//                               <div style={{ marginTop: "8px" }}>
//                                 {!(
//                                   activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                   (kr.ar_comment && kr.ar_comment.trim())
//                                 ) ? (
//                                   <button
//                                     type="button"
//                                     onClick={() =>
//                                       setActiveAR((prev) => [...prev, `${oIdx}-${kIdx}`])
//                                     }
//                                     style={{
//                                       background: "transparent",
//                                       border: "none",
//                                       cursor: "pointer",
//                                       color: "#ff9800",
//                                       fontSize: "13px",
//                                       fontWeight: "600",
//                                     }}
//                                   >
//                                     {kr.ar_comment ? "✏️ Edit AR" : "✏️ Add AR"}
//                                   </button>
//                                 ) : (
//                                   <textarea
//                                     value={kr.ar_comment || ""}
//                                     onChange={(e) => {
//                                       const updated = { ...selected };
//                                       updated.okr_details[oIdx].keyResults[kIdx].ar_comment =
//                                         e.target.value;
//                                       setSelected(updated);
//                                     }}
//                                     rows={2}
//                                     autoFocus
//                                     style={{
//                                       width: "100%",
//                                       marginTop: "6px",
//                                       padding: "8px",
//                                       borderRadius: "6px",
//                                       border: "1px solid #ff9800",
//                                       background: "rgba(255,152,0,0.05)",
//                                       fontSize: "13px",
//                                     }}
//                                   />
//                                 )}
//                               </div>
//                             )}



//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }
//     const filteredSubmitted = Object.entries(groupedData).filter(([empName, data]) => {
//       const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//       const dept = data?.years
//         ? data.years[Object.keys(data.years)[0]][0].department
//         : "";

//       const matchesDept = selectedDept ? dept === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });

//     const filteredMissing = missingEmployees.filter(emp => {
//       const matchesSearch = emp.full_name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesDept = selectedDept ? emp.team === selectedDept : true;

//       return matchesSearch && matchesDept;
//     });





//     return (
//       <div className="okr-genesis-container animate-fade" style={{
//         background: 'transparent',
//         minHeight: '100vh',
//         padding: '40px 0',
//         width: '100%',
//         fontFamily: "'Inter', 'Segoe UI', sans-serif"
//       }}>
//         <div style={{ width: '95%', margin: '0 auto' }}>

//           {/* 🔍 SEARCH + FILTER BAR */}
//           <div style={{
//             display: 'flex',
//             gap: '15px',
//             marginBottom: '12px',
//             flexWrap: 'wrap'
//           }}>
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: '10px 14px',
//                 borderRadius: '8px',
//                 border: '1px solid #ccc',
//                 minWidth: '250px'
//               }}
//             />

//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//             >
//               <option value="">All Departments</option>
//               {[...new Set(submissions.map(sub => sub.department))].map((dept, idx) => (
//                 <option key={idx} value={dept}>{dept}</option>
//               ))}
//             </select>
//           </div>

//           {/* MINIMALIST BREADCRUMB HEADER */}
//           <div className="hub-header-compact">
//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* 🔘 SUBMITTED / MISSING TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "submitted" ? "2px solid #00bcd4" : "1px solid #ccc",
//                 background: viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border: viewType === "missing" ? "2px solid #ff4d4f" : "1px solid #ccc",
//                 background: viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>

//           {/* ⚡ UPDATED: SPLIT-COLUMN GRID CONTAINER */}
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map(emp => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: '12px',
//                   padding: '12px 16px',
//                   display: 'grid',
//                   gridTemplateColumns: '180px 1fr',
//                   alignItems: 'center',
//                   background: '#fff',
//                   border: '1px solid #eef2f6',
//                   minHeight: '75px',
//                   boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
//                 }}
//               >
//                 {/* LEFT SIDE: USER PROFILE SECTION */}
//                 <div style={{ borderRight: '1px solid #edf2f7', paddingRight: '15px', display: 'flex', alignItems: 'center', gap: '12px' }}>
//                   <div className="emp-avatar clickable-avatar" style={{ width: '38px', height: '38px', flexShrink: 0 }}>
//                     {data.profile_image ? (
//                       <img
//                         src={data.profile_image}
//                         alt={empName}
//                         onClick={() => setPreviewImage(data.profile_image)}
//                         style={{ borderRadius: '50%', width: '100%', height: '100%', objectFit: 'cover' }}
//                       />
//                     ) : (
//                       <div style={{ width: '100%', height: '100%', background: '#f0f0f0', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 'bold' }}>
//                         {empName.charAt(0)}
//                       </div>
//                     )}
//                   </div>
//                   <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//                     <h3 style={{
//                       margin: 0,
//                       fontSize: '0.95rem',
//                       color: '#2d3748',
//                       fontWeight: '700',
//                       /* Changed: Allow wrapping but limit to 2 lines for consistency */
//                       display: '-webkit-box',
//                       WebkitLineClamp: '2',
//                       WebkitBoxOrient: 'vertical',
//                       overflow: 'hidden',
//                       lineHeight: '1.2',
//                       wordBreak: 'break-word'
//                     }}>
//                       {empName}
//                     </h3>
//                     <p style={{
//                       margin: 0,
//                       fontSize: '12px',
//                       color: '#718096',
//                       marginTop: '4px',
//                       fontWeight: '500'
//                     }}>
//                       ID: {viewType === "submitted" ? data.emp_id : data.empid}
//                     </p>
//                   </div>
//                 </div>

//                 {/* RIGHT SIDE: STACKED YEAR & QUARTER TIMELINE */}
//                 <div style={{ paddingLeft: '15px', display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
//                   {data?.years ? (
//                     Object.keys(data.years).sort((a, b) => b - a).map(year => (
//                       /* STACKED: Year on top, Quarters below */
//                       <div key={year} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
//                         <span style={{ fontSize: '13px', fontWeight: '800', color: '#94a3b8', letterSpacing: '0.5px' }}>
//                           {year}
//                         </span>
//                         <div style={{ display: 'flex', gap: '5px' }}>
//                           {data.years[year].map(sub => {
//                             const isLocked = sub.workflow_status === 'Locked';
//                             const isReview = ['Management_Review', 'Manager_Scoring_Review'].includes(sub.workflow_status);

//                             return (
//                               <button
//                                 key={sub.id}
//                                 onClick={() => {
//                                   const details = typeof sub.okr_details === 'string'
//                                     ? JSON.parse(sub.okr_details)
//                                     : sub.okr_details;
//                                   setSelected({ ...sub, okr_details: details });
//                                 }}
//                                 style={{
//                                   background: isLocked ? '#f7fafc' : (isReview ? '#fffaf0' : '#ebfaff'),
//                                   border: `1px solid ${isLocked ? '#e2e8f0' : (isReview ? '#fbd38d' : '#9decf9')}`,
//                                   color: isLocked ? '#a0aec0' : (isReview ? '#dd6b20' : '#008ca3'),
//                                   padding: '4px 10px',
//                                   borderRadius: '6px',
//                                   fontSize: '12px',
//                                   fontWeight: '600',
//                                   cursor: 'pointer',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: '4px',
//                                   whiteSpace: 'nowrap'
//                                 }}
//                               >
//                                 {sub.quarter}
//                                 <span>{isLocked ? '🔒' : (isReview ? '⏳' : '→')}</span>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div style={{ color: '#ff4d4f', fontWeight: '600', fontSize: '12px' }}>
//                       Not Submitted
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* IMAGE PREVIEW MODAL */}
//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}
//       </div>
//     );

//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;



















// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//   const [lockedQuarters, setLockedQuarters] = useState({});

//   const getFY = (date) => {
//     const m = date.getMonth() + 1;
//     const y = date.getFullYear();
//     return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//   };
//   const [lockYear, setLockYear] = useState(getFY(new Date()));

//   const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//   const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//   const [activeTab, setActiveTab] = useState("OKR Tracker");
//   const [loading, setLoading] = useState(true);

//   // OKR Tracker States
//   const [submissions, setSubmissions] = useState([]);
//   const [selected, setSelected] = useState(null);
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [activeAR, setActiveAR] = useState([]);

//   // Employee Review States
//   const [reviews, setReviews] = useState([]);
//   const [selectedReview, setSelectedReview] = useState(null);

//   // Management Action States
//   const [allEmployees, setAllEmployees] = useState([]);
//   const [mgmtSelection, setMgmtSelection] = useState({
//     emp_id: "",
//     content: "",
//     accomplished: "",
//     improvements: ""
//   });
//   const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//   const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//   // Hardcoded Message Template
//   const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//         const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//         const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//         const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//         const empUrl = `/gt-api/get_all_staff.php`;

//         const [revRes, okrRes, empRes] = await Promise.all([
//           fetch(revUrl),
//           fetch(okrUrl),
//           fetch(empUrl)
//         ]);

//         const revData = await revRes.json();
//         const okrData = await okrRes.json();
//         const empData = await empRes.json();

//         if (revData.success && revData.data.length > 0) {
//           setReviews(revData.data);
//         } else {
//           const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//           const fallbackData = await fallbackRes.json();
//           if (fallbackData.success) setReviews(fallbackData.data);
//         }

//         setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//         console.log("OKR DATA:", okrData.data);
//         console.log("FIRST SUBMISSION:", okrData.data[0]);

//         if (empData.success && Array.isArray(empData.data)) {
//           setAllEmployees(empData.data);
//         } else {
//           setAllEmployees([]);
//         }

//       } catch (err) {
//         console.error("❌ Fetch error:", err);
//         setAllEmployees([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [userRole, managedDept]);

//   useEffect(() => {
//     const fetchLocks = async () => {
//       try {
//         const res = await fetch(
//           `/gt-api/lock_timeline.php?year=${lockYear}`
//         );

//         const data = await res.json();

//         console.log("LOCK DATA:", data); // debug

//         if (data.success) {
//           setLockedQuarters(data.locks || {});
//         }
//       } catch (err) {
//         console.error("LOCK FETCH ERROR:", err);
//       }
//     };

//     fetchLocks();
//   }, [lockYear]);


//   // 🔍 Search + Filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedDept, setSelectedDept] = useState("");
//   const [previewImage, setPreviewImage] = useState(null);
//   const [viewType, setViewType] = useState("submitted");
//   const getCurrentQuarter = () => {
//     const month = new Date().getMonth() + 1;

//     if (month >= 4 && month <= 6) return "Quarter 1";
//     if (month >= 7 && month <= 9) return "Quarter 2";
//     if (month >= 10 && month <= 12) return "Quarter 3";
//     return "Quarter 4";
//   };

//   const currentQuarter = getCurrentQuarter();



//   const handleDeleteEntireOKR = async () => {
//     const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//     if (!confirmDelete) return;

//     try {
//       const response = await fetch('/gt-api/delete_okr.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert("OKR deleted successfully!");
//         setSelected(null);   // go back to list
//         window.location.reload(); // refresh data
//       } else {
//         alert("Error: " + (res.message || "Delete failed"));
//       }

//     } catch (err) {
//       alert("Server error while deleting OKR");
//     }
//   };




//   const handleManagementSubmit = async () => {
//     const isManagerReview = activeTab === "Manager Review";
//     const isProbation = activeTab === "Probation Period Feedback";

//     // Validation: If probation, we don't need to check "content" state since it's hardcoded
//     const hasContent = isManagerReview
//       ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//       : (isProbation ? true : mgmtSelection.content.trim());

//     if (!mgmtSelection.emp_id || !hasContent) {
//       alert("Please select an employee and fill in all required fields.");
//       return;
//     }

//     const apiEndpoint = isProbation
//       ? '/gt-api/save_probation_notice.php'
//       : '/gt-api/save_management_notice.php';

//     setIsSubmittingMgmt(true);
//     try {
//       let finalContent = "";
//       if (isManagerReview) {
//         finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//       } else if (isProbation) {
//         finalContent = PROBATION_MESSAGE;
//       } else {
//         finalContent = mgmtSelection.content;
//       }

//       const response = await fetch(apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           emp_id: mgmtSelection.emp_id,
//           content: finalContent,
//           type: activeTab,
//           sender_role: userRole
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         alert(`${activeTab} submitted successfully!`);
//         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//       } else {
//         alert("Error: " + (res.message || "Unknown error"));
//       }
//     } catch (err) {
//       alert("Failed to connect to the server.");
//     } finally {
//       setIsSubmittingMgmt(false);
//     }
//   };

//   const groupedData = submissions.reduce((acc, sub) => {
//     const name = sub.emp_name;
//     const year = sub.year;

//     if (!acc[name]) {
//       acc[name] = {
//         emp_id: sub.emp_id,
//         years: {},
//         profile_image: sub.profile_image
//       };
//     }

//     if (!acc[name].years[year]) acc[name].years[year] = [];
//     acc[name].years[year].push(sub);

//     return acc;
//   }, {});


//   // 🔍 Apply search + department filter
//   const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//     const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//     const empDept =
//       data.years[Object.keys(data.years)[0]][0].department || "";

//     const matchesDept = selectedDept ? empDept === selectedDept : true;

//     return matchesSearch && matchesDept;
//   });

//   const handleStatusChange = (oIdx, kIdx, newStatus) => {
//     const updatedSelected = { ...selected };
//     updatedSelected.okr_details[oIdx].keyResults[kIdx].result = newStatus;
//     setSelected(updatedSelected);
//   };

//   // ✏️ EDIT KEY RESULT TEXT
//   const handleKRTextChange = (oIdx, kIdx, newText) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults[kIdx].text = newText;
//     setSelected(updated);
//   };

//   // ❌ DELETE KEY RESULT
//   const handleDeleteKR = (oIdx, kIdx) => {
//     const updated = { ...selected };
//     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//     setSelected(updated);
//   };

//   const updateOKRStatus = async (customStatus = null) => {
//     setIsUpdating(true);

//     let nextWorkflowStatus = '';
//     if (customStatus) {
//       nextWorkflowStatus = customStatus;
//     } else if (selected.workflow_status === 'Management_Review') {
//       nextWorkflowStatus = 'Scoring';
//     } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//       nextWorkflowStatus = 'Sign_Off';
//     }

//     const cleanedOKR = selected.okr_details.map(obj => ({
//       ...obj,
//       keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//           delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//         }

//         return newKR;
//       })
//     }));

//     try {
//       const response = await fetch('/gt-api/update_okr_management.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           submission_id: selected.id,
//           okr_details: JSON.stringify(cleanedOKR),
//           workflow_status: nextWorkflowStatus
//         })
//       });

//       const res = await response.json();

//       if (res.success) {
//         setSelected(prev => ({
//           ...prev,
//           okr_details: cleanedOKR,
//           workflow_status: nextWorkflowStatus
//         }));
//         window.location.reload();
//       }
//     } catch (err) {
//       alert("🚨 Sync failed");
//     } finally {
//       setIsUpdating(false);
//     }
//   };


//   const [activeObjective, setActiveObjective] = useState(0);
//   const renderManagementActionForm = (title) => {
//     const isManagerReview = title === "Manager Review";
//     const isProbation = title === "Probation Period Feedback";

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//           <div className="list-header" style={{ marginBottom: '20px' }}>
//             <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//             <div className="form-group">
//               <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//               <select
//                 className="modern-select"
//                 style={{ width: '100%', padding: '10px' }}
//                 value={mgmtSelection.emp_id}
//                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//               >
//                 <option value="">-- Choose Employee --</option>
//                 {allEmployees?.map(emp => (
//                   <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                 ))}
//               </select>
//             </div>

//             {isManagerReview ? (
//               <>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe key accomplishments..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.accomplished}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                   <textarea
//                     className="modern-textarea"
//                     placeholder="Describe areas for improvement..."
//                     style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                     value={mgmtSelection.improvements}
//                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                   />
//                 </div>
//               </>
//             ) : isProbation ? (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                 <div style={{
//                   padding: '20px',
//                   background: 'rgba(0,188,212,0.08)',
//                   border: '1px solid #00bcd4',
//                   borderRadius: '8px',
//                   color: '#fff',
//                   fontSize: '13px',
//                   whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                   lineHeight: '1.6'
//                 }}>
//                   {PROBATION_MESSAGE}
//                 </div>
//               </div>
//             ) : (
//               <div className="form-group">
//                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                 <textarea
//                   className="modern-textarea"
//                   placeholder={`Write the ${title.toLowerCase()} details here...`}
//                   style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                   value={mgmtSelection.content}
//                   onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                 />
//               </div>
//             )}

//             <button
//               className="btn-primary"
//               style={{ marginTop: '10px', width: '100%' }}
//               onClick={handleManagementSubmit}
//               disabled={isSubmittingMgmt}
//             >
//               {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderOKRTrackerTab = () => {
//     if (loading) {
//       return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//     }

//     const flagColors = [
//       "linear-gradient(to right, #e63900, #ff8c00)",
//       "linear-gradient(to right, #7c3aed, #a855f7)",
//       "linear-gradient(to right, #16a34a, #22c55e)",
//       "linear-gradient(to right, #dc2626, #ef4444)"
//     ];

//     const getCurrentQuarter = () => {
//       const month = new Date().getMonth() + 1;
//       if (month >= 4 && month <= 6) return "Quarter 1";
//       if (month >= 7 && month <= 9) return "Quarter 2";
//       if (month >= 10 && month <= 12) return "Quarter 3";
//       return "Quarter 4";
//     };

//     const autoResize = (el) => {
//       if (!el) return;
//       el.style.height = "auto";
//       el.style.height = `${el.scrollHeight}px`;
//     };

//     const currentQuarter = getCurrentQuarter();

//     const submittedEmpIds = new Set(
//       submissions
//         .filter((sub) => sub.quarter === currentQuarter)
//         .map((sub) => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter((emp) =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(
//       (emp) => !submittedEmpIds.has(emp.empid)
//     );

//     // =========================
//     // 🔹 SELECTED VIEW
//     // =========================
//     if (selected) {
//       return (
//         <div className="okr-vertical-reveal-viewer animate-fade">
//           <div className="bg-subtle-grid"></div>

//           {/* HEADER */}
//           <div className="nav-strip-glass">
//             <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//               <span className="icon">⬅</span> DIRECTORY
//             </button>

//             <div className="profile-pill">
//               <div className="p-avatar clickable-avatar">
//                 {selected.profile_image ? (
//                   <img
//                     src={selected.profile_image}
//                     alt={selected.emp_name}
//                     onClick={() => setPreviewImage(selected.profile_image)}
//                   />
//                 ) : (
//                   <span>{selected.emp_name?.charAt(0)}</span>
//                 )}
//               </div>

//               <div className="p-info">
//                 <span className="p-name">{selected.emp_name}</span>
//                 <span className="p-status">
//                   {selected.workflow_status.replace(/_/g, " ")}
//                 </span>
//               </div>
//             </div>

//             <div className="nav-actions">
//               {selected.workflow_status === "Management_Review" && (
//                 <>
//                   <button
//                     className="btn-approve-cyan"
//                     onClick={() => updateOKRStatus("Scoring")}
//                     disabled={isUpdating}
//                   >
//                     {isUpdating ? "PROCESSING..." : "APPROVE"}
//                   </button>

//                   <button
//                     className="btn-warning"
//                     onClick={() =>
//                       updateOKRStatus("Returned_To_Employee")
//                     }
//                     disabled={isUpdating}
//                     style={{
//                       marginLeft: "10px",
//                       background: "#ff9800",
//                       color: "#000",
//                       fontWeight: "600"
//                     }}
//                   >
//                     {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                   </button>
//                 </>
//               )}

//               {selected.workflow_status === "Manager_Scoring_Review" && (
//                 <button
//                   className="btn-approve-cyan"
//                   onClick={() => updateOKRStatus("Sign_Off")}
//                   disabled={isUpdating}
//                 >
//                   {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                 </button>
//               )}

//               {selected.workflow_status === "Locked" && (
//                 <span className="locked-label">LOCKED</span>
//               )}

//               <button
//                 className="btn-delete-minimal"
//                 onClick={handleDeleteEntireOKR}
//               >
//                 🗑
//               </button>
//             </div>
//           </div>

//           {/* OBJECTIVES */}
//           <div className="objective-vertical-stack">
//             {Array.isArray(selected.okr_details) &&
//               selected.okr_details.map((obj, oIdx) => {
//                 const isExpanded = activeObjective === oIdx;

//                 return (
//                   <div
//                     key={oIdx}
//                     className={`obj-reveal-group ${isExpanded ? "is-active" : ""
//                       }`}
//                   >
//                     <div
//                       className="obj-header-row"
//                       onClick={() =>
//                         setActiveObjective(isExpanded ? null : oIdx)
//                       }
//                     >
//                       <div className="obj-flag-wrapper">
//                         <div className="obj-flag-fold"></div>
//                         <div
//                           className="obj-flag-body"
//                           style={{
//                             background:
//                               flagColors[oIdx % flagColors.length]
//                           }}
//                         >
//                           {String(oIdx + 1).padStart(2, "0")}
//                         </div>
//                       </div>

//                       <div className="obj-text-content">
//                         <h3 className="objective-title">
//                           {obj.objective}
//                         </h3>
//                       </div>

//                       <div
//                         className={`obj-status-indicator ${isExpanded ? "open" : ""
//                           }`}
//                       >
//                         {isExpanded
//                           ? "CLOSE"
//                           : "CLICK TO REVEAL RESULTS"}
//                       </div>
//                     </div>

//                     {/* KEY RESULTS */}
//                     <div className="kr-vertical-list">
//                       {obj.keyResults?.map((kr, kIdx) => {
//                         const isLocked =
//                           selected.workflow_status === "Locked";

//                         const isScoreEditable =
//                           selected.workflow_status ===
//                           "Manager_Scoring_Review";

//                         return (
//                           <div
//                             key={`${oIdx}-${kIdx}`}
//                             className={`kr-line-item ${kr.ar_comment?.trim()
//                               ? "has-ar"
//                               : ""
//                               }`}
//                           >
//                             <div className="kr-body-wrap">
//                               <span className="kr-index-inline">
//                                 {kIdx + 1})
//                               </span>

//                               <div className="kr-input-area">
//                                 <textarea
//                                   value={kr.text}
//                                   disabled={isLocked}
//                                   onChange={(e) =>
//                                     handleKRTextChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                   className="kr-text-minimal auto-expand"
//                                   rows={1}
//                                   placeholder="Key Result..."
//                                   onInput={(e) =>
//                                     autoResize(e.target)
//                                   }
//                                   ref={(el) =>
//                                     el && autoResize(el)
//                                   }
//                                 />
//                               </div>
//                             </div>

//                             <div className="kr-controls">
//                               <div className="kr-score-dropdown">
//                                 <label>SCORE</label>
//                                 <select
//                                   value={kr.result || "Pending"}
//                                   disabled={!isScoreEditable}
//                                   onChange={(e) =>
//                                     handleStatusChange(
//                                       oIdx,
//                                       kIdx,
//                                       e.target.value
//                                     )
//                                   }
//                                 >
//                                   {resultOptions.map((opt) => (
//                                     <option key={opt} value={opt}>
//                                       {opt}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>

//                               <button
//                                 className="kr-line-delete"
//                                 disabled={isLocked}
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   handleDeleteKR(oIdx, kIdx);
//                                 }}
//                               >
//                                 🗑
//                               </button>
//                             </div>

//                             {selected.workflow_status ===
//                               "Management_Review" && (
//                                 <div style={{ marginTop: "8px" }}>
//                                   {!(
//                                     activeAR.includes(
//                                       `${oIdx}-${kIdx}`
//                                     ) ||
//                                     kr.ar_comment?.trim()
//                                   ) ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         setActiveAR((prev) => [
//                                           ...prev,
//                                           `${oIdx}-${kIdx}`
//                                         ])
//                                       }
//                                       style={{
//                                         background: "transparent",
//                                         border: "none",
//                                         cursor: "pointer",
//                                         color: "#ff9800",
//                                         fontSize: "13px",
//                                         fontWeight: "600"
//                                       }}
//                                     >
//                                       {kr.ar_comment
//                                         ? "✏️ Edit AR"
//                                         : "✏️ Add AR"}
//                                     </button>
//                                   ) : (
//                                     <textarea
//                                       value={kr.ar_comment || ""}
//                                       onChange={(e) => {
//                                         const updated = {
//                                           ...selected
//                                         };
//                                         updated.okr_details[oIdx].keyResults[
//                                           kIdx
//                                         ].ar_comment = e.target.value;
//                                         setSelected(updated);
//                                       }}
//                                       rows={2}
//                                       autoFocus
//                                       style={{
//                                         width: "100%",
//                                         marginTop: "6px",
//                                         padding: "8px",
//                                         borderRadius: "6px",
//                                         border:
//                                           "1px solid #ff9800",
//                                         background:
//                                           "rgba(255,152,0,0.05)",
//                                         fontSize: "13px"
//                                       }}
//                                     />
//                                   )}
//                                 </div>
//                               )}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           {previewImage && (
//             <div
//               className="image-preview-overlay"
//               onClick={() => setPreviewImage(null)}
//             >
//               <div className="image-preview-box">
//                 <img src={previewImage} alt="Preview" />
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     }

//     // =========================
//     // 🔹 LIST VIEW (UNCHANGED)
//     // =========================

//     const filteredSubmitted = Object.entries(groupedData).filter(
//       ([empName, data]) => {
//         const matchesSearch = empName
//           .toLowerCase()
//           .includes(searchTerm.toLowerCase());

//         const dept = data?.years
//           ? data.years[Object.keys(data.years)[0]][0].department
//           : "";

//         const matchesDept = selectedDept
//           ? dept === selectedDept
//           : true;

//         return matchesSearch && matchesDept;
//       }
//     );

//     const filteredMissing = missingEmployees.filter((emp) => {
//       const matchesSearch = emp.full_name
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase());

//       const matchesDept = selectedDept
//         ? emp.team === selectedDept
//         : true;

//       return matchesSearch && matchesDept;
//     });


//     return (
//       <div
//         className="okr-genesis-container animate-fade"
//         style={{
//           background: "transparent",
//           minHeight: "100vh",
//           padding: "40px 0",
//           width: "100%",
//           fontFamily: "'Inter', 'Segoe UI', sans-serif"
//         }}
//       >


//         <div style={{ width: "95%", margin: "0 auto" }}>

//           {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//               gap: "12px",
//               marginBottom: "12px",
//               alignItems: "center"
//             }}
//           >

//             {/* SEARCH */}
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: "10px",
//                 borderRadius: "8px",
//                 border: "1px solid #ccc",
//                 width: "100%"
//               }}
//             />

//             {/* DEPARTMENT */}
//             <select
//               className="department-filter"
//               value={selectedDept}
//               onChange={(e) => setSelectedDept(e.target.value)}
//               style={{ padding: "10px", borderRadius: "8px" }}
//             >
//               <option value="">All Departments</option>
//               {[...new Set(submissions.map((sub) => sub.department))].map(
//                 (dept, idx) => (
//                   <option key={idx} value={dept}>
//                     {dept}
//                   </option>
//                 )
//               )}
//             </select>

//             {/* YEAR */}
//             <select
//               value={lockYear}
//               onChange={(e) => setLockYear(e.target.value)}
//               style={{ padding: "10px", borderRadius: "8px" }}
//             >
//               {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                 <option key={y} value={y}>
//                   {y}
//                 </option>
//               ))}
//             </select>

//             {/* QUARTER */}
//             <select
//               value={lockQuarter}
//               onChange={(e) => setLockQuarter(e.target.value)}
//               style={{ padding: "10px", borderRadius: "8px" }}
//             >
//               {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                 const isLocked = lockedQuarters[q];

//                 return (
//                   <option key={q} value={q}>
//                     {q} {isLocked ? "🔒" : ""}
//                   </option>
//                 );
//               })}
//             </select>

//             {/* LOCK */}
//             <button
//               onClick={async () => {
//                 try {
//                   const res = await fetch("/gt-api/lock_timeline.php", {
//                     method: "POST",
//                     headers: { "Content-Type": "application/json" },
//                     body: JSON.stringify({
//                       year: lockYear,
//                       quarter: lockQuarter,
//                       locked: true
//                     })
//                   });

//                   const data = await res.json();

//                   if (data.success) {
//                     alert("Locked!");

//                     setLockedQuarters(prev => ({
//                       ...prev,
//                       [lockQuarter]: true
//                     }));
//                   }

//                 } catch (err) {
//                   console.error("LOCK ERROR:", err);
//                   alert("Error locking");
//                 }
//               }}
//               style={{
//                 height: "40px",
//                 borderRadius: "8px",
//                 border: "none",
//                 background: "red",
//                 color: "#fff",
//                 fontSize: "18px",
//                 cursor: "pointer",
//                 marginTop: "4px"
//               }}
//             >
//               LOCK
//             </button>

//             {/* UNLOCK */}
//             <button
//               onClick={async () => {
//                 try {
//                   const res = await fetch("/gt-api/lock_timeline.php", {
//                     method: "POST",
//                     headers: { "Content-Type": "application/json" },
//                     body: JSON.stringify({
//                       year: lockYear,
//                       quarter: lockQuarter,
//                       locked: false
//                     })
//                   });

//                   const text = await res.text();
//                   console.log("RAW RESPONSE:", text);

//                   let data;
//                   try {
//                     data = JSON.parse(text);
//                   } catch (e) {
//                     alert("Invalid JSON from server");
//                     return;
//                   }

//                   if (data.success) {
//                     alert("Unlocked!");

//                     setLockedQuarters(prev => ({
//                       ...prev,
//                       [lockQuarter]: false
//                     }));
//                   }

//                 } catch {
//                   alert("Error unlocking");
//                 }
//               }}
//               style={{
//                 height: "40px",
//                 borderRadius: "8px",
//                 border: "none",
//                 background: "green",
//                 color: "#fff",
//                 fontSize: "18px",
//                 cursor: "pointer",
//                 marginTop: "4px"
//               }}
//             >
//               UNLOCK
//             </button>

//           </div>

//           {/* HEADER */}
//           <div className="hub-header-compact">
//             <h1 className="hub-title">
//               Employee <span>Performance Hub</span>
//             </h1>
//           </div>

//           {/* TOGGLE */}
//           <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//             <button
//               onClick={() => setViewType("submitted")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border:
//                   viewType === "submitted"
//                     ? "2px solid #00bcd4"
//                     : "1px solid #ccc",
//                 background:
//                   viewType === "submitted" ? "#e6fafd" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Submitted
//             </button>

//             <button
//               onClick={() => setViewType("missing")}
//               style={{
//                 padding: "8px 16px",
//                 borderRadius: "8px",
//                 border:
//                   viewType === "missing"
//                     ? "2px solid #ff4d4f"
//                     : "1px solid #ccc",
//                 background:
//                   viewType === "missing" ? "#fff1f0" : "#fff",
//                 fontWeight: "600",
//                 cursor: "pointer"
//               }}
//             >
//               Missing
//             </button>
//           </div>

//           {/* GRID */}
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "12px"
//             }}
//           >
//             {(viewType === "submitted"
//               ? filteredSubmitted
//               : filteredMissing.map((emp) => [emp.full_name, emp])
//             ).map(([empName, data]) => (
//               <div
//                 key={empName}
//                 className="employee-row-card"
//                 style={{
//                   borderRadius: "12px",
//                   padding: "12px 16px",
//                   display: "grid",
//                   gridTemplateColumns: "180px 1fr",
//                   alignItems: "center",
//                   background: "#fff",
//                   border: "1px solid #eef2f6",
//                   minHeight: "75px",
//                   boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                 }}
//               >
//                 {/* LEFT */}
//                 <div
//                   style={{
//                     borderRight: "1px solid #edf2f7",
//                     paddingRight: "15px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px"
//                   }}
//                 >
//                   <div
//                     className="emp-avatar clickable-avatar"
//                     style={{
//                       width: "38px",
//                       height: "38px",
//                       flexShrink: 0
//                     }}
//                   >
//                     {data.profile_image ? (
//                       <img
//                         src={data.profile_image}
//                         alt={empName}
//                         onClick={() =>
//                           setPreviewImage(data.profile_image)
//                         }
//                         style={{
//                           borderRadius: "50%",
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "cover"
//                         }}
//                       />
//                     ) : (
//                       <div
//                         style={{
//                           width: "100%",
//                           height: "100%",
//                           background: "#f0f0f0",
//                           borderRadius: "50%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontSize: "14px",
//                           fontWeight: "bold"
//                         }}
//                       >
//                         {empName.charAt(0)}
//                       </div>
//                     )}
//                   </div>

//                   <div style={{ overflow: "hidden" }}>
//                     <h3
//                       style={{
//                         margin: 0,
//                         fontSize: "0.95rem",
//                         fontWeight: "700",
//                         display: "-webkit-box",
//                         WebkitLineClamp: "2",
//                         WebkitBoxOrient: "vertical",
//                         overflow: "hidden"
//                       }}
//                     >
//                       {empName}
//                     </h3>
//                     <p style={{ margin: 0, fontSize: "12px" }}>
//                       ID:{" "}
//                       {viewType === "submitted"
//                         ? data.emp_id
//                         : data.empid}
//                     </p>
//                   </div>
//                 </div>

//                 {/* RIGHT */}
//                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                   {data?.years ? (
//                     Object.keys(data.years)
//                       .sort((a, b) => b - a)
//                       .map((year) => (
//                         <div key={year}>
//                           <span>{year}</span>
//                           <div style={{ display: "flex", gap: "5px" }}>
//                             {data.years[year].map((sub) => {
//                               const isLocked =
//                                 sub.workflow_status === "Locked";
//                               const isReview = [
//                                 "Management_Review",
//                                 "Manager_Scoring_Review"
//                               ].includes(sub.workflow_status);

//                               return (
//                                 <button
//                                   key={sub.id}
//                                   onClick={() => {
//                                     const details =
//                                       typeof sub.okr_details === "string"
//                                         ? JSON.parse(sub.okr_details)
//                                         : sub.okr_details;

//                                     setSelected({
//                                       ...sub,
//                                       okr_details: details
//                                     });
//                                   }}
//                                 >
//                                   {sub.quarter}{" "}
//                                   {isLocked
//                                     ? "🔒"
//                                     : isReview
//                                       ? "⏳"
//                                       : "→"}
//                                 </button>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       ))
//                   ) : (
//                     <div>Not Submitted</div>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* IMAGE PREVIEW */}
//         {previewImage && (
//           <div
//             className="image-preview-overlay"
//             onClick={() => setPreviewImage(null)}
//           >
//             <div
//               className="image-preview-box"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <img src={previewImage} alt="Preview" />
//             </div>
//           </div>
//         )}
//       </div>
//     );

//   };









//   const renderEmployeeReviewTab = () => {
//     if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//     const submittedEmpIds = new Set(
//       submissions
//         .filter(sub => sub.quarter === currentQuarter)
//         .map(sub => sub.emp_id)
//     );

//     const submittedEmployees = allEmployees.filter(emp =>
//       submittedEmpIds.has(emp.empid)
//     );

//     const missingEmployees = allEmployees.filter(emp =>
//       !submittedEmpIds.has(emp.empid)
//     );


//     if (selectedReview) {
//       return (
//         <div className="okr-viewer-wrapper animate-fade">
//           <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//           <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//             <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//             <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//             <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//             {[
//               { label: "Key Achievements", data: selectedReview.achievements },
//               { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//               { label: "Skills & Growth", data: selectedReview.skills_growth },
//               { label: "Challenges Faced", data: selectedReview.challenges },
//               { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//               { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//               { label: "Additional Contributions", data: selectedReview.additional_contributions },
//               { label: "Support Needed", data: selectedReview.support_needed }
//             ].map(section => (
//               <div key={section.label} style={{ marginBottom: '25px' }}>
//                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                   {Array.isArray(section.data) ? section.data.map((point, i) => (
//                     point && point.trim() !== "" && (
//                       <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                         {point}
//                       </div>
//                     )
//                   )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="okr-genesis-container animate-fade">
//         <div className="okr-glass-card">
//           <div className="list-header" style={{ marginBottom: '30px' }}>
//             <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//             {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//           </div>
//           <table className="sequencer-table-view">
//             <thead>
//               <tr>
//                 <th>EMPLOYEE NAME</th>
//                 <th>TEAM</th>
//                 <th>PERIOD</th>
//                 <th>SUBMISSION DATE</th>
//                 <th>ACTION</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reviews.length > 0 ? reviews.map(rev => (
//                 <tr key={rev.id}>
//                   <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                   <td>{rev.team}</td>
//                   <td>{rev.review_period}</td>
//                   <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                   <td>
//                     <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                   </td>
//                 </tr>
//               )) : (
//                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   };

//   const renderSubModule = () => {
//     switch (activeTab) {
//       case "OKR Tracker": return renderOKRTrackerTab();
//       case "Employee Self Performance Review": return renderEmployeeReviewTab();
//       case "Manager Review": return renderManagementActionForm("Manager Review");
//       case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//       default: return null;
//     }
//   };

//   return (
//     <div className="pay-module">
//       <div className="pay-nav-grid">
//         {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//           <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//             setActiveTab(tab);
//             setSelected(null);
//             setSelectedReview(null);
//             setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//           }}>
//             {tab.toUpperCase()}
//           </button>
//         ))}
//       </div>


//       <div className="pay-content-area">
//         {renderSubModule()}
//       </div>
//     </div>


//   );
// };

// export default ManagementOKRViewer;












// working

// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl),
//                     fetch(okrUrl),
//                     fetch(empUrl)
//                 ]);

//                 const revData = await revRes.json();
//                 const okrData = await okrRes.json();
//                 const empData = await empRes.json();

//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`
//                 );

//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {
//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };

//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm("Delete this objective?");
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = selected.okr_details.map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//                 }

//                 return newKR;
//             })
//         }));

//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">
//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() =>
//                                             updateOKRStatus("Returned_To_Employee")
//                                         }
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>
//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     onChange={(e) => {
//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };









//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;












// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl),
//                     fetch(okrUrl),
//                     fetch(empUrl)
//                 ]);

//                 const revData = await revRes.json();
//                 const okrData = await okrRes.json();
//                 const empData = await empRes.json();

//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`
//                 );

//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {
//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };

//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm("Delete this objective?");
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = selected.okr_details.map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;   // 🔥 REMOVE FIELD COMPLETELY
//                 }

//                 return newKR;
//             })
//         }));

//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">
//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() =>
//                                             updateOKRStatus("Returned_To_Employee")
//                                         }
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>
//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     onChange={(e) => {
//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };









//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;


















// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl),
//                     fetch(okrUrl),
//                     fetch(empUrl)
//                 ]);

//                 const revData = await revRes.json();
//                 const okrData = await okrRes.json();
//                 const empData = await empRes.json();

//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`
//                 );

//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//    const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//     const updated = { ...selected };

//     if (!updated.okr_details[oIdx].keyResults) {
//         updated.okr_details[oIdx].keyResults = [];
//     }

//     while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending",
//             ar_comment: ""
//         });
//     }

//     updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//     setSelected(updated);

//     // 🔥 AUTO SAVE
//     try {
//         await fetch('/gt-api/update_okr_management.php', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//                 submission_id: updated.id,
//                 okr_details: JSON.stringify(updated.okr_details),
//                 workflow_status: updated.workflow_status
//             })
//         });
//     } catch (err) {
//         console.error("Auto save failed");
//     }
// };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {
//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };

//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm("Delete this objective?");
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//     ...obj,
//     keyResults: obj.keyResults.map(kr => {
//         const newKR = { ...kr };

//         if (nextWorkflowStatus === 'Scoring') {
//             delete newKR.ar_comment;
//         }

//         return newKR;
//     })
// }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">
//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() =>
//                                             updateOKRStatus("Returned_To_Employee")
//                                         }
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>
//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //     selected.workflow_status === "Manager_Scoring_Review";
//                            const isScoreEditable =
//     selected.workflow_status === "Management_Review" ||  // before approval
//     selected.workflow_status === "Scoring" ||            // after approval
//     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     onChange={(e) => {
//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };



//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;

















//working before dynamic


// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl),
//                     fetch(okrUrl),
//                     fetch(empUrl)
//                 ]);

//                 const revData = await revRes.json();
//                 const okrData = await okrRes.json();
//                 const empData = await empRes.json();

//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`);
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`
//                 );

//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {
//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };

//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm("Delete this objective?");
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const handleSaveEditedOKR = async () => {
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">
//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     {/* APPROVE */}
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     {/* RETURN */}
//                                     <button
//                                         className="btn-warning"
//                                         onClick={() =>
//                                             updateOKRStatus("Returned_To_Employee")
//                                         }
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>

//                                     {/* SAVE */}
//                                     <button
//                                         onClick={handleSaveEditedOKR}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#00c853",
//                                             color: "#fff",
//                                             border: "none",
//                                             padding: "10px 16px",
//                                             borderRadius: "6px",
//                                             cursor: "pointer",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "SAVING..." : "SAVE"}
//                                     </button>
//                                 </>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>
//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //     selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     onChange={(e) => {
//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };



//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;





























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revData = await revRes.json();
//                 const okrData = await okrRes.json();
//                 const empData = await empRes.json();

//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//               const res = await fetch(
//     `/gt-api/lock_timeline.php?year=${lockYear}`,
//     {
//         credentials: "include"
//     }
// );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm("Are you sure you want to delete this entire OKR?");
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {
//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };

//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm("Delete this objective?");
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const handleSaveEditedOKR = async () => {
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">
//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     {/* APPROVE */}
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     {/* RETURN */}
//                                     <button
//                                         className="btn-warning"
//                                         onClick={() =>
//                                             updateOKRStatus("Returned_To_Employee")
//                                         }
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>

//                                     {/* SAVE */}
//                                     <button
//                                         onClick={handleSaveEditedOKR}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#00c853",
//                                             color: "#fff",
//                                             border: "none",
//                                             padding: "10px 16px",
//                                             borderRadius: "6px",
//                                             cursor: "pointer",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "SAVING..." : "SAVE"}
//                                     </button>
//                                 </>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>
//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //     selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     onChange={(e) => {
//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };



//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;



















// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

   

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?\n\nPlease note: After deleting, you must click the SAVE button to permanently save this change."
//         );

//         if (!confirmed) return;

//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };
//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //     selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     disabled={isLocked}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };



//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;





























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

   

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?\n\nPlease note: After deleting, you must click the SAVE button to permanently save this change."
//         );

//         if (!confirmed) return;

//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };
//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };












    
// const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning btn-action-return"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     className="btn-save-action"
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             className="btn-add-objective-trigger"
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //     selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 className="btn-delete-objective-inline"
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     disabled={isLocked}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title objective-input-field"
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div className="kr-ar-container">
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             className="kr-ar-toggle-btn"
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             className="kr-ar-textarea-editor"
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div className="okr-genesis-container okr-genesis-dashboard animate-fade">


//                 <div className="dashboard-inner-bounds">

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div className="filter-controls-grid">

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="dashboard-search-input"
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter dashboard-select-dropdown"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             className="dashboard-select-dropdown"
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             className="dashboard-select-dropdown"
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             className="btn-timeline-lock"
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             className="btn-timeline-unlock"
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div className="view-toggle-container">
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             className={`toggle-action-tab submitted-tab ${viewType === "submitted" ? "is-active" : ""}`}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             className={`toggle-action-tab missing-tab ${viewType === "missing" ? "is-active" : ""}`}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div className="employee-cards-grid">
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card enterprise-card-layout"
//                             >
//                                 {/* LEFT */}
//                                 <div className="card-profile-section">
//                                     <div className="emp-avatar clickable-avatar profile-avatar-frame">
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 className="avatar-image-render"
//                                             />
//                                         ) : (
//                                             <div className="avatar-placeholder-render">
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div className="profile-text-group">
//                                         <h3 className="employee-display-name">
//                                             {empName}
//                                         </h3>
//                                         <p className="employee-id-badge">
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div className="card-metrics-section">
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((b, a) => b - a)
//                                             .map((year) => (
//                                                 <div key={year} className="metric-year-group">
//                                                     <span className="metric-year-label">{year}</span>
//                                                     <div className="metric-quarter-actions">
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                     className="quarter-route-btn"
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div className="unsubmitted-status-text">Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };


//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;


































// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {
//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );
//         if (!confirmDelete) return;

//         try {
//             const response = await fetch('/gt-api/delete_okr.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);   // go back to list
//                 window.location.reload(); // refresh data
//             } else {
//                 alert("Error: " + (res.message || "Delete failed"));
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };




//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

   

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?\n\nPlease note: After deleting, you must click the SAVE button to permanently save this change."
//         );

//         if (!confirmed) return;

//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);
//     };
//     // ➕ ADD NEW OBJECTIVE
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {
//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );
//         if (!confirmDelete) return;

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);

//         setSelected(updated);
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(0);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











// const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //      selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     disabled={isLocked}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;




































// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



// const handleDeleteEntireOKR = async () => {

//     const confirmDelete = window.confirm(
//         "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//     );

//     if (!confirmDelete) return;

//     const password = window.prompt(
//         "Enter your Password or Master Password to confirm deletion:"
//     );

//     if (!password) return;

//     try {

//         const authRes = await fetch(
//             "/gt-api/verify_delete_password.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify({ password })
//             }
//         );

//         const authData = await authRes.json();

//         if (!authData.success) {
//             alert("Invalid Password");
//             return;
//         }

//         const response = await fetch(
//             '/gt-api/delete_okr.php',
//             {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             }
//         );

//         const res = await response.json();

//         if (res.success) {
//             alert("OKR deleted successfully!");
//             setSelected(null);
//             window.location.reload();
//         }

//     } catch (err) {
//         alert("Server error while deleting OKR");
//     }
// };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

   

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
// const handleDeleteKR = async (oIdx, kIdx) => {

//     const confirmed = window.confirm(
//         "Are you sure you want to delete this Key Result?"
//     );

//     if (!confirmed) return;

//     const password = window.prompt(
//         "Enter your Password or Master Password:"
//     );

//     if (!password) return;

//     try {

//         const authRes = await fetch(
//             "/gt-api/verify_delete_password.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify({ password })
//             }
//         );

//         const authData = await authRes.json();

//         if (!authData.success) {
//             alert("Invalid Password");
//             return;
//         }

//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);

//     } catch (err) {
//         alert("Authentication failed");
//     }
// };

    
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = async (oIdx) => {

//     const confirmDelete = window.confirm(
//         "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//     );

//     if (!confirmDelete) return;

//     const password = window.prompt(
//         "Enter your Password or Master Password:"
//     );

//     if (!password) return;

//     try {

//         const authRes = await fetch(
//             "/gt-api/verify_delete_password.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify({ password })
//             }
//         );

//         const authData = await authRes.json();

//         if (!authData.success) {
//             alert("Invalid Password");
//             return;
//         }

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);
//         setSelected(updated);

//     } catch (err) {
//         alert("Authentication failed");
//     }
// };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











// const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //      selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     disabled={isLocked}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;



































// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



// const handleDeleteEntireOKR = async () => {

//     const confirmDelete = window.confirm(
//         "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//     );

//     if (!confirmDelete) return;

//     const password = window.prompt(
//         "Enter your Password or Master Password to confirm deletion:"
//     );

//     if (!password) return;

//     try {

//         const authRes = await fetch(
//             "/gt-api/verify_delete_password.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify({ password })
//             }
//         );

//         const authData = await authRes.json();

//         if (!authData.success) {
//             alert("Invalid Password");
//             return;
//         }

//         const response = await fetch(
//             '/gt-api/delete_okr.php',
//             {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id
//                 })
//             }
//         );

//         const res = await response.json();

//         if (res.success) {
//             alert("OKR deleted successfully!");
//             setSelected(null);
//             window.location.reload();
//         }

//     } catch (err) {
//         alert("Server error while deleting OKR");
//     }
// };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };

   

//     const groupedData = submissions.reduce((acc, sub) => {
//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
// const handleDeleteKR = async (oIdx, kIdx) => {

//     const confirmed = window.confirm(
//         "Are you sure you want to delete this Key Result?"
//     );

//     if (!confirmed) return;

//     const password = window.prompt(
//         "Enter your Password or Master Password:"
//     );

//     if (!password) return;

//     try {

//         const authRes = await fetch(
//             "/gt-api/verify_delete_password.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify({ password })
//             }
//         );

//         const authData = await authRes.json();

//         if (!authData.success) {
//             alert("Invalid Password");
//             return;
//         }

//         const updated = { ...selected };
//         updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//         setSelected(updated);

//     } catch (err) {
//         alert("Authentication failed");
//     }
// };

    
//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = async (oIdx) => {

//     const confirmDelete = window.confirm(
//         "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//     );

//     if (!confirmDelete) return;

//     const password = window.prompt(
//         "Enter your Password or Master Password:"
//     );

//     if (!password) return;

//     try {

//         const authRes = await fetch(
//             "/gt-api/verify_delete_password.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify({ password })
//             }
//         );

//         const authData = await authRes.json();

//         if (!authData.success) {
//             alert("Invalid Password");
//             return;
//         }

//         const updated = { ...selected };
//         updated.okr_details.splice(oIdx, 1);
//         setSelected(updated);

//     } catch (err) {
//         alert("Authentication failed");
//     }
// };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("Changes saved successfully!");
//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };
//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











// const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button className="back-btn-cyber" onClick={() => setSelected(null)}>
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {
//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";
//                                 // const isScoreEditable =
//                                 //      selected.workflow_status === "Manager_Scoring_Review";
//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||  // before approval
//                                     selected.workflow_status === "Scoring" ||            // after approval
//                                     selected.workflow_status === "Manager_Scoring_Review";
//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective}
//                                                     disabled={isLocked}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         color: "#fff",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         resize: "none",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;





























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password to confirm deletion:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const response = await fetch(
//                 '/gt-api/delete_okr.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         submission_id: selected.id
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);
//                 window.location.reload();
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = async (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?"
//         );

//         if (!confirmed) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = { ...selected };
//             updated.okr_details[oIdx].keyResults.splice(kIdx, 1);
//             setSelected(updated);

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };


//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = async (oIdx) => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = { ...selected };
//             updated.okr_details.splice(oIdx, 1);
//             setSelected(updated);

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     const updated = { ...selected };
//                                                     updated.okr_details.splice(oIdx, 1);
//                                                     setSelected(updated);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(0);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;


































// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password to confirm deletion:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const response = await fetch(
//                 '/gt-api/delete_okr.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         submission_id: selected.id
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);
//                 window.location.reload();
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = async (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?"
//         );

//         if (!confirmed) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = {
//                 ...selected,
//                 okr_details: [...selected.okr_details]
//             };

//             updated.okr_details[oIdx].keyResults = [
//                 ...updated.okr_details[oIdx].keyResults
//             ];

//             updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//             const response = await fetch(
//                 "/gt-api/update_okr_management.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({
//                         submission_id: updated.id,
//                         okr_details: JSON.stringify(updated.okr_details),
//                         workflow_status: updated.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(updated);
//                 alert("Key Result deleted successfully!");
//             } else {
//                 alert("Failed to delete Key Result.");
//             }

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = async (oIdx) => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = {
//                 ...selected,
//                 okr_details: [...selected.okr_details]
//             };

//             updated.okr_details.splice(oIdx, 1);

//             const response = await fetch(
//                 "/gt-api/update_okr_management.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({
//                         submission_id: updated.id,
//                         okr_details: JSON.stringify(updated.okr_details),
//                         workflow_status: updated.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(updated);
//                 alert("Objective deleted successfully!");
//             } else {
//                 alert("Failed to delete objective.");
//             }

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(0);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;




























// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password to confirm deletion:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const response = await fetch(
//                 '/gt-api/delete_okr.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         submission_id: selected.id
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);
//                 window.location.reload();
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = async (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?"
//         );

//         if (!confirmed) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = {
//                 ...selected,
//                 okr_details: [...selected.okr_details]
//             };

//             updated.okr_details[oIdx].keyResults = [
//                 ...updated.okr_details[oIdx].keyResults
//             ];

//             updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//             const response = await fetch(
//                 "/gt-api/update_okr_management.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({
//                         submission_id: updated.id,
//                         okr_details: JSON.stringify(updated.okr_details),
//                         workflow_status: updated.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(updated);
//                 alert("Key Result deleted successfully!");
//             } else {
//                 alert("Failed to delete Key Result.");
//             }

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//         alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = async (oIdx) => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = {
//                 ...selected,
//                 okr_details: [...selected.okr_details]
//             };

//             updated.okr_details.splice(oIdx, 1);

//             const response = await fetch(
//                 "/gt-api/update_okr_management.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({
//                         submission_id: updated.id,
//                         okr_details: JSON.stringify(updated.okr_details),
//                         workflow_status: updated.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(updated);
//                 alert("Objective deleted successfully!");
//             } else {
//                 alert("Failed to delete objective.");
//             }

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(0);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;

































// import React, { useState, useEffect } from 'react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = async () => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to permanently delete this entire OKR?\n\nThis action cannot be undone."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password to confirm deletion:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const response = await fetch(
//                 '/gt-api/delete_okr.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         submission_id: selected.id
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 alert("OKR deleted successfully!");
//                 setSelected(null);
//                 window.location.reload();
//             }

//         } catch (err) {
//             alert("Server error while deleting OKR");
//         }
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = async (oIdx, kIdx) => {

//         const confirmed = window.confirm(
//             "Are you sure you want to delete this Key Result?"
//         );

//         if (!confirmed) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = {
//                 ...selected,
//                 okr_details: [...selected.okr_details]
//             };

//             updated.okr_details[oIdx].keyResults = [
//                 ...updated.okr_details[oIdx].keyResults
//             ];

//             updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//             const response = await fetch(
//                 "/gt-api/update_okr_management.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({
//                         submission_id: updated.id,
//                         okr_details: JSON.stringify(updated.okr_details),
//                         workflow_status: updated.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(updated);
//                 alert("Key Result deleted successfully!");
//             } else {
//                 alert("Failed to delete Key Result.");
//             }

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//         alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = async (oIdx) => {

//         const confirmDelete = window.confirm(
//             "Are you sure you want to delete this objective?\n\nAll associated Key Results will also be removed."
//         );

//         if (!confirmDelete) return;

//         const password = window.prompt(
//             "Enter your Password or Master Password:"
//         );

//         if (!password) return;

//         try {

//             const authRes = await fetch(
//                 "/gt-api/verify_delete_password.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({ password })
//                 }
//             );

//             const authData = await authRes.json();

//             if (!authData.success) {
//                 alert("Invalid Password");
//                 return;
//             }

//             const updated = {
//                 ...selected,
//                 okr_details: [...selected.okr_details]
//             };

//             updated.okr_details.splice(oIdx, 1);

//             const response = await fetch(
//                 "/gt-api/update_okr_management.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     headers: {
//                         "Content-Type": "application/json"
//                     },
//                     body: JSON.stringify({
//                         submission_id: updated.id,
//                         okr_details: JSON.stringify(updated.okr_details),
//                         workflow_status: updated.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(updated);
//                 alert("Objective deleted successfully!");
//             } else {
//                 alert("Failed to delete objective.");
//             }

//         } catch (err) {
//             alert("Authentication failed");
//         }
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                             >
//                                 🗑
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     marginRight: "10px",
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px"
//                                                 }}
//                                             >
//                                                 🗑
//                                             </button>
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 🗑
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus={activeAR.includes(`${oIdx}-${kIdx}`)}
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(null);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//         </div>


//     );
// };

// export default ManagementOKRViewer;































// import React, { useState, useEffect } from 'react';
// import { Trash2 } from 'lucide-react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const [passwordModal, setPasswordModal] = useState({
//         isOpen: false,
//         title: "",
//         onConfirm: null
//     });
//     const [modalPassword, setModalPassword] = useState("");
//     const [showModalPassword, setShowModalPassword] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = () => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to permanently delete this entire OKR? This action cannot be undone.",
//             title: "Enter your Password or Master Password to confirm deletion:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     alert("Password is required.");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         alert("Invalid Password");
//                         return;
//                     }

//                     const response = await fetch(
//                         '/gt-api/delete_okr.php',
//                         {
//                             method: 'POST',
//                             credentials: "include",
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify({
//                                 submission_id: selected.id
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         alert("OKR deleted successfully!");
//                         setSelected(null);
//                         window.location.reload();
//                     }

//                 } catch (err) {
//                     alert("Server error while deleting OKR");
//                 }
//             }
//         });
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this Key Result?",
//             title: "Enter your Password or Master Password to delete this Key Result:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     alert("Password is required.");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         alert("Invalid Password");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details[oIdx].keyResults = [
//                         ...updated.okr_details[oIdx].keyResults
//                     ];

//                     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         alert("Key Result deleted successfully!");
//                     } else {
//                         alert("Failed to delete Key Result.");
//                     }

//                 } catch (err) {
//                     alert("Authentication failed");
//                 }
//             }
//         });
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//         alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this objective? All associated Key Results will also be removed.",
//             title: "Enter your Password or Master Password to delete this objective:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     alert("Password is required.");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         alert("Invalid Password");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details.splice(oIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         alert("Objective deleted successfully!");
//                     } else {
//                         alert("Failed to delete objective.");
//                     }

//                 } catch (err) {
//                     alert("Authentication failed");
//                 }
//             }
//         });
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const renderPasswordModal = () => {
//         if (!passwordModal.isOpen) return null;

//         return (
//             <div className="delete-password-modal-overlay">
//                 <div className="delete-password-modal-card">
//                     <h3 className="delete-password-modal-title">
//                         ⚠️ Delete Confirmation
//                     </h3>
                    
//                     {passwordModal.confirmMessage && (
//                         <p className="delete-password-modal-msg">
//                             {passwordModal.confirmMessage}
//                         </p>
//                     )}

//                     <p className="delete-password-modal-label">
//                         {passwordModal.title}
//                     </p>
                    
//                     <div className="delete-password-modal-input-wrapper">
//                         <input
//                             type={showModalPassword ? "text" : "password"}
//                             placeholder="Enter password..."
//                             value={modalPassword}
//                             onChange={(e) => setModalPassword(e.target.value)}
//                             className="delete-password-modal-input"
//                             autoFocus
//                             onKeyDown={(e) => {
//                                 if (e.key === "Enter") {
//                                     passwordModal.onConfirm(modalPassword);
//                                 }
//                             }}
//                         />
//                         <button
//                             type="button"
//                             onClick={() => setShowModalPassword(!showModalPassword)}
//                             className="delete-password-modal-toggle-btn"
//                         >
//                             {showModalPassword ? (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
//                             ) : (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
//                             )}
//                         </button>
//                     </div>

//                     <div className="delete-password-modal-btn-group">
//                         <button
//                             type="button"
//                             onClick={() => {
//                                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });
//                                 setModalPassword("");
//                                 setShowModalPassword(false);
//                             }}
//                             className="delete-password-modal-cancel-btn"
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="button"
//                             onClick={() => passwordModal.onConfirm(modalPassword)}
//                             className="delete-password-modal-confirm-btn"
//                         >
//                             Delete
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                                 title="Delete OKR"
//                             >
//                                 <Trash2 size={16} />
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>

//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px",
//                                                     marginLeft: "15px",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     padding: "0"
//                                                 }}
//                                             >
//                                                 <Trash2 size={16} />
//                                             </button>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 <Trash2 size={16} />
                                                                
//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus={activeAR.includes(`${oIdx}-${kIdx}`)}
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(null);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//             {renderPasswordModal()}
//         </div>


//     );
// };

// export default ManagementOKRViewer;


































// import React, { useState, useEffect } from 'react';
// import { createPortal } from 'react-dom';
// import { Trash2 } from 'lucide-react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const [passwordModal, setPasswordModal] = useState({
//         isOpen: false,
//         title: "",
//         onConfirm: null
//     });
//     const [modalPassword, setModalPassword] = useState("");
//     const [showModalPassword, setShowModalPassword] = useState(false);

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = () => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to permanently delete this entire OKR? This action cannot be undone.",
//             title: "Enter your Password or Master Password to confirm deletion:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     alert("Password is required.");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         alert("Invalid Password");
//                         return;
//                     }

//                     const response = await fetch(
//                         '/gt-api/delete_okr.php',
//                         {
//                             method: 'POST',
//                             credentials: "include",
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify({
//                                 submission_id: selected.id
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         alert("OKR deleted successfully!");
//                         setSelected(null);
//                         window.location.reload();
//                     }

//                 } catch (err) {
//                     alert("Server error while deleting OKR");
//                 }
//             }
//         });
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this Key Result?",
//             title: "Enter your Password or Master Password to delete this Key Result:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     alert("Password is required.");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         alert("Invalid Password");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details[oIdx].keyResults = [
//                         ...updated.okr_details[oIdx].keyResults
//                     ];

//                     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         alert("Key Result deleted successfully!");
//                     } else {
//                         alert("Failed to delete Key Result.");
//                     }

//                 } catch (err) {
//                     alert("Authentication failed");
//                 }
//             }
//         });
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//         alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this objective? All associated Key Results will also be removed.",
//             title: "Enter your Password or Master Password to delete this objective:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     alert("Password is required.");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         alert("Invalid Password");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details.splice(oIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         alert("Objective deleted successfully!");
//                     } else {
//                         alert("Failed to delete objective.");
//                     }

//                 } catch (err) {
//                     alert("Authentication failed");
//                 }
//             }
//         });
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const renderPasswordModal = () => {
//         if (!passwordModal.isOpen) return null;

//         return createPortal(
//             <div className="delete-password-modal-overlay">
//                 <div className="delete-password-modal-card">
//                     <h3 className="delete-password-modal-title">
//                         ⚠️ Delete Confirmation
//                     </h3>

//                     {passwordModal.confirmMessage && (
//                         <p className="delete-password-modal-msg">
//                             {passwordModal.confirmMessage}
//                         </p>
//                     )}

//                     <p className="delete-password-modal-label">
//                         {passwordModal.title}
//                     </p>

//                     <div className="delete-password-modal-input-wrapper">
//                         <input
//                             type={showModalPassword ? "text" : "password"}
//                             placeholder="Enter password..."
//                             value={modalPassword}
//                             onChange={(e) => setModalPassword(e.target.value)}
//                             className="delete-password-modal-input"
//                             autoFocus
//                             onKeyDown={(e) => {
//                                 if (e.key === "Enter") {
//                                     passwordModal.onConfirm(modalPassword);
//                                 }
//                             }}
//                         />
//                         <button
//                             type="button"
//                             onClick={() => setShowModalPassword(!showModalPassword)}
//                             className="delete-password-modal-toggle-btn"
//                         >
//                             {showModalPassword ? (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
//                             ) : (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
//                             )}
//                         </button>
//                     </div>

//                     <div className="delete-password-modal-btn-group">
//                         <button
//                             type="button"
//                             onClick={() => {
//                                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });
//                                 setModalPassword("");
//                                 setShowModalPassword(false);
//                             }}
//                             className="delete-password-modal-cancel-btn"
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="button"
//                             onClick={() => passwordModal.onConfirm(modalPassword)}
//                             className="delete-password-modal-confirm-btn"
//                         >
//                             Delete
//                         </button>
//                     </div>
//                 </div>
//             </div>,
//             document.body
//         );
//     };

//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {selected.workflow_status === "Management_Review" && (
//                                 <>
//                                     <button
//                                         className="btn-approve-cyan"
//                                         onClick={() => updateOKRStatus("Scoring")}
//                                         disabled={isUpdating}
//                                     >
//                                         {isUpdating ? "PROCESSING..." : "APPROVE"}
//                                     </button>

//                                     <button
//                                         className="btn-warning"
//                                         onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                         disabled={isUpdating}
//                                         style={{
//                                             marginLeft: "10px",
//                                             background: "#ff9800",
//                                             color: "#000",
//                                             fontWeight: "600"
//                                         }}
//                                     >
//                                         {isUpdating ? "RETURNING..." : "RETURN TO EMPLOYEE"}
//                                     </button>
//                                 </>
//                             )}

//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     style={{
//                                         marginLeft: "10px",
//                                         background: "#00c853",
//                                         color: "#fff",
//                                         border: "none",
//                                         padding: "10px 16px",
//                                         borderRadius: "6px",
//                                         cursor: "pointer",
//                                         fontWeight: "600"
//                                     }}
//                                 >
//                                     {isUpdating ? "SAVING..." : "SAVE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-approve-cyan"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                                 title="Delete OKR"
//                             >
//                                 <Trash2 size={16} />
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">


//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 margin: "10px",
//                                 padding: "10px 16px",
//                                 background: "#00bcd4",
//                                 color: "#000",
//                                 border: "none",
//                                 borderRadius: "6px",
//                                 cursor: "pointer",
//                                 fontWeight: "600"
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>

//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px",
//                                                     marginLeft: "15px",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     padding: "0"
//                                                 }}
//                                             >
//                                                 <Trash2 size={16} />
//                                             </button>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 <Trash2 size={16} />

//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus={activeAR.includes(`${oIdx}-${kIdx}`)}
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(null);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//             {renderPasswordModal()}
//         </div>


//     );
// };

// export default ManagementOKRViewer;




























// import React, { useState, useEffect } from 'react';
// import { createPortal } from 'react-dom';
// import { Trash2 } from 'lucide-react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);

//     const [passwordModal, setPasswordModal] = useState({
//         isOpen: false,
//         title: "",
//         onConfirm: null
//     });
//     const [modalPassword, setModalPassword] = useState("");
//     const [showModalPassword, setShowModalPassword] = useState(false);

//     const [customAlert, setCustomAlert] = useState({
//         isOpen: false,
//         type: "error", // "success" | "error"
//         message: "",
//         onClose: null
//     });

//     const showMessage = (message, type = "success", onClose = null) => {
//         setCustomAlert({
//             isOpen: true,
//             type,
//             message,
//             onClose
//         });
//     };

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = () => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to permanently delete this entire OKR? This action cannot be undone.",
//             title: "Enter your Password or Master Password to confirm deletion:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     showMessage("Password is required.", "error");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         showMessage("Invalid Password", "error");
//                         return;
//                     }

//                     const response = await fetch(
//                         '/gt-api/delete_okr.php',
//                         {
//                             method: 'POST',
//                             credentials: "include",
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify({
//                                 submission_id: selected.id
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         showMessage("OKR deleted successfully!", "success", () => {
//                             setSelected(null);
//                             window.location.reload();
//                         });
//                     }

//                 } catch (err) {
//                     showMessage("Server error while deleting OKR", "error");
//                 }
//             }
//         });
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(`${activeTab} submitted successfully!`);
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this Key Result?",
//             title: "Enter your Password or Master Password to delete this Key Result:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     showMessage("Password is required.", "error");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         showMessage("Invalid Password", "error");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details[oIdx].keyResults = [
//                         ...updated.okr_details[oIdx].keyResults
//                     ];

//                     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         showMessage("Key Result deleted successfully!", "success");
//                     } else {
//                         showMessage("Failed to delete Key Result.", "error");
//                     }

//                 } catch (err) {
//                     showMessage("Authentication failed", "error");
//                 }
//             }
//         });
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//         alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this objective? All associated Key Results will also be removed.",
//             title: "Enter your Password or Master Password to delete this objective:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     showMessage("Password is required.", "error");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         showMessage("Invalid Password", "error");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details.splice(oIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         showMessage("Objective deleted successfully!", "success");
//                     } else {
//                         showMessage("Failed to delete objective.", "error");
//                     }

//                 } catch (err) {
//                     showMessage("Authentication failed", "error");
//                 }
//             }
//         });
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const renderCustomAlertModal = () => {
//         if (!customAlert.isOpen) return null;

//         return createPortal(
//             <div className="custom-alert-modal-overlay">
//                 <div className="custom-alert-modal-card animate-fade">
//                     <div className="custom-alert-modal-icon">
//                         {customAlert.type === "success" ? (
//                             <div className="alert-icon-success">✓</div>
//                         ) : (
//                             <div className="alert-icon-error">✕</div>
//                         )}
//                     </div>
//                     <h3 className="custom-alert-modal-title">
//                         {customAlert.type === "success" ? "Success" : "Error"}
//                     </h3>
//                     <p className="custom-alert-modal-msg">{customAlert.message}</p>
//                     <button
//                         type="button"
//                         className="custom-alert-modal-ok-btn"
//                         onClick={() => {
//                             const closeHandler = customAlert.onClose;
//                             setCustomAlert({ isOpen: false, type: "error", message: "", onClose: null });
//                             if (closeHandler) closeHandler();
//                         }}
//                     >
//                         OK
//                     </button>
//                 </div>
//             </div>,
//             document.body
//         );
//     };


//     const renderPasswordModal = () => {
//         if (!passwordModal.isOpen) return null;

//         return createPortal(
//             <div className="delete-password-modal-overlay">
//                 <div className="delete-password-modal-card">
//                     <h3 className="delete-password-modal-title">
//                         ⚠️ Delete Confirmation
//                     </h3>

//                     {passwordModal.confirmMessage && (
//                         <p className="delete-password-modal-msg">
//                             {passwordModal.confirmMessage}
//                         </p>
//                     )}

//                     <p className="delete-password-modal-label">
//                         {passwordModal.title}
//                     </p>

//                     <div className="delete-password-modal-input-wrapper">
//                         <input
//                             type={showModalPassword ? "text" : "password"}
//                             placeholder="Enter password..."
//                             value={modalPassword}
//                             onChange={(e) => setModalPassword(e.target.value)}
//                             className="delete-password-modal-input"
//                             autoFocus
//                             onKeyDown={(e) => {
//                                 if (e.key === "Enter") {
//                                     passwordModal.onConfirm(modalPassword);
//                                 }
//                             }}
//                         />
//                         <button
//                             type="button"
//                             onClick={() => setShowModalPassword(!showModalPassword)}
//                             className="delete-password-modal-toggle-btn"
//                         >
//                             {showModalPassword ? (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
//                             ) : (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
//                             )}
//                         </button>
//                     </div>

//                     <div className="delete-password-modal-btn-group">
//                         <button
//                             type="button"
//                             onClick={() => {
//                                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });
//                                 setModalPassword("");
//                                 setShowModalPassword(false);
//                             }}
//                             className="delete-password-modal-cancel-btn"
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="button"
//                             onClick={() => passwordModal.onConfirm(modalPassword)}
//                             className="delete-password-modal-confirm-btn"
//                         >
//                             Delete
//                         </button>
//                     </div>
//                 </div>
//             </div>,
//             document.body
//         );
//     };

//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         <div className="form-group">
//                             <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>SELECT EMPLOYEE</label>
//                             <select
//                                 className="modern-select"
//                                 style={{ width: '100%', padding: '10px' }}
//                                 value={mgmtSelection.emp_id}
//                                 onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                             >
//                                 <option value="">-- Choose Employee --</option>
//                                 {allEmployees?.map(emp => (
//                                     <option key={emp.empid} value={emp.empid}>{emp.full_name} ({emp.team})</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {/* 1) Save Progress */}
//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     title="Save the progress of your OKR draft changes"
//                                 >
//                                     {isUpdating ? "SAVING..." : "Save Progress"}
//                                 </button>
//                             )}

//                             {/* 2) Send it for AR Updation */}
//                             {selected.workflow_status === "Management_Review" && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                     disabled={isUpdating}
//                                     title="Send the OKR back to the employee for Annual Review (AR) updation"
//                                 >
//                                     {isUpdating ? "RETURNING..." : "Send it for AR Updation"}
//                                 </button>
//                             )}

//                             {/* 3) Approve and Send for Grade Scoring */}
//                             {selected.workflow_status === "Management_Review" && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={() => updateOKRStatus("Scoring")}
//                                     disabled={isUpdating}
//                                     title="Approve the current OKR and send it for grade scoring"
//                                 >
//                                     {isUpdating ? "PROCESSING..." : "Approve and Send for Grade Scoring"}
//                                 </button>
//                             )}

//                             {/* 4) Finalize (for Manager_Scoring_Review) */}
//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                     title="Finalize the OKR and sign off"
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                                 title="Delete OKR"
//                             >
//                                 <Trash2 size={16} />
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">
//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 alignSelf: "flex-start",
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 gap: "6px",
//                                 padding: "8px 16px",
//                                 // background: "linear-gradient(135deg, #00bcd4, #00838f)",
//                                 background: "linear-gradient(rgb(29 203 225), rgb(35 199 214))",
//                                 color: "#ffffff",
//                                 border: "none",
//                                 borderRadius: "50px",
//                                 cursor: "pointer",
//                                 fontWeight: "700",
//                                 fontSize: "13px",
//                                 letterSpacing: "0.5px",
//                                 boxShadow: "0 4px 12px rgba(0, 188, 212, 0.25)",
//                                 transition: "all 0.3s ease",
//                                 marginTop: "10px",
//                                 marginBottom: "5px"
//                             }}
//                             onMouseOver={(e) => {
//                                 e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 188, 212, 0.4)";
//                                 e.currentTarget.style.transform = "translateY(-1px)";
//                             }}
//                             onMouseOut={(e) => {
//                                 e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 188, 212, 0.25)";
//                                 e.currentTarget.style.transform = "none";
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>

//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px",
//                                                     marginLeft: "15px",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     padding: "0"
//                                                 }}
//                                             >
//                                                 <Trash2 size={16} />
//                                             </button>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 <Trash2 size={16} />

//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus={activeAR.includes(`${oIdx}-${kIdx}`)}
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(null);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//             {renderPasswordModal()}
//             {renderCustomAlertModal()}
//         </div>


//     );
// };

// export default ManagementOKRViewer;








































// import React, { useState, useEffect, useRef } from 'react';
// import { createPortal } from 'react-dom';
// import { Trash2 } from 'lucide-react';
// import '../styles/OKRTracker.css';

// const ManagementOKRViewer = ({ userRole, managedDept }) => {

//     const [lockedQuarters, setLockedQuarters] = useState({});

//     const getFY = (date) => {
//         const m = date.getMonth() + 1;
//         const y = date.getFullYear();
//         return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//     };
//     const [lockYear, setLockYear] = useState(getFY(new Date()));

//     const [lockQuarter, setLockQuarter] = useState("Quarter 1");
//     const [isTimelineLocked, setIsTimelineLocked] = useState(false);
//     const [activeTab, setActiveTab] = useState("OKR Tracker");
//     const [loading, setLoading] = useState(true);

//     // OKR Tracker States
//     const [submissions, setSubmissions] = useState([]);
//     const [selected, setSelected] = useState(null);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
//     const [activeAR, setActiveAR] = useState([]);

//     // Employee Review States
//     const [reviews, setReviews] = useState([]);
//     const [selectedReview, setSelectedReview] = useState(null);

//     // Management Action States
//     const [allEmployees, setAllEmployees] = useState([]);
//     const [mgmtSelection, setMgmtSelection] = useState({
//         emp_id: "",
//         content: "",
//         accomplished: "",
//         improvements: ""
//     });
//     const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);
//     const [mgmtEmpSearch, setMgmtEmpSearch] = useState("");
//     const [showOnlyProbation, setShowOnlyProbation] = useState(false);

//     const [passwordModal, setPasswordModal] = useState({
//         isOpen: false,
//         title: "",
//         onConfirm: null
//     });
//     const [modalPassword, setModalPassword] = useState("");
//     const [showModalPassword, setShowModalPassword] = useState(false);

//     const [customAlert, setCustomAlert] = useState({
//         isOpen: false,
//         type: "error", // "success" | "error"
//         message: "",
//         onClose: null
//     });

//     const showMessage = (message, type = "success", onClose = null) => {
//         setCustomAlert({
//             isOpen: true,
//             type,
//             message,
//             onClose
//         });
//     };

//     const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

//     // Hardcoded Message Template
//     const PROBATION_MESSAGE = `Hello,

// Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

// Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

// Congratulations and wish you the best.

// Thanks,
// Genesis Tech Engineers Pvt. Ltd.`;

//     useEffect(() => {
//         const fetchData = async () => {
//             setLoading(true);
//             try {
//                 const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
//                 console.log("userRole =", userRole);
//                 console.log("managedDept =", managedDept);
//                 const queryParams = `role=${userRole}&managedDept=${deptParam}`;

//                 const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
//                 const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
//                 const empUrl = `/gt-api/get_all_staff.php`;

//                 const [revRes, okrRes, empRes] = await Promise.all([
//                     fetch(revUrl, { credentials: "include" }),
//                     fetch(okrUrl, { credentials: "include" }),
//                     fetch(empUrl, { credentials: "include" })
//                 ]);

//                 const revText = await revRes.text();
//                 const okrText = await okrRes.text();
//                 const empText = await empRes.text();


//                 const revData = JSON.parse(revText);
//                 const okrData = JSON.parse(okrText);
//                 const empData = JSON.parse(empText);



//                 if (revData.success && revData.data.length > 0) {
//                     setReviews(revData.data);
//                 } else {
//                     const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
//                         credentials: "include"
//                     });
//                     const fallbackData = await fallbackRes.json();
//                     if (fallbackData.success) setReviews(fallbackData.data);
//                 }

//                 setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
//                 console.log("SETTING SUBMISSIONS:", okrData.data);
//                 console.log("OKR DATA:", okrData.data);
//                 okrData.data.forEach((item) => {
//                     console.log("ID:", item.id);
//                     console.log(item.okr_details);
//                 });
//                 console.log("FIRST SUBMISSION:", okrData.data[0]);

//                 if (empData.success && Array.isArray(empData.data)) {
//                     setAllEmployees(empData.data);
//                 } else {
//                     setAllEmployees([]);
//                 }

//             } catch (err) {
//                 console.error("❌ Fetch error:", err);
//                 setAllEmployees([]);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [userRole, managedDept]);

//     useEffect(() => {
//         const fetchLocks = async () => {
//             try {
//                 const res = await fetch(
//                     `/gt-api/lock_timeline.php?year=${lockYear}`,
//                     {
//                         credentials: "include"
//                     }
//                 );
//                 const data = await res.json();

//                 console.log("LOCK DATA:", data); // debug

//                 if (data.success) {
//                     setLockedQuarters(data.locks || {});
//                 }
//             } catch (err) {
//                 console.error("LOCK FETCH ERROR:", err);
//             }
//         };

//         fetchLocks();
//     }, [lockYear]);


//     // 🔍 Search + Filter states
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDept, setSelectedDept] = useState("");
//     const [previewImage, setPreviewImage] = useState(null);
//     const [viewType, setViewType] = useState("submitted");
//     const getCurrentQuarter = () => {
//         const month = new Date().getMonth() + 1;

//         if (month >= 4 && month <= 6) return "Quarter 1";
//         if (month >= 7 && month <= 9) return "Quarter 2";
//         if (month >= 10 && month <= 12) return "Quarter 3";
//         return "Quarter 4";
//     };

//     const currentQuarter = getCurrentQuarter();



//     const handleDeleteEntireOKR = () => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to permanently delete this entire OKR? This action cannot be undone.",
//             title: "Enter your Password or Master Password to confirm deletion:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     showMessage("Password is required.", "error");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         showMessage("Invalid Password", "error");
//                         return;
//                     }

//                     const response = await fetch(
//                         '/gt-api/delete_okr.php',
//                         {
//                             method: 'POST',
//                             credentials: "include",
//                             headers: { 'Content-Type': 'application/json' },
//                             body: JSON.stringify({
//                                 submission_id: selected.id
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         showMessage("OKR deleted successfully!", "success", () => {
//                             setSelected(null);
//                             window.location.reload();
//                         });
//                     }

//                 } catch (err) {
//                     showMessage("Server error while deleting OKR", "error");
//                 }
//             }
//         });
//     };


//     const handleManagementSubmit = async () => {
//         const isManagerReview = activeTab === "Manager Review";
//         const isProbation = activeTab === "Probation Period Feedback";

//         // Validation: If probation, we don't need to check "content" state since it's hardcoded
//         const hasContent = isManagerReview
//             ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
//             : (isProbation ? true : mgmtSelection.content.trim());

//         if (!mgmtSelection.emp_id || !hasContent) {
//             alert("Please select an employee and fill in all required fields.");
//             return;
//         }

//         const apiEndpoint = isProbation
//             ? '/gt-api/save_probation_notice.php'
//             : '/gt-api/save_management_notice.php';

//         setIsSubmittingMgmt(true);
//         try {
//             let finalContent = "";
//             if (isManagerReview) {
//                 finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
//             } else if (isProbation) {
//                 finalContent = PROBATION_MESSAGE;
//             } else {
//                 finalContent = mgmtSelection.content;
//             }

//             const response = await fetch(apiEndpoint, {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     emp_id: mgmtSelection.emp_id,
//                     content: finalContent,
//                     type: activeTab,
//                     sender_role: userRole
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 alert(res.message || `${activeTab} submitted successfully!`);
//                 if (isProbation) {
//                     setAllEmployees(prev => prev.map(emp => {
//                         if (String(emp.empid) === String(mgmtSelection.emp_id)) {
//                             return { ...emp, probation_status: 'Permanent', probation_feedback_sent_at: new Date().toISOString() };
//                         }
//                         return emp;
//                     }));
//                 }
//                 setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//             } else {
//                 alert("Error: " + (res.message || "Unknown error"));
//             }
//         } catch (err) {
//             alert("Failed to connect to the server.");
//         } finally {
//             setIsSubmittingMgmt(false);
//         }
//     };


//     console.log("========== SUBMISSIONS ==========");
//     console.log(submissions);

//     submissions.forEach(s => {
//         console.log(
//             s.id,
//             s.emp_name,
//             s.workflow_status,
//             s.quarter,
//             s.year
//         );
//     });
//     const groupedData = submissions.reduce((acc, sub) => {

//         const name = sub.emp_name;
//         const year = sub.year;

//         if (!acc[name]) {
//             acc[name] = {
//                 emp_id: sub.emp_id,
//                 years: {},
//                 profile_image: sub.profile_image
//             };
//         }

//         if (!acc[name].years[year]) acc[name].years[year] = [];
//         acc[name].years[year].push(sub);

//         return acc;
//     }, {});
//     console.log("GROUPED DATA", groupedData);


//     // 🔍 Apply search + department filter
//     const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
//         const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

//         const empDept =
//             data.years[Object.keys(data.years)[0]][0].department || "";

//         const matchesDept = selectedDept ? empDept === selectedDept : true;

//         return matchesSearch && matchesDept;
//     });

//     const handleStatusChange = async (oIdx, kIdx, newStatus) => {
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

//         setSelected(updated);

//         // 🔥 AUTO SAVE
//         try {
//             await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: updated.id,
//                     okr_details: JSON.stringify(updated.okr_details),
//                     workflow_status: updated.workflow_status
//                 })
//             });
//         } catch (err) {
//             console.error("Auto save failed");
//         }
//     };

//     const showEditWarning = () => {
//         if (!hasShownEditWarning) {
//             alert("You have modified the OKR. Click SAVE to persist your changes.");
//             setHasShownEditWarning(true);
//         }
//     };

//     const handleKRTextChange = (oIdx, kIdx, newText) => {
//         showEditWarning();
//         const updated = { ...selected };

//         if (!updated.okr_details[oIdx].keyResults) {
//             updated.okr_details[oIdx].keyResults = [];
//         }

//         while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//             updated.okr_details[oIdx].keyResults.push({
//                 text: "",
//                 result: "Pending",
//                 ar_comment: ""
//             });
//         }

//         updated.okr_details[oIdx].keyResults[kIdx].text = newText;

//         setSelected(updated);
//     };

//     // ❌ DELETE KEY RESULT
//     const handleDeleteKR = (oIdx, kIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this Key Result?",
//             title: "Enter your Password or Master Password to delete this Key Result:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     showMessage("Password is required.", "error");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         showMessage("Invalid Password", "error");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details[oIdx].keyResults = [
//                         ...updated.okr_details[oIdx].keyResults
//                     ];

//                     updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         showMessage("Key Result deleted successfully!", "success");
//                     } else {
//                         showMessage("Failed to delete Key Result.", "error");
//                     }

//                 } catch (err) {
//                     showMessage("Authentication failed", "error");
//                 }
//             }
//         });
//     };

//     const handleAddObjective = () => {
//         const updated = { ...selected };

//         if (!updated.okr_details) updated.okr_details = [];

//         updated.okr_details.push({
//             objective: "New Objective",
//             keyResults: [{ text: "", result: "Pending" }]
//         });

//         setSelected(updated);
//         alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
//     };

//     // ➕ ADD NEW KEY RESULT
//     const handleAddKR = (oIdx) => {
//         const updated = { ...selected };

//         updated.okr_details[oIdx].keyResults.push({
//             text: "",
//             result: "Pending"
//         });

//         setSelected(updated);
//     };

//     const handleDeleteObjective = (oIdx) => {

//         setModalPassword("");
//         setShowModalPassword(false);
//         setPasswordModal({
//             isOpen: true,
//             confirmMessage: "Are you sure you want to delete this objective? All associated Key Results will also be removed.",
//             title: "Enter your Password or Master Password to delete this objective:",
//             onConfirm: async (password) => {
//                 if (!password) {
//                     showMessage("Password is required.", "error");
//                     return;
//                 }

//                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

//                 try {

//                     const authRes = await fetch(
//                         "/gt-api/verify_delete_password.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({ password })
//                         }
//                     );

//                     const authData = await authRes.json();

//                     if (!authData.success) {
//                         showMessage("Invalid Password", "error");
//                         return;
//                     }

//                     const updated = {
//                         ...selected,
//                         okr_details: [...selected.okr_details]
//                     };

//                     updated.okr_details.splice(oIdx, 1);

//                     const response = await fetch(
//                         "/gt-api/update_okr_management.php",
//                         {
//                             method: "POST",
//                             credentials: "include",
//                             headers: {
//                                 "Content-Type": "application/json"
//                             },
//                             body: JSON.stringify({
//                                 submission_id: updated.id,
//                                 okr_details: JSON.stringify(updated.okr_details),
//                                 workflow_status: updated.workflow_status
//                             })
//                         }
//                     );

//                     const res = await response.json();

//                     if (res.success) {
//                         setSelected(updated);
//                         showMessage("Objective deleted successfully!", "success");
//                     } else {
//                         showMessage("Failed to delete objective.", "error");
//                     }

//                 } catch (err) {
//                     showMessage("Authentication failed", "error");
//                 }
//             }
//         });
//     };

//     const handleSaveEditedOKR = async () => {
//         const confirmed = window.confirm(
//             "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
//         );

//         if (!confirmed) return;
//         try {
//             setIsUpdating(true);

//             const response = await fetch(
//                 '/gt-api/update_okr_management.php',
//                 {
//                     method: 'POST',
//                     credentials: "include",
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         submission_id: selected.id,
//                         okr_details: JSON.stringify(selected.okr_details),
//                         workflow_status: selected.workflow_status
//                     })
//                 }
//             );

//             const res = await response.json();

//             if (res.success) {

//                 alert("Changes saved successfully!");

//                 console.log("SELECTED BEFORE UPDATE", selected);

//                 setSubmissions(prev =>
//                     prev.map(item =>
//                         item.id === selected.id
//                             ? {
//                                 ...item,
//                                 okr_details: JSON.stringify(selected.okr_details),
//                                 workflow_status: selected.workflow_status
//                             }
//                             : item
//                     )
//                 );

//                 setHasShownEditWarning(false);
//             } else {
//                 alert("Failed to save changes");
//             }

//         } catch (err) {
//             console.error(err);
//             alert("Server error while saving");
//         } finally {
//             setIsUpdating(false);
//         }
//     };

//     const updateOKRStatus = async (customStatus = null) => {
//         if (customStatus === "Scoring") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
//             );

//             if (!confirmed) return;
//         }

//         if (customStatus === "Returned_To_Employee") {
//             const confirmed = window.confirm(
//                 "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
//             );

//             if (!confirmed) return;
//         }
//         setIsUpdating(true);

//         let nextWorkflowStatus = '';
//         if (customStatus) {
//             nextWorkflowStatus = customStatus;
//         } else if (selected.workflow_status === 'Management_Review') {
//             nextWorkflowStatus = 'Scoring';
//         } else if (selected.workflow_status === 'Manager_Scoring_Review') {
//             nextWorkflowStatus = 'Sign_Off';
//         }

//         const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
//             ...obj,
//             keyResults: obj.keyResults.map(kr => {
//                 const newKR = { ...kr };

//                 if (nextWorkflowStatus === 'Scoring') {
//                     delete newKR.ar_comment;
//                 }

//                 return newKR;
//             })
//         }));
//         try {
//             const response = await fetch('/gt-api/update_okr_management.php', {
//                 method: 'POST',
//                 credentials: "include",
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     submission_id: selected.id,
//                     okr_details: JSON.stringify(cleanedOKR),
//                     workflow_status: nextWorkflowStatus
//                 })
//             });

//             const res = await response.json();

//             if (res.success) {
//                 setSelected(prev => ({
//                     ...prev,
//                     okr_details: cleanedOKR,
//                     workflow_status: nextWorkflowStatus
//                 }));
//                 window.location.reload();
//             }
//         } catch (err) {
//             alert("🚨 Sync failed");
//         } finally {
//             setIsUpdating(false);
//         }
//     };


//     const renderCustomAlertModal = () => {
//         if (!customAlert.isOpen) return null;

//         return createPortal(
//             <div className="custom-alert-modal-overlay">
//                 <div className="custom-alert-modal-card animate-fade">
//                     <div className="custom-alert-modal-icon">
//                         {customAlert.type === "success" ? (
//                             <div className="alert-icon-success">✓</div>
//                         ) : (
//                             <div className="alert-icon-error">✕</div>
//                         )}
//                     </div>
//                     <h3 className="custom-alert-modal-title">
//                         {customAlert.type === "success" ? "Success" : "Error"}
//                     </h3>
//                     <p className="custom-alert-modal-msg">{customAlert.message}</p>
//                     <button
//                         type="button"
//                         className="custom-alert-modal-ok-btn"
//                         onClick={() => {
//                             const closeHandler = customAlert.onClose;
//                             setCustomAlert({ isOpen: false, type: "error", message: "", onClose: null });
//                             if (closeHandler) closeHandler();
//                         }}
//                     >
//                         OK
//                     </button>
//                 </div>
//             </div>,
//             document.body
//         );
//     };


//     const renderPasswordModal = () => {
//         if (!passwordModal.isOpen) return null;

//         return createPortal(
//             <div className="delete-password-modal-overlay">
//                 <div className="delete-password-modal-card">
//                     <h3 className="delete-password-modal-title">
//                         ⚠️ Delete Confirmation
//                     </h3>

//                     {passwordModal.confirmMessage && (
//                         <p className="delete-password-modal-msg">
//                             {passwordModal.confirmMessage}
//                         </p>
//                     )}

//                     <p className="delete-password-modal-label">
//                         {passwordModal.title}
//                     </p>

//                     <div className="delete-password-modal-input-wrapper">
//                         <input
//                             type={showModalPassword ? "text" : "password"}
//                             placeholder="Enter password..."
//                             value={modalPassword}
//                             onChange={(e) => setModalPassword(e.target.value)}
//                             className="delete-password-modal-input"
//                             autoFocus
//                             onKeyDown={(e) => {
//                                 if (e.key === "Enter") {
//                                     passwordModal.onConfirm(modalPassword);
//                                 }
//                             }}
//                         />
//                         <button
//                             type="button"
//                             onClick={() => setShowModalPassword(!showModalPassword)}
//                             className="delete-password-modal-toggle-btn"
//                         >
//                             {showModalPassword ? (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
//                             ) : (
//                                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
//                             )}
//                         </button>
//                     </div>

//                     <div className="delete-password-modal-btn-group">
//                         <button
//                             type="button"
//                             onClick={() => {
//                                 setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });
//                                 setModalPassword("");
//                                 setShowModalPassword(false);
//                             }}
//                             className="delete-password-modal-cancel-btn"
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="button"
//                             onClick={() => passwordModal.onConfirm(modalPassword)}
//                             className="delete-password-modal-confirm-btn"
//                         >
//                             Delete
//                         </button>
//                     </div>
//                 </div>
//             </div>,
//             document.body
//         );
//     };

//     const [activeObjective, setActiveObjective] = useState(null);
//     const renderManagementActionForm = (title) => {
//         const isManagerReview = title === "Manager Review";
//         const isProbation = title === "Probation Period Feedback";




//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
//                     <div className="list-header" style={{ marginBottom: '20px' }}>
//                         <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
//                     </div>

//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                         {(() => {
//                             const probationCount = allEmployees?.filter(e => e.probation_status !== 'Permanent').length || 0;

//                             // Filter employees by search query and optional probation-only toggle
//                             let filtered = (allEmployees || []).filter(emp => {
//                                 if (isProbation && showOnlyProbation && emp.probation_status === 'Permanent') {
//                                     return false;
//                                 }
//                                 if (!mgmtEmpSearch) return true;
//                                 const q = mgmtEmpSearch.toLowerCase();
//                                 const nameMatch = (emp.full_name || '').toLowerCase().includes(q);
//                                 const teamMatch = (emp.team || '').toLowerCase().includes(q);
//                                 const idMatch = String(emp.empid || '').toLowerCase().includes(q);
//                                 const isProbMatch = isProbation && (emp.probation_status !== 'Permanent') && 'probation'.includes(q);
//                                 return nameMatch || teamMatch || idMatch || isProbMatch;
//                             });

//                             // For Probation tab, place active probation employees at the top
//                             if (isProbation) {
//                                 filtered = [...filtered].sort((a, b) => {
//                                     const aProb = a.probation_status !== 'Permanent';
//                                     const bProb = b.probation_status !== 'Permanent';
//                                     if (aProb && !bProb) return -1;
//                                     if (!aProb && bProb) return 1;
//                                     return (a.full_name || '').localeCompare(b.full_name || '');
//                                 });
//                             }

//                             // Keep currently selected employee in the options so value is never lost while searching
//                             if (mgmtSelection.emp_id && !filtered.some(e => String(e.empid) === String(mgmtSelection.emp_id))) {
//                                 const selectedEmp = allEmployees?.find(e => String(e.empid) === String(mgmtSelection.emp_id));
//                                 if (selectedEmp) {
//                                     filtered = [selectedEmp, ...filtered];
//                                 }
//                             }

//                             const probationList = filtered.filter(emp => emp.probation_status !== 'Permanent');
//                             const permanentList = filtered.filter(emp => emp.probation_status === 'Permanent');

//                             return (
//                                 <div className="form-group">
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
//                                         <label style={{ color: '#00bcd4', fontSize: '12px', margin: 0 }}>SELECT EMPLOYEE</label>
//                                         {isProbation && (
//                                             <label style={{ fontSize: '11px', color: '#ffb74d', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', userSelect: 'none' }}>
//                                                 <input
//                                                     type="checkbox"
//                                                     checked={showOnlyProbation}
//                                                     onChange={(e) => setShowOnlyProbation(e.target.checked)}
//                                                     style={{ cursor: 'pointer', accentColor: '#ff9800' }}
//                                                 />
//                                                 <span>Show only Probation ({probationCount})</span>
//                                             </label>
//                                         )}
//                                     </div>

//                                     {/* Search Input - White/Light mode compliant */}
//                                     <div style={{ position: 'relative', marginBottom: '8px' }}>
//                                         <input
//                                             type="text"
//                                             className="mgmt-search-input"
//                                             placeholder="🔍 Search employee by name, ID or department..."
//                                             value={mgmtEmpSearch}
//                                             onChange={(e) => setMgmtEmpSearch(e.target.value)}
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '10px 34px 10px 12px',
//                                                 borderRadius: '6px',
//                                                 border: '1px solid #cbd5e1',
//                                                 background: '#ffffff',
//                                                 color: '#1e293b',
//                                                 fontSize: '13px',
//                                                 outline: 'none',
//                                                 boxSizing: 'border-box'
//                                             }}
//                                         />
//                                         {mgmtEmpSearch && (
//                                             <button
//                                                 type="button"
//                                                 className="mgmt-search-clear"
//                                                 onClick={() => setMgmtEmpSearch("")}
//                                                 title="Clear search"
//                                             >
//                                                 ✕
//                                             </button>
//                                         )}
//                                     </div>

//                                     {/* Quick Selection Chip for Probation Candidate */}
//                                     {isProbation && probationCount > 0 && (
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
//                                             <span style={{ fontSize: '11px', color: '#64748b', fontWeight: 600 }}>Probation Candidates:</span>
//                                             {allEmployees.filter(e => e.probation_status !== 'Permanent').map(pEmp => {
//                                                 const isSelected = String(mgmtSelection.emp_id) === String(pEmp.empid);
//                                                 return (
//                                                     <button
//                                                         key={pEmp.empid}
//                                                         type="button"
//                                                         onClick={() => setMgmtSelection({ ...mgmtSelection, emp_id: String(pEmp.empid) })}
//                                                         style={{
//                                                             background: isSelected ? '#f59e0b' : '#fef3c7',
//                                                             border: isSelected ? '1px solid #d97706' : '1px solid #fcd34d',
//                                                             color: isSelected ? '#ffffff' : '#b45309',
//                                                             fontSize: '11px',
//                                                             fontWeight: 700,
//                                                             padding: '4px 10px',
//                                                             borderRadius: '16px',
//                                                             cursor: 'pointer',
//                                                             display: 'inline-flex',
//                                                             alignItems: 'center',
//                                                             gap: '4px',
//                                                             boxShadow: isSelected ? '0 2px 4px rgba(245, 158, 11, 0.3)' : 'none',
//                                                             transition: 'all 0.15s ease'
//                                                         }}
//                                                         title="Click to select this probation employee"
//                                                     >
//                                                         <span>⭐</span> {pEmp.full_name} ({pEmp.team})
//                                                     </button>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}

//                                     {/* Standard Native Select (Zero DOM Overlap) */}
//                                     <select
//                                         className="modern-select"
//                                         style={{ width: '100%', padding: '11px 12px', fontSize: '13px' }}
//                                         value={mgmtSelection.emp_id}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, emp_id: e.target.value })}
//                                     >
//                                         <option value="">
//                                             -- Choose Employee {mgmtEmpSearch || showOnlyProbation ? `(${filtered.length} found)` : ''} --
//                                         </option>
//                                         {isProbation ? (
//                                             <>
//                                                 {probationList.length > 0 && (
//                                                     <optgroup label={`⚡ ON PROBATION (${probationList.length})`} className="probation-optgroup">
//                                                         {probationList.map(emp => (
//                                                             <option
//                                                                 key={emp.empid}
//                                                                 value={emp.empid}
//                                                                 className="probation-option-highlight"
//                                                                 style={{
//                                                                     backgroundColor: '#fef3c7',
//                                                                     color: '#b45309',
//                                                                     fontWeight: 'bold'
//                                                                 }}
//                                                             >
//                                                                 ⭐ [PROBATION] {emp.full_name} ({emp.team})
//                                                             </option>
//                                                         ))}
//                                                     </optgroup>
//                                                 )}
//                                                 {(!showOnlyProbation && permanentList.length > 0) && (
//                                                     <optgroup label={`PERMANENT EMPLOYEES (${permanentList.length})`}>
//                                                         {permanentList.map(emp => (
//                                                             <option key={emp.empid} value={emp.empid}>
//                                                                 {emp.full_name} ({emp.team})
//                                                             </option>
//                                                         ))}
//                                                     </optgroup>
//                                                 )}
//                                             </>
//                                         ) : (
//                                             filtered.map(emp => (
//                                                 <option key={emp.empid} value={emp.empid}>
//                                                     {emp.full_name} ({emp.team})
//                                                 </option>
//                                             ))
//                                         )}
//                                     </select>
//                                 </div>
//                             );
//                         })()}

//                         {isProbation && mgmtSelection.emp_id && (() => {
//                             const selectedEmp = allEmployees?.find(e => String(e.empid) === String(mgmtSelection.emp_id));
//                             const isPerm = selectedEmp && selectedEmp.probation_status === 'Permanent';
//                             return (
//                                 <div style={{
//                                     fontSize: '12px',
//                                     padding: '10px 14px',
//                                     borderRadius: '6px',
//                                     background: isPerm ? '#f0fdf4' : '#fffbeb',
//                                     border: isPerm ? '1px solid #86efac' : '1px solid #fcd34d',
//                                     color: isPerm ? '#166534' : '#92400e',
//                                     fontWeight: 500
//                                 }}>
//                                     {isPerm 
//                                         ? "✅ This employee is already confirmed as Permanent." 
//                                         : "⏳ Employee is currently in Probation. Submitting will send the confirmation email and transition them to Permanent status."}
//                                 </div>
//                             );
//                         })()}

//                         {isManagerReview ? (
//                             <>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe key accomplishments..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.accomplished}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
//                                     />
//                                 </div>
//                                 <div className="form-group">
//                                     <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
//                                     <textarea
//                                         className="modern-textarea"
//                                         placeholder="Describe areas for improvement..."
//                                         style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                         value={mgmtSelection.improvements}
//                                         onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
//                                     />
//                                 </div>
//                             </>
//                         ) : isProbation ? (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>CONFIRMATION MESSAGE PREVIEW</label>
//                                 <div style={{
//                                     padding: '20px',
//                                     background: 'rgba(0,188,212,0.08)',
//                                     border: '1px solid #00bcd4',
//                                     borderRadius: '8px',
//                                     color: '#fff',
//                                     fontSize: '13px',
//                                     whiteSpace: 'pre-wrap', // This property handles the line breaks correctly
//                                     lineHeight: '1.6'
//                                 }}>
//                                     {PROBATION_MESSAGE}
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="form-group">
//                                 <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
//                                 <textarea
//                                     className="modern-textarea"
//                                     placeholder={`Write the ${title.toLowerCase()} details here...`}
//                                     style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
//                                     value={mgmtSelection.content}
//                                     onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
//                                 />
//                             </div>
//                         )}

//                         <button
//                             className="btn-primary"
//                             style={{ marginTop: '10px', width: '100%' }}
//                             onClick={handleManagementSubmit}
//                             disabled={isSubmittingMgmt}
//                         >
//                             {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };











//     const renderOKRTrackerTab = () => {
//         if (loading) {
//             return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
//         }

//         const flagColors = [
//             "linear-gradient(to right, #e63900, #ff8c00)",
//             "linear-gradient(to right, #7c3aed, #a855f7)",
//             "linear-gradient(to right, #16a34a, #22c55e)",
//             "linear-gradient(to right, #dc2626, #ef4444)"
//         ];

//         const getCurrentQuarter = () => {
//             const month = new Date().getMonth() + 1;
//             if (month >= 4 && month <= 6) return "Quarter 1";
//             if (month >= 7 && month <= 9) return "Quarter 2";
//             if (month >= 10 && month <= 12) return "Quarter 3";
//             return "Quarter 4";
//         };

//         const autoResize = (el) => {
//             if (!el) return;
//             el.style.height = "auto";
//             el.style.height = `${el.scrollHeight}px`;
//         };

//         const currentQuarter = getCurrentQuarter();

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter((sub) => sub.quarter === currentQuarter)
//                 .map((sub) => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter((emp) =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(
//             (emp) => !submittedEmpIds.has(emp.empid)
//         );

//         // =========================
//         // 🔹 SELECTED VIEW
//         // =========================
//         if (selected) {
//             return (
//                 <div className="okr-vertical-reveal-viewer animate-fade">
//                     <div className="bg-subtle-grid"></div>

//                     {/* HEADER */}
//                     <div className="nav-strip-glass">
//                         <button
//                             className="back-btn-cyber"
//                             onClick={() => {
//                                 setSelected(null);
//                                 setActiveObjective(null);
//                             }}
//                         >
//                             <span className="icon">⬅</span> DIRECTORY
//                         </button>

//                         <div className="profile-pill">
//                             <div className="p-avatar clickable-avatar">
//                                 {selected.profile_image ? (
//                                     <img
//                                         src={selected.profile_image}
//                                         alt={selected.emp_name}
//                                         onClick={() => setPreviewImage(selected.profile_image)}
//                                     />
//                                 ) : (
//                                     <span>{selected.emp_name?.charAt(0)}</span>
//                                 )}
//                             </div>

//                             <div className="p-info">
//                                 <span className="p-name">{selected.emp_name}</span>
//                                 <span className="p-status">
//                                     {selected.workflow_status.replace(/_/g, " ")}
//                                 </span>
//                             </div>
//                         </div>

//                         <div className="nav-actions">

//                             {/* 1) Save Progress */}
//                             {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={handleSaveEditedOKR}
//                                     disabled={isUpdating}
//                                     title="Save the progress of your OKR draft changes"
//                                 >
//                                     {isUpdating ? "SAVING..." : "Save Progress"}
//                                 </button>
//                             )}

//                             {/* 2) Send it for AR Updation */}
//                             {selected.workflow_status === "Management_Review" && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={() => updateOKRStatus("Returned_To_Employee")}
//                                     disabled={isUpdating}
//                                     title="Send the OKR back to the employee for Annual Review (AR) updation"
//                                 >
//                                     {isUpdating ? "RETURNING..." : "Send it for AR Updation"}
//                                 </button>
//                             )}

//                             {/* 3) Approve and Send for Grade Scoring */}
//                             {selected.workflow_status === "Management_Review" && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={() => updateOKRStatus("Scoring")}
//                                     disabled={isUpdating}
//                                     title="Approve the current OKR and send it for grade scoring"
//                                 >
//                                     {isUpdating ? "PROCESSING..." : "Approve and Send for Grade Scoring"}
//                                 </button>
//                             )}

//                             {/* 4) Finalize (for Manager_Scoring_Review) */}
//                             {selected.workflow_status === "Manager_Scoring_Review" && (
//                                 <button
//                                     className="btn-okr-action"
//                                     onClick={() => updateOKRStatus("Sign_Off")}
//                                     disabled={isUpdating}
//                                     title="Finalize the OKR and sign off"
//                                 >
//                                     {isUpdating ? "FINALIZING..." : "FINALIZE"}
//                                 </button>
//                             )}

//                             {selected.workflow_status === "Locked" && (
//                                 <span className="locked-label">LOCKED</span>
//                             )}

//                             <button
//                                 className="btn-delete-minimal"
//                                 onClick={handleDeleteEntireOKR}
//                                 title="Delete OKR"
//                             >
//                                 <Trash2 size={16} />
//                             </button>

//                         </div>
//                     </div>

//                     {/* OBJECTIVES */}
//                     <div className="objective-vertical-stack">
//                         <button
//                             onClick={handleAddObjective}
//                             style={{
//                                 alignSelf: "flex-start",
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 gap: "6px",
//                                 padding: "8px 16px",
//                                 // background: "linear-gradient(135deg, #00bcd4, #00838f)",
//                                 background: "linear-gradient(rgb(29 203 225), rgb(35 199 214))",
//                                 color: "#ffffff",
//                                 border: "none",
//                                 borderRadius: "50px",
//                                 cursor: "pointer",
//                                 fontWeight: "700",
//                                 fontSize: "13px",
//                                 letterSpacing: "0.5px",
//                                 boxShadow: "0 4px 12px rgba(0, 188, 212, 0.25)",
//                                 transition: "all 0.3s ease",
//                                 marginTop: "10px",
//                                 marginBottom: "5px"
//                             }}
//                             onMouseOver={(e) => {
//                                 e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 188, 212, 0.4)";
//                                 e.currentTarget.style.transform = "translateY(-1px)";
//                             }}
//                             onMouseOut={(e) => {
//                                 e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 188, 212, 0.25)";
//                                 e.currentTarget.style.transform = "none";
//                             }}
//                         >
//                             + Add Objective
//                         </button>

//                         {Array.isArray(selected.okr_details) &&
//                             selected.okr_details.map((obj, oIdx) => {

//                                 console.log("========== OBJECT ==========");
//                                 console.log(obj);
//                                 console.log("OBJECTIVE:", obj.objective);
//                                 console.log("KEY RESULTS:", obj.keyResults);

//                                 const isExpanded = activeObjective === oIdx;

//                                 const isLocked = selected.workflow_status === "Locked";

//                                 const isScoreEditable =
//                                     selected.workflow_status === "Management_Review" ||
//                                     selected.workflow_status === "Scoring" ||
//                                     selected.workflow_status === "Manager_Scoring_Review";

//                                 return (
//                                     <div
//                                         key={oIdx}
//                                         className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
//                                     >
//                                         {/* <h1 style={{ color: "red", fontSize: "40px" }}>
//                                             TEST OBJECTIVE
//                                         </h1> */}

//                                         {/* HEADER */}
//                                         <div
//                                             className="obj-header-row"
//                                             onClick={() =>
//                                                 setActiveObjective(isExpanded ? null : oIdx)
//                                             }
//                                         >
//                                             <div className="obj-flag-wrapper">
//                                                 <div className="obj-flag-fold"></div>
//                                                 <div
//                                                     className="obj-flag-body"
//                                                     style={{
//                                                         background: flagColors[oIdx % flagColors.length]
//                                                     }}
//                                                 >
//                                                     {String(oIdx + 1).padStart(2, "0")}
//                                                 </div>
//                                             </div>

//                                             {/* OBJECTIVE */}
//                                             <div className="obj-text-content">
//                                                 <textarea
//                                                     value={obj.objective || ""}
//                                                     rows={2}
//                                                     disabled={isLocked}
//                                                     onInput={(e) => autoResize(e.target)}
//                                                     ref={(el) => el && autoResize(el)}
//                                                     onChange={(e) => {
//                                                         showEditWarning();

//                                                         const updated = { ...selected };
//                                                         updated.okr_details[oIdx].objective = e.target.value;
//                                                         setSelected(updated);
//                                                     }}
//                                                     className="objective-title"
//                                                     style={{
//                                                         width: "100%",
//                                                         minHeight: "50px",
//                                                         color: "#111827",
//                                                         background: "transparent",
//                                                         border: "none",
//                                                         resize: "none",
//                                                         overflow: "hidden",
//                                                         fontSize: "16px",
//                                                         fontWeight: "600",
//                                                         outline: "none"
//                                                     }}
//                                                 />
//                                             </div>

//                                             {/* STATUS */}
//                                             <div
//                                                 className={`obj-status-indicator ${isExpanded ? "open" : ""
//                                                     }`}
//                                             >
//                                                 {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
//                                             </div>

//                                             {/* DELETE OBJECTIVE BUTTON */}
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     handleDeleteObjective(oIdx);
//                                                 }}
//                                                 style={{
//                                                     background: "transparent",
//                                                     border: "none",
//                                                     color: "#ff4d4f",
//                                                     cursor: "pointer",
//                                                     fontSize: "16px",
//                                                     marginLeft: "15px",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     padding: "0"
//                                                 }}
//                                             >
//                                                 <Trash2 size={16} />
//                                             </button>
//                                         </div>

//                                         {/* KEY RESULTS */}
//                                         <div className="kr-vertical-list">
//                                             {[...Array(6)].map((_, kIdx) => {
//                                                 console.log("KR INDEX", kIdx);
//                                                 console.log(obj.keyResults?.[kIdx]);
//                                                 const kr = obj.keyResults?.[kIdx] || {
//                                                     text: "",
//                                                     result: "Pending",
//                                                     ar_comment: ""
//                                                 };

//                                                 const hasAR = kr.ar_comment?.trim();

//                                                 return (
//                                                     <div
//                                                         key={`${oIdx}-${kIdx}`}
//                                                         className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
//                                                     >
//                                                         {/* KR TEXT */}
//                                                         <div className="kr-body-wrap">
//                                                             <span className="kr-index-inline">
//                                                                 {kIdx + 1})
//                                                             </span>

//                                                             <div className="kr-input-area">
//                                                                 <textarea
//                                                                     value={kr.text}
//                                                                     disabled={isLocked}
//                                                                     onChange={(e) =>
//                                                                         handleKRTextChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                     className="kr-text-minimal auto-expand"
//                                                                     rows={1}
//                                                                     placeholder="Key Result..."
//                                                                     onInput={(e) => autoResize(e.target)}
//                                                                     ref={(el) => el && autoResize(el)}
//                                                                 />
//                                                             </div>
//                                                         </div>

//                                                         {/* CONTROLS */}
//                                                         <div className="kr-controls">
//                                                             <div className="kr-score-dropdown">
//                                                                 <label>SCORE</label>
//                                                                 <select
//                                                                     value={kr.result || "Pending"}
//                                                                     disabled={!isScoreEditable}
//                                                                     onChange={(e) =>
//                                                                         handleStatusChange(
//                                                                             oIdx,
//                                                                             kIdx,
//                                                                             e.target.value
//                                                                         )
//                                                                     }
//                                                                 >
//                                                                     {resultOptions.map((opt) => (
//                                                                         <option key={opt} value={opt}>
//                                                                             {opt}
//                                                                         </option>
//                                                                     ))}
//                                                                 </select>
//                                                             </div>

//                                                             <button
//                                                                 className="kr-line-delete"
//                                                                 disabled={isLocked}
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     handleDeleteKR(oIdx, kIdx);
//                                                                 }}
//                                                             >
//                                                                 <Trash2 size={16} />

//                                                             </button>
//                                                         </div>

//                                                         {/* AR */}
//                                                         {selected.workflow_status ===
//                                                             "Management_Review" && (
//                                                                 <div style={{ marginTop: "8px" }}>
//                                                                     {!(
//                                                                         activeAR.includes(`${oIdx}-${kIdx}`) ||
//                                                                         hasAR
//                                                                     ) ? (
//                                                                         <button
//                                                                             type="button"
//                                                                             onClick={() =>
//                                                                                 setActiveAR((prev) => [
//                                                                                     ...prev,
//                                                                                     `${oIdx}-${kIdx}`
//                                                                                 ])
//                                                                             }
//                                                                             style={{
//                                                                                 background: "transparent",
//                                                                                 border: "none",
//                                                                                 cursor: "pointer",
//                                                                                 color: "#ff9800",
//                                                                                 fontSize: "13px",
//                                                                                 fontWeight: "600"
//                                                                             }}
//                                                                         >
//                                                                             {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
//                                                                         </button>
//                                                                     ) : (
//                                                                         <textarea
//                                                                             value={kr.ar_comment || ""}
//                                                                             onChange={(e) => {
//                                                                                 const updated = { ...selected };

//                                                                                 if (!updated.okr_details[oIdx].keyResults) {
//                                                                                     updated.okr_details[oIdx].keyResults = [];
//                                                                                 }

//                                                                                 while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
//                                                                                     updated.okr_details[oIdx].keyResults.push({
//                                                                                         text: "",
//                                                                                         result: "Pending",
//                                                                                         ar_comment: ""
//                                                                                     });
//                                                                                 }

//                                                                                 updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

//                                                                                 setSelected(updated);
//                                                                             }}
//                                                                             rows={2}
//                                                                             autoFocus={activeAR.includes(`${oIdx}-${kIdx}`)}
//                                                                             style={{
//                                                                                 width: "100%",
//                                                                                 marginTop: "6px",
//                                                                                 padding: "8px",
//                                                                                 borderRadius: "6px",
//                                                                                 border: "1px solid #ff9800",
//                                                                                 background: "rgba(255,152,0,0.05)",
//                                                                                 fontSize: "13px"
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                 </div>
//                                                             )}
//                                                     </div>
//                                                 );
//                                             })}


//                                             {/* <button
//                                                 onClick={() => handleAddKR(oIdx)}
//                                                 style={{
//                                                     marginTop: "10px",
//                                                     background: "#4caf50",
//                                                     color: "#fff",
//                                                     border: "none",
//                                                     padding: "6px 10px",
//                                                     borderRadius: "5px",
//                                                     cursor: "pointer"
//                                                 }}
//                                             >
//                                                 + Add Key Result
//                                             </button> */}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                     </div>

//                     {previewImage && (
//                         <div
//                             className="image-preview-overlay"
//                             onClick={() => setPreviewImage(null)}
//                         >
//                             <div className="image-preview-box">
//                                 <img src={previewImage} alt="Preview" />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             );
//         }

//         // =========================
//         // 🔹 LIST VIEW (UNCHANGED)
//         // =========================

//         const filteredSubmitted = Object.entries(groupedData).filter(
//             ([empName, data]) => {
//                 const matchesSearch = empName
//                     .toLowerCase()
//                     .includes(searchTerm.toLowerCase());

//                 const dept = data?.years
//                     ? data.years[Object.keys(data.years)[0]][0].department
//                     : "";

//                 const matchesDept = selectedDept
//                     ? dept === selectedDept
//                     : true;

//                 return matchesSearch && matchesDept;
//             }
//         );

//         console.log("=========== FILTERED SUBMITTED ===========");
//         console.log(filteredSubmitted);

//         filteredSubmitted.forEach(([empName, data]) => {
//             console.log("Employee:", empName);
//             console.log(data);
//         });

//         const filteredMissing = missingEmployees.filter((emp) => {
//             const matchesSearch = emp.full_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase());

//             const matchesDept = selectedDept
//                 ? emp.team === selectedDept
//                 : true;

//             return matchesSearch && matchesDept;
//         });


//         return (
//             <div
//                 className="okr-genesis-container animate-fade"
//                 style={{
//                     background: "transparent",
//                     minHeight: "100vh",
//                     padding: "40px 0",
//                     width: "100%",
//                     fontFamily: "'Inter', 'Segoe UI', sans-serif"
//                 }}
//             >


//                 <div style={{ width: "95%", margin: "0 auto" }}>

//                     {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
//                             gap: "12px",
//                             marginBottom: "12px",
//                             alignItems: "center"
//                         }}
//                     >

//                         {/* SEARCH */}
//                         <input
//                             type="text"
//                             placeholder="Search employee..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             style={{
//                                 padding: "10px",
//                                 borderRadius: "8px",
//                                 border: "1px solid #ccc",
//                                 width: "100%"
//                             }}
//                         />

//                         {/* DEPARTMENT */}
//                         <select
//                             className="department-filter"
//                             value={selectedDept}
//                             onChange={(e) => setSelectedDept(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             <option value="">All Departments</option>
//                             {[...new Set(submissions.map((sub) => sub.department))].map(
//                                 (dept, idx) => (
//                                     <option key={idx} value={dept}>
//                                         {dept}
//                                     </option>
//                                 )
//                             )}
//                         </select>

//                         {/* YEAR */}
//                         <select
//                             value={lockYear}
//                             onChange={(e) => setLockYear(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
//                                 <option key={y} value={y}>
//                                     {y}
//                                 </option>
//                             ))}
//                         </select>

//                         {/* QUARTER */}
//                         <select
//                             value={lockQuarter}
//                             onChange={(e) => setLockQuarter(e.target.value)}
//                             style={{ padding: "10px", borderRadius: "8px" }}
//                         >
//                             {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
//                                 const isLocked = lockedQuarters[q];

//                                 return (
//                                     <option key={q} value={q}>
//                                         {q} {isLocked ? "🔒" : ""}
//                                     </option>
//                                 );
//                             })}
//                         </select>

//                         {/* LOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         credentials: "include",
//                                         headers: { "Content-Type": "application/json" },
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: true
//                                         })
//                                     });

//                                     const data = await res.json();

//                                     if (data.success) {
//                                         alert("Locked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: true
//                                         }));
//                                     }

//                                 } catch (err) {
//                                     console.error("LOCK ERROR:", err);
//                                     alert("Error locking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "red",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             LOCK
//                         </button>

//                         {/* UNLOCK */}
//                         <button
//                             onClick={async () => {
//                                 try {
//                                     const res = await fetch("/gt-api/lock_timeline.php", {
//                                         method: "POST",
//                                         headers: { "Content-Type": "application/json" },
//                                         credentials: "include",
//                                         body: JSON.stringify({
//                                             year: lockYear,
//                                             quarter: lockQuarter,
//                                             locked: false
//                                         })
//                                     });

//                                     const text = await res.text();
//                                     console.log("RAW RESPONSE:", text);

//                                     let data;
//                                     try {
//                                         data = JSON.parse(text);
//                                     } catch (e) {
//                                         alert("Invalid JSON from server");
//                                         return;
//                                     }

//                                     if (data.success) {
//                                         alert("Unlocked!");

//                                         setLockedQuarters(prev => ({
//                                             ...prev,
//                                             [lockQuarter]: false
//                                         }));
//                                     }

//                                 } catch {
//                                     alert("Error unlocking");
//                                 }
//                             }}
//                             style={{
//                                 height: "40px",
//                                 borderRadius: "8px",
//                                 border: "none",
//                                 background: "green",
//                                 color: "#fff",
//                                 fontSize: "18px",
//                                 cursor: "pointer",
//                                 marginTop: "4px"
//                             }}
//                         >
//                             UNLOCK
//                         </button>

//                     </div>

//                     {/* HEADER */}
//                     <div className="hub-header-compact">
//                         <h1 className="hub-title">
//                             Employee <span>Performance Hub</span>
//                         </h1>
//                     </div>

//                     {/* TOGGLE */}
//                     <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
//                         <button
//                             onClick={() => setViewType("submitted")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "submitted"
//                                         ? "2px solid #00bcd4"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "submitted" ? "#e6fafd" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Submitted
//                         </button>

//                         <button
//                             onClick={() => setViewType("missing")}
//                             style={{
//                                 padding: "8px 16px",
//                                 borderRadius: "8px",
//                                 border:
//                                     viewType === "missing"
//                                         ? "2px solid #ff4d4f"
//                                         : "1px solid #ccc",
//                                 background:
//                                     viewType === "missing" ? "#fff1f0" : "#fff",
//                                 fontWeight: "600",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Missing
//                         </button>
//                     </div>

//                     {/* GRID */}
//                     <div
//                         style={{
//                             display: "grid",
//                             gridTemplateColumns: "1fr 1fr",
//                             gap: "12px"
//                         }}
//                     >
//                         {(viewType === "submitted"
//                             ? filteredSubmitted
//                             : filteredMissing.map((emp) => [emp.full_name, emp])
//                         ).map(([empName, data]) => (
//                             <div
//                                 key={empName}
//                                 className="employee-row-card"
//                                 style={{
//                                     borderRadius: "12px",
//                                     padding: "12px 16px",
//                                     display: "grid",
//                                     gridTemplateColumns: "180px 1fr",
//                                     alignItems: "center",
//                                     background: "#fff",
//                                     border: "1px solid #eef2f6",
//                                     minHeight: "75px",
//                                     boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
//                                 }}
//                             >
//                                 {/* LEFT */}
//                                 <div
//                                     style={{
//                                         borderRight: "1px solid #edf2f7",
//                                         paddingRight: "15px",
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "12px"
//                                     }}
//                                 >
//                                     <div
//                                         className="emp-avatar clickable-avatar"
//                                         style={{
//                                             width: "38px",
//                                             height: "38px",
//                                             flexShrink: 0
//                                         }}
//                                     >
//                                         {data.profile_image ? (
//                                             <img
//                                                 src={data.profile_image}
//                                                 alt={empName}
//                                                 onClick={() =>
//                                                     setPreviewImage(data.profile_image)
//                                                 }
//                                                 style={{
//                                                     borderRadius: "50%",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover"
//                                                 }}
//                                             />
//                                         ) : (
//                                             <div
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     background: "#f0f0f0",
//                                                     borderRadius: "50%",
//                                                     display: "flex",
//                                                     alignItems: "center",
//                                                     justifyContent: "center",
//                                                     fontSize: "14px",
//                                                     fontWeight: "bold"
//                                                 }}
//                                             >
//                                                 {empName.charAt(0)}
//                                             </div>
//                                         )}
//                                     </div>

//                                     <div style={{ overflow: "hidden" }}>
//                                         <h3
//                                             style={{
//                                                 margin: 0,
//                                                 fontSize: "0.95rem",
//                                                 fontWeight: "700",
//                                                 display: "-webkit-box",
//                                                 WebkitLineClamp: "2",
//                                                 WebkitBoxOrient: "vertical",
//                                                 overflow: "hidden"
//                                             }}
//                                         >
//                                             {empName}
//                                         </h3>
//                                         <p style={{ margin: 0, fontSize: "12px" }}>
//                                             ID:{" "}
//                                             {viewType === "submitted"
//                                                 ? data.emp_id
//                                                 : data.empid}
//                                         </p>
//                                     </div>
//                                 </div>

//                                 {/* RIGHT */}
//                                 <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
//                                     {data?.years ? (
//                                         Object.keys(data.years)
//                                             .sort((a, b) => b - a)
//                                             .map((year) => (
//                                                 <div key={year}>
//                                                     <span>{year}</span>
//                                                     <div style={{ display: "flex", gap: "5px" }}>
//                                                         {data.years[year].map((sub) => {
//                                                             const isLocked =
//                                                                 sub.workflow_status === "Locked";
//                                                             const isReview = [
//                                                                 "Management_Review",
//                                                                 "Manager_Scoring_Review"
//                                                             ].includes(sub.workflow_status);

//                                                             return (
//                                                                 <button
//                                                                     key={sub.id}
//                                                                     onClick={() => {
//                                                                         const details =
//                                                                             typeof sub.okr_details === "string"
//                                                                                 ? JSON.parse(sub.okr_details)
//                                                                                 : sub.okr_details;

//                                                                         setSelected({
//                                                                             ...sub,
//                                                                             okr_details: details
//                                                                         });

//                                                                         // Open first objective automatically
//                                                                         setActiveObjective(null);
//                                                                     }}
//                                                                 >
//                                                                     {sub.quarter}{" "}
//                                                                     {isLocked
//                                                                         ? "🔒"
//                                                                         : isReview
//                                                                             ? "⏳"
//                                                                             : "→"}
//                                                                 </button>
//                                                             );
//                                                         })}
//                                                     </div>
//                                                 </div>
//                                             ))
//                                     ) : (
//                                         <div>Not Submitted</div>
//                                     )}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* IMAGE PREVIEW */}
//                 {previewImage && (
//                     <div
//                         className="image-preview-overlay"
//                         onClick={() => setPreviewImage(null)}
//                     >
//                         <div
//                             className="image-preview-box"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img src={previewImage} alt="Preview" />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         );

//     };

//     const renderEmployeeReviewTab = () => {
//         if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

//         const submittedEmpIds = new Set(
//             submissions
//                 .filter(sub => sub.quarter === currentQuarter)
//                 .map(sub => sub.emp_id)
//         );

//         const submittedEmployees = allEmployees.filter(emp =>
//             submittedEmpIds.has(emp.empid)
//         );

//         const missingEmployees = allEmployees.filter(emp =>
//             !submittedEmpIds.has(emp.empid)
//         );


//         if (selectedReview) {
//             return (
//                 <div className="okr-viewer-wrapper animate-fade">
//                     <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
//                     <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
//                         <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
//                         <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
//                         <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

//                         {[
//                             { label: "Key Achievements", data: selectedReview.achievements },
//                             { label: "Role & Responsibilities", data: selectedReview.responsibilities },
//                             { label: "Skills & Growth", data: selectedReview.skills_growth },
//                             { label: "Challenges Faced", data: selectedReview.challenges },
//                             { label: "Areas for Improvement", data: selectedReview.improvement_areas },
//                             { label: "Goals for Next Year", data: selectedReview.goals_next_year },
//                             { label: "Additional Contributions", data: selectedReview.additional_contributions },
//                             { label: "Support Needed", data: selectedReview.support_needed }
//                         ].map(section => (
//                             <div key={section.label} style={{ marginBottom: '25px' }}>
//                                 <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
//                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                     {Array.isArray(section.data) ? section.data.map((point, i) => (
//                                         point && point.trim() !== "" && (
//                                             <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
//                                                 {point}
//                                             </div>
//                                         )
//                                     )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             );
//         }

//         return (
//             <div className="okr-genesis-container animate-fade">
//                 <div className="okr-glass-card">
//                     <div className="list-header" style={{ marginBottom: '30px' }}>
//                         <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
//                         {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
//                     </div>
//                     <table className="sequencer-table-view">
//                         <thead>
//                             <tr>
//                                 <th>EMPLOYEE NAME</th>
//                                 <th>TEAM</th>
//                                 <th>PERIOD</th>
//                                 <th>SUBMISSION DATE</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reviews.length > 0 ? reviews.map(rev => (
//                                 <tr key={rev.id}>
//                                     <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
//                                     <td>{rev.team}</td>
//                                     <td>{rev.review_period}</td>
//                                     <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
//                                     <td>
//                                         <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
//                                     </td>
//                                 </tr>
//                             )) : (
//                                 <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     };

//     const renderSubModule = () => {
//         switch (activeTab) {
//             case "OKR Tracker": return renderOKRTrackerTab();
//             case "Employee Self Performance Review": return renderEmployeeReviewTab();
//             case "Manager Review": return renderManagementActionForm("Manager Review");
//             case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
//             default: return null;
//         }
//     };

//     return (
//         <div className="pay-module">
//             <div className="pay-nav-grid">
//                 {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
//                     <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
//                         setActiveTab(tab);
//                         setSelected(null);
//                         setSelectedReview(null);
//                         setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
//                         setMgmtEmpSearch("");
//                         setShowOnlyProbation(false);
//                     }}>
//                         {tab.toUpperCase()}
//                     </button>
//                 ))}
//             </div>


//             <div className="pay-content-area">
//                 {renderSubModule()}
//             </div>
//             {renderPasswordModal()}
//             {renderCustomAlertModal()}
//         </div>


//     );
// };

// export default ManagementOKRViewer;
































import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Trash2, Users, Calendar, Search, ChevronLeft, ChevronRight, ChevronDown, Check } from 'lucide-react';
import '../styles/OKRTracker.css';

const ManagementOKRViewer = ({ userRole, managedDept }) => {

    const [lockedQuarters, setLockedQuarters] = useState({});

    const getFY = (date) => {
        const m = date.getMonth() + 1;
        const y = date.getFullYear();
        return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
    };
    const [lockYear, setLockYear] = useState(getFY(new Date()));

    const [lockQuarter, setLockQuarter] = useState("Quarter 1");
    const [isTimelineLocked, setIsTimelineLocked] = useState(false);
    const [activeTab, setActiveTab] = useState("OKR Tracker");
    const [loading, setLoading] = useState(true);

    // OKR Tracker States
    const [submissions, setSubmissions] = useState([]);
    const [selected, setSelected] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);
    const [hasShownEditWarning, setHasShownEditWarning] = useState(false);
    const [activeAR, setActiveAR] = useState([]);

    // Employee Review States
    const [reviews, setReviews] = useState([]);
    const [selectedReview, setSelectedReview] = useState(null);

    // Management Action States
    const [allEmployees, setAllEmployees] = useState([]);
    const [mgmtSelection, setMgmtSelection] = useState({
        emp_id: "",
        content: "",
        accomplished: "",
        improvements: ""
    });
    const [isSubmittingMgmt, setIsSubmittingMgmt] = useState(false);
    const [mgmtEmpSearch, setMgmtEmpSearch] = useState("");
    const [showOnlyProbation, setShowOnlyProbation] = useState(false);
    const [probationSearch, setProbationSearch] = useState("");
    const [probationPage, setProbationPage] = useState(1);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [comboboxSearch, setComboboxSearch] = useState("");
    const selectDropdownRef = useRef(null);

    const [passwordModal, setPasswordModal] = useState({
        isOpen: false,
        title: "",
        onConfirm: null
    });
    const [modalPassword, setModalPassword] = useState("");
    const [showModalPassword, setShowModalPassword] = useState(false);

    const [customAlert, setCustomAlert] = useState({
        isOpen: false,
        type: "error", // "success" | "error"
        message: "",
        onClose: null
    });

    const showMessage = (message, type = "success", onClose = null) => {
        setCustomAlert({
            isOpen: true,
            type,
            message,
            onClose
        });
    };

    const resultOptions = ["Pending", "Not Met/ Downgraded", "Successfull", "Exceeds", "Excellence"];

    // Hardcoded Message Template
    const PROBATION_MESSAGE = `Hello,

Based on your work performance, professional attitude, and commitment during the probationary period, we are pleased to inform you that you have successfully completed your probationary period with Genesis Tech Engineers Pvt Ltd.

Your employment is hereby confirmed. We appreciate your efforts and look forward to your continued contribution and growth within the organization. Please continue to maintain the expected level of performance and professionalism.

Congratulations and wish you the best.

Thanks,
Genesis Tech Engineers Pvt. Ltd.`;

    // Auto-select first probation employee when Probation Period Feedback tab is active
    useEffect(() => {
        if (activeTab === "Probation Period Feedback") {
            const probationEmps = (allEmployees || []).filter(e => e.probation_status !== 'Permanent');
            if (probationEmps.length > 0 && !mgmtSelection.emp_id) {
                setMgmtSelection(prev => ({ ...prev, emp_id: String(probationEmps[0].empid) }));
            }
        }
    }, [activeTab, allEmployees]);

    // Probation Helper Functions
    const formatProbationDate = (dateVal) => {
        if (!dateVal || dateVal === "0000-00-00") return "N/A";
        const d = new Date(dateVal);
        if (isNaN(d.getTime())) return dateVal;
        return d.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const getProbationEndDate = (dateVal) => {
        if (!dateVal || dateVal === "0000-00-00") return null;
        const d = new Date(dateVal);
        if (isNaN(d.getTime())) return null;
        const end = new Date(d);
        end.setMonth(end.getMonth() + 6);
        end.setDate(end.getDate() - 1);
        return end;
    };

    const getDaysLeftCount = (endDate) => {
        if (!endDate) return null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const target = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
        const diffTime = target.getTime() - today.getTime();
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    const getDaysLeftBadgeConfig = (days) => {
        if (days === null || isNaN(days)) {
            return { text: "N/A", bg: "#f1f5f9", color: "#64748b" };
        }
        if (days <= 0) {
            return { text: "Completed", bg: "#f1f5f9", color: "#64748b" };
        }
        if (days <= 30) {
            return { text: `${days} Days`, bg: "#fee2e2", color: "#dc2626" };
        }
        if (days <= 60) {
            return { text: `${days} Days`, bg: "#fef3c7", color: "#d97706" };
        }
        return { text: `${days} Days`, bg: "#dcfce7", color: "#16a34a" };
    };

    const getEmployeeInitials = (name) => {
        if (!name) return "??";
        const parts = name.trim().split(/\s+/);
        if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };

    const AVATAR_COLORS = [
        { bg: '#dbeafe', color: '#1d4ed8' }, // blue (AD)
        { bg: '#ede9fe', color: '#7c3aed' }, // purple (RG)
        { bg: '#dcfce7', color: '#15803d' }, // green (SP)
        { bg: '#ffe4e6', color: '#be123c' }, // pink/red (AK)
        { bg: '#e0f2fe', color: '#0369a1' }, // cyan (PJ)
        { bg: '#f5f3ff', color: '#6d28d9' }, // violet (MK)
        { bg: '#d1fae5', color: '#047857' }, // mint (SW)
        { bg: '#ffedd5', color: '#c2410c' }  // orange (TD)
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectDropdownRef.current && !selectDropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
                setComboboxSearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const deptParam = managedDept ? encodeURIComponent(managedDept) : "";
                console.log("userRole =", userRole);
                console.log("managedDept =", managedDept);
                const queryParams = `role=${userRole}&managedDept=${deptParam}`;

                const revUrl = `/gt-api/get_employee_reviews.php?${queryParams}`;
                const okrUrl = `/gt-api/get_employee_okrs.php?${queryParams}`;
                const empUrl = `/gt-api/get_all_staff.php`;

                const [revRes, okrRes, empRes] = await Promise.all([
                    fetch(revUrl, { credentials: "include" }),
                    fetch(okrUrl, { credentials: "include" }),
                    fetch(empUrl, { credentials: "include" })
                ]);

                const revText = await revRes.text();
                const okrText = await okrRes.text();
                const empText = await empRes.text();


                const revData = JSON.parse(revText);
                const okrData = JSON.parse(okrText);
                const empData = JSON.parse(empText);



                if (revData.success && revData.data.length > 0) {
                    setReviews(revData.data);
                } else {
                    const fallbackRes = await fetch(`/gt-api/get_employee_reviews.php?role=SuperAdmin`, {
                        credentials: "include"
                    });
                    const fallbackData = await fallbackRes.json();
                    if (fallbackData.success) setReviews(fallbackData.data);
                }

                setSubmissions(okrData.success ? okrData.data : (Array.isArray(okrData) ? okrData : []));
                console.log("SETTING SUBMISSIONS:", okrData.data);
                console.log("OKR DATA:", okrData.data);
                okrData.data.forEach((item) => {
                    console.log("ID:", item.id);
                    console.log(item.okr_details);
                });
                console.log("FIRST SUBMISSION:", okrData.data[0]);

                if (empData.success && Array.isArray(empData.data)) {
                    setAllEmployees(empData.data);
                } else {
                    setAllEmployees([]);
                }

            } catch (err) {
                console.error("❌ Fetch error:", err);
                setAllEmployees([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [userRole, managedDept]);

    useEffect(() => {
        const fetchLocks = async () => {
            try {
                const res = await fetch(
                    `/gt-api/lock_timeline.php?year=${lockYear}`,
                    {
                        credentials: "include"
                    }
                );
                const data = await res.json();

                console.log("LOCK DATA:", data); // debug

                if (data.success) {
                    setLockedQuarters(data.locks || {});
                }
            } catch (err) {
                console.error("LOCK FETCH ERROR:", err);
            }
        };

        fetchLocks();
    }, [lockYear]);


    // 🔍 Search + Filter states
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDept, setSelectedDept] = useState("");
    const [previewImage, setPreviewImage] = useState(null);
    const [viewType, setViewType] = useState("submitted");
    const getCurrentQuarter = () => {
        const month = new Date().getMonth() + 1;

        if (month >= 4 && month <= 6) return "Quarter 1";
        if (month >= 7 && month <= 9) return "Quarter 2";
        if (month >= 10 && month <= 12) return "Quarter 3";
        return "Quarter 4";
    };

    const currentQuarter = getCurrentQuarter();



    const handleDeleteEntireOKR = () => {

        setModalPassword("");
        setShowModalPassword(false);
        setPasswordModal({
            isOpen: true,
            confirmMessage: "Are you sure you want to permanently delete this entire OKR? This action cannot be undone.",
            title: "Enter your Password or Master Password to confirm deletion:",
            onConfirm: async (password) => {
                if (!password) {
                    showMessage("Password is required.", "error");
                    return;
                }

                setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

                try {

                    const authRes = await fetch(
                        "/gt-api/verify_delete_password.php",
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ password })
                        }
                    );

                    const authData = await authRes.json();

                    if (!authData.success) {
                        showMessage("Invalid Password", "error");
                        return;
                    }

                    const response = await fetch(
                        '/gt-api/delete_okr.php',
                        {
                            method: 'POST',
                            credentials: "include",
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                submission_id: selected.id
                            })
                        }
                    );

                    const res = await response.json();

                    if (res.success) {
                        showMessage("OKR deleted successfully!", "success", () => {
                            setSelected(null);
                            window.location.reload();
                        });
                    }

                } catch (err) {
                    showMessage("Server error while deleting OKR", "error");
                }
            }
        });
    };


    const handleManagementSubmit = async () => {
        const isManagerReview = activeTab === "Manager Review";
        const isProbation = activeTab === "Probation Period Feedback";

        // Validation: If probation, we don't need to check "content" state since it's hardcoded
        const hasContent = isManagerReview
            ? (mgmtSelection.accomplished.trim() && mgmtSelection.improvements.trim())
            : (isProbation ? true : mgmtSelection.content.trim());

        if (!mgmtSelection.emp_id || !hasContent) {
            alert("Please select an employee and fill in all required fields.");
            return;
        }

        const apiEndpoint = isProbation
            ? '/gt-api/save_probation_notice.php'
            : '/gt-api/save_management_notice.php';

        setIsSubmittingMgmt(true);
        try {
            let finalContent = "";
            if (isManagerReview) {
                finalContent = `ACCOMPLISHED: ${mgmtSelection.accomplished}\n\nIMPROVEMENTS NEEDED: ${mgmtSelection.improvements}`;
            } else if (isProbation) {
                finalContent = PROBATION_MESSAGE;
            } else {
                finalContent = mgmtSelection.content;
            }

            const response = await fetch(apiEndpoint, {
                method: 'POST',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    emp_id: mgmtSelection.emp_id,
                    content: finalContent,
                    type: activeTab,
                    sender_role: userRole
                })
            });

            const res = await response.json();

            if (res.success) {
                alert(res.message || `${activeTab} submitted successfully!`);
                if (isProbation) {
                    setAllEmployees(prev => prev.map(emp => {
                        if (String(emp.empid) === String(mgmtSelection.emp_id)) {
                            return { ...emp, probation_status: 'Permanent', probation_feedback_sent_at: new Date().toISOString() };
                        }
                        return emp;
                    }));
                }
                setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
            } else {
                alert("Error: " + (res.message || "Unknown error"));
            }
        } catch (err) {
            alert("Failed to connect to the server.");
        } finally {
            setIsSubmittingMgmt(false);
        }
    };


    console.log("========== SUBMISSIONS ==========");
    console.log(submissions);

    submissions.forEach(s => {
        console.log(
            s.id,
            s.emp_name,
            s.workflow_status,
            s.quarter,
            s.year
        );
    });
    const groupedData = submissions.reduce((acc, sub) => {

        const name = sub.emp_name;
        const year = sub.year;

        if (!acc[name]) {
            acc[name] = {
                emp_id: sub.emp_id,
                years: {},
                profile_image: sub.profile_image
            };
        }

        if (!acc[name].years[year]) acc[name].years[year] = [];
        acc[name].years[year].push(sub);

        return acc;
    }, {});
    console.log("GROUPED DATA", groupedData);


    // 🔍 Apply search + department filter
    const filteredGroupedData = Object.entries(groupedData).filter(([empName, data]) => {
        const matchesSearch = empName.toLowerCase().includes(searchTerm.toLowerCase());

        const empDept =
            data.years[Object.keys(data.years)[0]][0].department || "";

        const matchesDept = selectedDept ? empDept === selectedDept : true;

        return matchesSearch && matchesDept;
    });

    const handleStatusChange = async (oIdx, kIdx, newStatus) => {
        const updated = { ...selected };

        if (!updated.okr_details[oIdx].keyResults) {
            updated.okr_details[oIdx].keyResults = [];
        }

        while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
            updated.okr_details[oIdx].keyResults.push({
                text: "",
                result: "Pending",
                ar_comment: ""
            });
        }

        updated.okr_details[oIdx].keyResults[kIdx].result = newStatus;

        setSelected(updated);

        // 🔥 AUTO SAVE
        try {
            await fetch('/gt-api/update_okr_management.php', {
                method: 'POST',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    submission_id: updated.id,
                    okr_details: JSON.stringify(updated.okr_details),
                    workflow_status: updated.workflow_status
                })
            });
        } catch (err) {
            console.error("Auto save failed");
        }
    };

    const showEditWarning = () => {
        if (!hasShownEditWarning) {
            alert("You have modified the OKR. Click SAVE to persist your changes.");
            setHasShownEditWarning(true);
        }
    };

    const handleKRTextChange = (oIdx, kIdx, newText) => {
        showEditWarning();
        const updated = { ...selected };

        if (!updated.okr_details[oIdx].keyResults) {
            updated.okr_details[oIdx].keyResults = [];
        }

        while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
            updated.okr_details[oIdx].keyResults.push({
                text: "",
                result: "Pending",
                ar_comment: ""
            });
        }

        updated.okr_details[oIdx].keyResults[kIdx].text = newText;

        setSelected(updated);
    };

    // ❌ DELETE KEY RESULT
    const handleDeleteKR = (oIdx, kIdx) => {

        setModalPassword("");
        setShowModalPassword(false);
        setPasswordModal({
            isOpen: true,
            confirmMessage: "Are you sure you want to delete this Key Result?",
            title: "Enter your Password or Master Password to delete this Key Result:",
            onConfirm: async (password) => {
                if (!password) {
                    showMessage("Password is required.", "error");
                    return;
                }

                setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

                try {

                    const authRes = await fetch(
                        "/gt-api/verify_delete_password.php",
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ password })
                        }
                    );

                    const authData = await authRes.json();

                    if (!authData.success) {
                        showMessage("Invalid Password", "error");
                        return;
                    }

                    const updated = {
                        ...selected,
                        okr_details: [...selected.okr_details]
                    };

                    updated.okr_details[oIdx].keyResults = [
                        ...updated.okr_details[oIdx].keyResults
                    ];

                    updated.okr_details[oIdx].keyResults.splice(kIdx, 1);

                    const response = await fetch(
                        "/gt-api/update_okr_management.php",
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                submission_id: updated.id,
                                okr_details: JSON.stringify(updated.okr_details),
                                workflow_status: updated.workflow_status
                            })
                        }
                    );

                    const res = await response.json();

                    if (res.success) {
                        setSelected(updated);
                        showMessage("Key Result deleted successfully!", "success");
                    } else {
                        showMessage("Failed to delete Key Result.", "error");
                    }

                } catch (err) {
                    showMessage("Authentication failed", "error");
                }
            }
        });
    };

    const handleAddObjective = () => {
        const updated = { ...selected };

        if (!updated.okr_details) updated.okr_details = [];

        updated.okr_details.push({
            objective: "New Objective",
            keyResults: [{ text: "", result: "Pending" }]
        });

        setSelected(updated);
        alert("Objective added successfully! Scroll down to the bottom of the page to see it. Please click on SAVE after you make your changes.");
    };

    // ➕ ADD NEW KEY RESULT
    const handleAddKR = (oIdx) => {
        const updated = { ...selected };

        updated.okr_details[oIdx].keyResults.push({
            text: "",
            result: "Pending"
        });

        setSelected(updated);
    };

    const handleDeleteObjective = (oIdx) => {

        setModalPassword("");
        setShowModalPassword(false);
        setPasswordModal({
            isOpen: true,
            confirmMessage: "Are you sure you want to delete this objective? All associated Key Results will also be removed.",
            title: "Enter your Password or Master Password to delete this objective:",
            onConfirm: async (password) => {
                if (!password) {
                    showMessage("Password is required.", "error");
                    return;
                }

                setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });

                try {

                    const authRes = await fetch(
                        "/gt-api/verify_delete_password.php",
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ password })
                        }
                    );

                    const authData = await authRes.json();

                    if (!authData.success) {
                        showMessage("Invalid Password", "error");
                        return;
                    }

                    const updated = {
                        ...selected,
                        okr_details: [...selected.okr_details]
                    };

                    updated.okr_details.splice(oIdx, 1);

                    const response = await fetch(
                        "/gt-api/update_okr_management.php",
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                submission_id: updated.id,
                                okr_details: JSON.stringify(updated.okr_details),
                                workflow_status: updated.workflow_status
                            })
                        }
                    );

                    const res = await response.json();

                    if (res.success) {
                        setSelected(updated);
                        showMessage("Objective deleted successfully!", "success");
                    } else {
                        showMessage("Failed to delete objective.", "error");
                    }

                } catch (err) {
                    showMessage("Authentication failed", "error");
                }
            }
        });
    };

    const handleSaveEditedOKR = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to save these changes?\n\nThese updates will be reflected in the employee's OKR."
        );

        if (!confirmed) return;
        try {
            setIsUpdating(true);

            const response = await fetch(
                '/gt-api/update_okr_management.php',
                {
                    method: 'POST',
                    credentials: "include",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        submission_id: selected.id,
                        okr_details: JSON.stringify(selected.okr_details),
                        workflow_status: selected.workflow_status
                    })
                }
            );

            const res = await response.json();

            if (res.success) {

                alert("Changes saved successfully!");

                console.log("SELECTED BEFORE UPDATE", selected);

                setSubmissions(prev =>
                    prev.map(item =>
                        item.id === selected.id
                            ? {
                                ...item,
                                okr_details: JSON.stringify(selected.okr_details),
                                workflow_status: selected.workflow_status
                            }
                            : item
                    )
                );

                setHasShownEditWarning(false);
            } else {
                alert("Failed to save changes");
            }

        } catch (err) {
            console.error(err);
            alert("Server error while saving");
        } finally {
            setIsUpdating(false);
        }
    };

    const updateOKRStatus = async (customStatus = null) => {
        if (customStatus === "Scoring") {
            const confirmed = window.confirm(
                "Are you sure you want to approve this OKR?\n\nAfter approval, the employee will NOT be able to edit this OKR."
            );

            if (!confirmed) return;
        }

        if (customStatus === "Returned_To_Employee") {
            const confirmed = window.confirm(
                "Are you sure you want to return this OKR to the employee?\n\nThe employee will be able to edit and resubmit the OKR."
            );

            if (!confirmed) return;
        }
        setIsUpdating(true);

        let nextWorkflowStatus = '';
        if (customStatus) {
            nextWorkflowStatus = customStatus;
        } else if (selected.workflow_status === 'Management_Review') {
            nextWorkflowStatus = 'Scoring';
        } else if (selected.workflow_status === 'Manager_Scoring_Review') {
            nextWorkflowStatus = 'Sign_Off';
        }

        const cleanedOKR = JSON.parse(JSON.stringify(selected.okr_details)).map(obj => ({
            ...obj,
            keyResults: obj.keyResults.map(kr => {
                const newKR = { ...kr };

                if (nextWorkflowStatus === 'Scoring') {
                    delete newKR.ar_comment;
                }

                return newKR;
            })
        }));
        try {
            const response = await fetch('/gt-api/update_okr_management.php', {
                method: 'POST',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    submission_id: selected.id,
                    okr_details: JSON.stringify(cleanedOKR),
                    workflow_status: nextWorkflowStatus
                })
            });

            const res = await response.json();

            if (res.success) {
                setSelected(prev => ({
                    ...prev,
                    okr_details: cleanedOKR,
                    workflow_status: nextWorkflowStatus
                }));
                window.location.reload();
            }
        } catch (err) {
            alert("🚨 Sync failed");
        } finally {
            setIsUpdating(false);
        }
    };


    const renderCustomAlertModal = () => {
        if (!customAlert.isOpen) return null;

        return createPortal(
            <div className="custom-alert-modal-overlay">
                <div className="custom-alert-modal-card animate-fade">
                    <div className="custom-alert-modal-icon">
                        {customAlert.type === "success" ? (
                            <div className="alert-icon-success">✓</div>
                        ) : (
                            <div className="alert-icon-error">✕</div>
                        )}
                    </div>
                    <h3 className="custom-alert-modal-title">
                        {customAlert.type === "success" ? "Success" : "Error"}
                    </h3>
                    <p className="custom-alert-modal-msg">{customAlert.message}</p>
                    <button
                        type="button"
                        className="custom-alert-modal-ok-btn"
                        onClick={() => {
                            const closeHandler = customAlert.onClose;
                            setCustomAlert({ isOpen: false, type: "error", message: "", onClose: null });
                            if (closeHandler) closeHandler();
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>,
            document.body
        );
    };


    const renderPasswordModal = () => {
        if (!passwordModal.isOpen) return null;

        return createPortal(
            <div className="delete-password-modal-overlay">
                <div className="delete-password-modal-card">
                    <h3 className="delete-password-modal-title">
                        ⚠️ Delete Confirmation
                    </h3>

                    {passwordModal.confirmMessage && (
                        <p className="delete-password-modal-msg">
                            {passwordModal.confirmMessage}
                        </p>
                    )}

                    <p className="delete-password-modal-label">
                        {passwordModal.title}
                    </p>

                    <div className="delete-password-modal-input-wrapper">
                        <input
                            type={showModalPassword ? "text" : "password"}
                            placeholder="Enter password..."
                            value={modalPassword}
                            onChange={(e) => setModalPassword(e.target.value)}
                            className="delete-password-modal-input"
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    passwordModal.onConfirm(modalPassword);
                                }
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => setShowModalPassword(!showModalPassword)}
                            className="delete-password-modal-toggle-btn"
                        >
                            {showModalPassword ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                            ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            )}
                        </button>
                    </div>

                    <div className="delete-password-modal-btn-group">
                        <button
                            type="button"
                            onClick={() => {
                                setPasswordModal({ isOpen: false, title: "", confirmMessage: "", onConfirm: null });
                                setModalPassword("");
                                setShowModalPassword(false);
                            }}
                            className="delete-password-modal-cancel-btn"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={() => passwordModal.onConfirm(modalPassword)}
                            className="delete-password-modal-confirm-btn"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>,
            document.body
        );
    };

    const [activeObjective, setActiveObjective] = useState(null);
    const renderManagementActionForm = (title) => {
        const isManagerReview = title === "Manager Review";
        const isProbation = title === "Probation Period Feedback";

        // Filter employees for the probation table on the left
        const allProbationEmployees = (allEmployees || []).filter(e => e.probation_status !== 'Permanent');
        const filteredProbationList = allProbationEmployees.filter(emp => {
            if (!probationSearch) return true;
            const q = probationSearch.toLowerCase();
            const nameMatch = (emp.full_name || '').toLowerCase().includes(q);
            const teamMatch = (emp.team || '').toLowerCase().includes(q);
            const idMatch = String(emp.empid || '').toLowerCase().includes(q);
            return nameMatch || teamMatch || idMatch;
        });

        const PROBATION_PAGE_SIZE = 8;
        const totalProbationPages = Math.max(1, Math.ceil(filteredProbationList.length / PROBATION_PAGE_SIZE));
        const pagedProbationList = filteredProbationList.slice(
            (probationPage - 1) * PROBATION_PAGE_SIZE,
            probationPage * PROBATION_PAGE_SIZE
        );

        // Action form content (used in both probation right-card and manager review)
        const renderActionFormContent = () => {
            const probationCount = allEmployees?.filter(e => e.probation_status !== 'Permanent').length || 0;

            const selectedEmp = allEmployees?.find(e => String(e.empid) === String(mgmtSelection.emp_id));
            const selectedLabel = selectedEmp
                ? (isProbation && selectedEmp.probation_status !== 'Permanent'
                    ? `⭐ [PROBATION] ${selectedEmp.full_name} (${selectedEmp.team || 'IT'})`
                    : `${selectedEmp.full_name} (${selectedEmp.team || 'General'})`)
                : "";

            // Filter employees by combobox search query
            let filtered = (allEmployees || []).filter(emp => {
                const q = (comboboxSearch || "").trim().toLowerCase();
                if (!q) return true;
                const nameMatch = (emp.full_name || '').toLowerCase().includes(q);
                const teamMatch = (emp.team || '').toLowerCase().includes(q);
                const idMatch = String(emp.empid || '').toLowerCase().includes(q);
                const isProbMatch = (emp.probation_status !== 'Permanent') && 'probation'.includes(q);
                return nameMatch || teamMatch || idMatch || isProbMatch;
            });

            // For Probation tab, place active probation employees at the top
            if (isProbation) {
                filtered = [...filtered].sort((a, b) => {
                    const aProb = a.probation_status !== 'Permanent';
                    const bProb = b.probation_status !== 'Permanent';
                    if (aProb && !bProb) return -1;
                    if (!aProb && bProb) return 1;
                    return (a.full_name || '').localeCompare(b.full_name || '');
                });
            }

            const probationList = filtered.filter(emp => emp.probation_status !== 'Permanent');
            const permanentList = filtered.filter(emp => emp.probation_status === 'Permanent');

            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div className="form-group" style={{ marginBottom: 0, position: 'relative', zIndex: isDropdownOpen ? 9999 : 2 }}>
                        <label style={{ color: '#00bcd4', fontSize: '12px', margin: '0 0 8px 0', fontWeight: 600, display: 'block' }}>
                            SELECT EMPLOYEE
                        </label>

                        {/* Single Unified Searchable Dropdown Combobox */}
                        <div ref={selectDropdownRef} className="custom-select-wrapper" style={{ position: 'relative', width: '100%', zIndex: isDropdownOpen ? 9999 : 2 }}>
                            <div
                                className={`mgmt-combobox-trigger ${isDropdownOpen ? 'open' : ''}`}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: '10px',
                                    transition: 'all 0.2s ease',
                                    cursor: 'pointer',
                                    minHeight: '46px',
                                    padding: '0 12px',
                                    boxSizing: 'border-box',
                                    gap: '10px'
                                }}
                                onClick={() => {
                                    setIsDropdownOpen(prev => !prev);
                                }}
                            >
                                {isDropdownOpen ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }} onClick={(e) => e.stopPropagation()}>
                                        <Search size={16} color="#2563eb" style={{ flexShrink: 0 }} />
                                        <input
                                            type="text"
                                            className="mgmt-combobox-input"
                                            value={comboboxSearch}
                                            onChange={(e) => setComboboxSearch(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Escape") {
                                                    setIsDropdownOpen(false);
                                                    setComboboxSearch("");
                                                } else if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    if (filtered.length > 0) {
                                                        setMgmtSelection(prev => ({ ...prev, emp_id: String(filtered[0].empid) }));
                                                        setComboboxSearch("");
                                                        setIsDropdownOpen(false);
                                                    }
                                                }
                                            }}
                                            placeholder={selectedEmp ? `Search to change (selected: ${selectedEmp.full_name})...` : "Type employee name, ID or department..."}
                                            autoFocus
                                            autoComplete="off"
                                            spellCheck="false"
                                            style={{
                                                width: '100%',
                                                height: '28px',
                                                fontSize: '13.5px',
                                                background: 'transparent',
                                                border: 'none',
                                                outline: 'none',
                                                boxShadow: 'none',
                                                padding: 0,
                                                margin: 0
                                            }}
                                        />
                                    </div>
                                ) : selectedEmp ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: 0, overflow: 'hidden' }}>
                                        {selectedEmp.profile_image ? (
                                            <img src={selectedEmp.profile_image} alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                                        ) : (
                                            <div style={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: '50%',
                                                backgroundColor: selectedEmp.probation_status !== 'Permanent' ? '#fef3c7' : '#dbeafe',
                                                color: selectedEmp.probation_status !== 'Permanent' ? '#b45309' : '#1d4ed8',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                flexShrink: 0
                                            }}>
                                                {getEmployeeInitials(selectedEmp.full_name)}
                                            </div>
                                        )}
                                        <span className="mgmt-emp-name" style={{ fontWeight: 600, fontSize: '13.5px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {selectedEmp.full_name}
                                        </span>
                                        {isProbation && selectedEmp.probation_status !== 'Permanent' && (
                                            <span style={{
                                                background: '#fef3c7',
                                                color: '#b45309',
                                                border: '1px solid #fde68a',
                                                fontSize: '10.5px',
                                                fontWeight: 700,
                                                padding: '2px 8px',
                                                borderRadius: '12px',
                                                whiteSpace: 'nowrap',
                                                flexShrink: 0,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}>
                                                ⭐ Probation
                                            </span>
                                        )}
                                        <span className="mgmt-emp-team" style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                                            ({selectedEmp.team || 'General'})
                                        </span>
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, color: '#94a3b8' }}>
                                        <Search size={16} color="#94a3b8" style={{ flexShrink: 0 }} />
                                        <span style={{ fontSize: '13px' }}>Search or select employee by name, ID or department...</span>
                                    </div>
                                )}

                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                                    {mgmtSelection.emp_id && (
                                        <button
                                            type="button"
                                            className="mgmt-clear-trigger-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setMgmtSelection(prev => ({ ...prev, emp_id: "" }));
                                                setComboboxSearch("");
                                            }}
                                            title="Clear selection"
                                        >
                                            ✕
                                        </button>
                                    )}

                                    <div style={{ color: '#64748b', display: 'flex', alignItems: 'center' }}>
                                        <ChevronDown
                                            size={16}
                                            style={{
                                                transition: 'transform 0.2s ease',
                                                transform: isDropdownOpen ? 'rotate(180deg)' : 'none'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Dropdown Options List */}
                            {isDropdownOpen && (
                                <div
                                    className="mgmt-custom-dropdown-menu"
                                    style={{
                                        position: 'absolute',
                                        top: 'calc(100% + 6px)',
                                        left: 0,
                                        right: 0,
                                        zIndex: 99999,
                                        borderRadius: '12px',
                                        maxHeight: '320px',
                                        overflowY: 'auto',
                                        padding: '6px 0'
                                    }}
                                >
                                    {mgmtSelection.emp_id && (
                                        <div className="mgmt-deselect-box" style={{ padding: '6px 10px 8px 10px' }}>
                                            <button
                                                type="button"
                                                className="mgmt-deselect-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setMgmtSelection(prev => ({ ...prev, emp_id: "" }));
                                                    setComboboxSearch("");
                                                    setIsDropdownOpen(false);
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '7px 12px',
                                                    borderRadius: '8px',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '6px',
                                                    transition: 'all 0.15s ease'
                                                }}
                                            >
                                                <span style={{ fontSize: '13px' }}>✕</span> Deselect current employee
                                            </button>
                                        </div>
                                    )}

                                    {isProbation ? (
                                        <>
                                            {probationList.length > 0 && (
                                                <>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        padding: '8px 14px 4px 14px',
                                                        fontSize: '11px',
                                                        fontWeight: 700,
                                                        letterSpacing: '0.06em',
                                                        textTransform: 'uppercase',
                                                        color: '#d97706',
                                                        userSelect: 'none'
                                                    }}>
                                                        <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <span>⚡</span> ON PROBATION
                                                        </span>
                                                        <span style={{
                                                            background: '#fef3c7',
                                                            color: '#b45309',
                                                            fontSize: '10px',
                                                            fontWeight: 700,
                                                            padding: '1px 7px',
                                                            borderRadius: '10px',
                                                            border: '1px solid #fde68a'
                                                        }}>
                                                            {probationList.length}
                                                        </span>
                                                    </div>
                                                    {probationList.map((emp) => {
                                                        const isSelected = String(mgmtSelection.emp_id) === String(emp.empid);
                                                        const initials = getEmployeeInitials(emp.full_name);
                                                        return (
                                                            <div
                                                                key={emp.empid}
                                                                className={`mgmt-dropdown-row probation-row ${isSelected ? 'selected' : ''}`}
                                                                onClick={() => {
                                                                    setMgmtSelection(prev => ({ ...prev, emp_id: String(emp.empid) }));
                                                                    setComboboxSearch("");
                                                                    setIsDropdownOpen(false);
                                                                }}
                                                            >
                                                                {emp.profile_image ? (
                                                                    <img src={emp.profile_image} alt="" style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                                                                ) : (
                                                                    <div style={{
                                                                        width: 32,
                                                                        height: 32,
                                                                        borderRadius: '50%',
                                                                        background: '#fde68a',
                                                                        color: '#92400e',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '12px',
                                                                        fontWeight: 700,
                                                                        flexShrink: 0,
                                                                        border: '1px solid #fcd34d'
                                                                    }}>
                                                                        {initials}
                                                                    </div>
                                                                )}
                                                                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1, gap: '2px' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                        <span className="mgmt-row-name" style={{ fontWeight: 600, fontSize: '13.5px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                            {emp.full_name}
                                                                        </span>
                                                                        <span style={{
                                                                            background: '#fef3c7',
                                                                            color: '#b45309',
                                                                            border: '1px solid #fde68a',
                                                                            fontSize: '10px',
                                                                            fontWeight: 700,
                                                                            padding: '1px 6px',
                                                                            borderRadius: '10px',
                                                                            whiteSpace: 'nowrap',
                                                                            flexShrink: 0
                                                                        }}>
                                                                            ⭐ Probation
                                                                        </span>
                                                                    </div>
                                                                    <div className="mgmt-row-subtitle" style={{ fontSize: '11.5px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        <span>{emp.team || 'General'}</span>
                                                                        <span>•</span>
                                                                        <span>ID: {emp.empid}</span>
                                                                    </div>
                                                                </div>
                                                                {isSelected ? (
                                                                    <div style={{
                                                                        width: 22,
                                                                        height: 22,
                                                                        borderRadius: '50%',
                                                                        background: '#f59e0b',
                                                                        color: '#ffffff',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        <Check size={14} strokeWidth={3} />
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            )}

                                            {permanentList.length > 0 && (
                                                <>
                                                    <div className="mgmt-group-header-permanent" style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        padding: '12px 14px 4px 14px',
                                                        margin: '4px 0 2px 0',
                                                        fontSize: '11px',
                                                        fontWeight: 700,
                                                        letterSpacing: '0.06em',
                                                        textTransform: 'uppercase',
                                                        userSelect: 'none'
                                                    }}>
                                                        <span>PERMANENT EMPLOYEES</span>
                                                        <span className="mgmt-badge-permanent-count" style={{
                                                            fontSize: '10px',
                                                            fontWeight: 700,
                                                            padding: '1px 7px',
                                                            borderRadius: '10px'
                                                        }}>
                                                            {permanentList.length}
                                                        </span>
                                                    </div>
                                                    {permanentList.map((emp, index) => {
                                                        const isSelected = String(mgmtSelection.emp_id) === String(emp.empid);
                                                        const initials = getEmployeeInitials(emp.full_name);
                                                        const avatarColor = AVATAR_COLORS[index % AVATAR_COLORS.length];
                                                        return (
                                                            <div
                                                                key={emp.empid}
                                                                className={`mgmt-dropdown-row permanent-row ${isSelected ? 'selected' : ''}`}
                                                                onClick={() => {
                                                                    setMgmtSelection(prev => ({ ...prev, emp_id: String(emp.empid) }));
                                                                    setComboboxSearch("");
                                                                    setIsDropdownOpen(false);
                                                                }}
                                                            >
                                                                {emp.profile_image ? (
                                                                    <img src={emp.profile_image} alt="" style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                                                                ) : (
                                                                    <div style={{
                                                                        width: 32,
                                                                        height: 32,
                                                                        borderRadius: '50%',
                                                                        background: avatarColor.bg,
                                                                        color: avatarColor.color,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        fontSize: '12px',
                                                                        fontWeight: 700,
                                                                        flexShrink: 0
                                                                    }}>
                                                                        {initials}
                                                                    </div>
                                                                )}
                                                                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1, gap: '2px' }}>
                                                                    <span className="mgmt-row-name" style={{ fontWeight: isSelected ? 600 : 500, fontSize: '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                        {emp.full_name}
                                                                    </span>
                                                                    <div className="mgmt-row-subtitle" style={{ fontSize: '11.5px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        <span>{emp.team || 'General'}</span>
                                                                        <span>•</span>
                                                                        <span>ID: {emp.empid}</span>
                                                                    </div>
                                                                </div>
                                                                {isSelected && (
                                                                    <div style={{
                                                                        width: 22,
                                                                        height: 22,
                                                                        borderRadius: '50%',
                                                                        background: '#2563eb',
                                                                        color: '#ffffff',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        flexShrink: 0
                                                                    }}>
                                                                        <Check size={14} strokeWidth={3} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            )}

                                            {probationList.length === 0 && permanentList.length === 0 && (
                                                <div style={{ padding: '24px 16px', textAlign: 'center', color: '#64748b', fontSize: '12.5px' }}>
                                                    <Search size={22} color="#94a3b8" style={{ margin: '0 auto 8px auto', display: 'block' }} />
                                                    <div style={{ fontWeight: 600, color: '#334155' }}>No employees found</div>
                                                    <div style={{ fontSize: '11.5px', color: '#94a3b8', marginTop: '3px' }}>No matches for "{comboboxSearch}"</div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        filtered.length > 0 ? (
                                            filtered.map((emp, index) => {
                                                const isSelected = String(mgmtSelection.emp_id) === String(emp.empid);
                                                const initials = getEmployeeInitials(emp.full_name);
                                                const avatarColor = AVATAR_COLORS[index % AVATAR_COLORS.length];
                                                return (
                                                    <div
                                                        key={emp.empid}
                                                        className={`mgmt-dropdown-row permanent-row ${isSelected ? 'selected' : ''}`}
                                                        onClick={() => {
                                                            setMgmtSelection(prev => ({ ...prev, emp_id: String(emp.empid) }));
                                                            setComboboxSearch("");
                                                            setIsDropdownOpen(false);
                                                        }}
                                                    >
                                                        {emp.profile_image ? (
                                                            <img src={emp.profile_image} alt="" style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                                                        ) : (
                                                            <div style={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: '50%',
                                                                background: avatarColor.bg,
                                                                color: avatarColor.color,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: 700,
                                                                flexShrink: 0
                                                            }}>
                                                                {initials}
                                                            </div>
                                                        )}
                                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1, gap: '2px' }}>
                                                            <span className="mgmt-row-name" style={{ fontWeight: isSelected ? 600 : 500, fontSize: '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {emp.full_name}
                                                            </span>
                                                            <div className="mgmt-row-subtitle" style={{ fontSize: '11.5px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                <span>{emp.team || 'General'}</span>
                                                                <span>•</span>
                                                                <span>ID: {emp.empid}</span>
                                                            </div>
                                                        </div>
                                                        {isSelected && (
                                                            <div style={{
                                                                width: 22,
                                                                height: 22,
                                                                borderRadius: '50%',
                                                                background: '#2563eb',
                                                                color: '#ffffff',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                flexShrink: 0
                                                            }}>
                                                                <Check size={14} strokeWidth={3} />
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div style={{ padding: '24px 16px', textAlign: 'center', color: '#64748b', fontSize: '12.5px' }}>
                                                <Search size={22} color="#94a3b8" style={{ margin: '0 auto 8px auto', display: 'block' }} />
                                                <div style={{ fontWeight: 600, color: '#334155' }}>No employees found</div>
                                                <div style={{ fontSize: '11.5px', color: '#94a3b8', marginTop: '3px' }}>No matches for "{comboboxSearch}"</div>
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {isProbation && mgmtSelection.emp_id && (() => {
                        const selectedEmp = allEmployees?.find(e => String(e.empid) === String(mgmtSelection.emp_id));
                        const isPerm = selectedEmp && selectedEmp.probation_status === 'Permanent';
                        return (
                            <div
                                className={`mgmt-probation-status-alert ${isPerm ? 'permanent' : 'probation'}`}
                                style={{
                                    position: 'relative',
                                    zIndex: 1,
                                    fontSize: '12px',
                                    padding: '10px 14px',
                                    borderRadius: '6px',
                                    fontWeight: 500
                                }}
                            >
                                {isPerm 
                                    ? "✅ This employee is already confirmed as Permanent." 
                                    : "⏳ Employee is currently in Probation. Submitting will send the confirmation email and transition them to Permanent status."}
                            </div>
                        );
                    })()}

                    {isManagerReview ? (
                        <>
                            <div className="form-group" style={{ position: 'relative', zIndex: 1 }}>
                                <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>EMPLOYEE ACCOMPLISHED</label>
                                <textarea
                                    className="modern-textarea"
                                    placeholder="Describe key accomplishments..."
                                    style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
                                    value={mgmtSelection.accomplished}
                                    onChange={(e) => setMgmtSelection({ ...mgmtSelection, accomplished: e.target.value })}
                                />
                            </div>
                            <div className="form-group" style={{ position: 'relative', zIndex: 1 }}>
                                <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>IMPROVEMENT NEEDED</label>
                                <textarea
                                    className="modern-textarea"
                                    placeholder="Describe areas for improvement..."
                                    style={{ width: '100%', minHeight: '100px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
                                    value={mgmtSelection.improvements}
                                    onChange={(e) => setMgmtSelection({ ...mgmtSelection, improvements: e.target.value })}
                                />
                            </div>
                        </>
                    ) : isProbation ? (
                        <div className="form-group" style={{ position: 'relative', zIndex: 1 }}>
                            <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '6px', display: 'block', fontWeight: 600 }}>CONFIRMATION MESSAGE PREVIEW</label>
                            <div
                                className="mgmt-confirmation-preview-box"
                                style={{
                                    padding: '18px 20px',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    whiteSpace: 'pre-wrap',
                                    lineHeight: '1.6'
                                }}
                            >
                                {PROBATION_MESSAGE}
                            </div>
                        </div>
                    ) : (
                        <div className="form-group" style={{ position: 'relative', zIndex: 1 }}>
                            <label style={{ color: '#00bcd4', fontSize: '12px', marginBottom: '5px', display: 'block' }}>MESSAGE / NOTICE</label>
                            <textarea
                                className="modern-textarea"
                                placeholder={`Write the ${title.toLowerCase()} details here...`}
                                style={{ width: '100%', minHeight: '150px', background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', padding: '10px', borderRadius: '4px' }}
                                value={mgmtSelection.content}
                                onChange={(e) => setMgmtSelection({ ...mgmtSelection, content: e.target.value })}
                            />
                        </div>
                    )}

                    <button
                        className={isProbation ? "probation-submit-btn" : "btn-primary"}
                        style={{
                            marginTop: '10px',
                            width: '100%',
                            padding: '12px',
                            borderRadius: '8px',
                            fontSize: '13px',
                            fontWeight: 700,
                            letterSpacing: '0.5px'
                        }}
                        onClick={handleManagementSubmit}
                        disabled={isSubmittingMgmt}
                    >
                        {isSubmittingMgmt ? "SENDING..." : `SUBMIT ${title.toUpperCase()}`}
                    </button>
                </div>
            );
        };

        if (isProbation) {
            return (
                <div className="okr-genesis-container animate-fade" style={{ padding: '24px 20px' }}>
                    <div className="probation-feedback-layout">
                        {/* LEFT COLUMN: Probation Employees Table */}
                        <div className="okr-glass-card probation-card-container" style={{
                            padding: '24px',
                            borderRadius: '16px'
                        }}>
                            {/* Header */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Users size={22} color="#2563eb" style={{ flexShrink: 0 }} />
                                <h2 className="probation-card-title" style={{ fontSize: '1.25rem', fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center' }}>
                                    Probation Employees <span style={{ color: '#2563eb', fontWeight: 700, marginLeft: '6px' }}>({allProbationEmployees.length})</span>
                                </h2>
                            </div>

                            {/* Search Input */}
                            <div style={{ position: 'relative', marginTop: '16px', marginBottom: '14px' }}>
                                <Search size={15} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                                <input
                                    type="text"
                                    className="probation-search-input"
                                    placeholder="Search by name, employee ID or department..."
                                    value={probationSearch}
                                    onChange={(e) => {
                                        setProbationSearch(e.target.value);
                                        setProbationPage(1);
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '10px 34px 10px 36px',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                        boxSizing: 'border-box'
                                    }}
                                />
                                {probationSearch && (
                                    <button
                                        type="button"
                                        onClick={() => { setProbationSearch(""); setProbationPage(1); }}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            background: 'none',
                                            border: 'none',
                                            color: '#94a3b8',
                                            cursor: 'pointer',
                                            fontSize: '13px',
                                            padding: '2px 6px'
                                        }}
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            {/* Employees Table */}
                            <div style={{ overflowX: 'auto' }}>
                                <table className="probation-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '13px' }}>
                                    <thead>
                                        <tr className="probation-th-row">
                                            <th className="probation-th-cell" style={{ width: '40px', padding: '12px 8px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>#</th>
                                            <th className="probation-th-cell" style={{ padding: '12px 14px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Employee</th>
                                            <th className="probation-th-cell" style={{ padding: '12px 14px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Joining Date</th>
                                            <th className="probation-th-cell" style={{ padding: '12px 14px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Probation End Date</th>
                                            <th className="probation-th-cell" style={{ padding: '12px 14px', textAlign: 'center', fontWeight: 600, fontSize: '12px' }}>Days Left</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagedProbationList.length === 0 ? (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8', fontSize: '13px' }}>
                                                    <Users size={32} color="#cbd5e1" style={{ display: 'block', margin: '0 auto 8px' }} />
                                                    {probationSearch ? "No probation employees found matching your search." : "No employees currently in probation period."}
                                                </td>
                                            </tr>
                                        ) : (
                                            pagedProbationList.map((emp, idx) => {
                                                const isSelected = String(mgmtSelection.emp_id) === String(emp.empid);
                                                const rowNumber = (probationPage - 1) * PROBATION_PAGE_SIZE + idx + 1;
                                                const probationEnd = getProbationEndDate(emp.JoiningDate);
                                                const daysLeft = getDaysLeftCount(probationEnd);
                                                const badge = getDaysLeftBadgeConfig(daysLeft);
                                                const avatarStyle = AVATAR_COLORS[idx % AVATAR_COLORS.length];

                                                return (
                                                    <tr
                                                        key={emp.empid}
                                                        onClick={() => setMgmtSelection(prev => ({ ...prev, emp_id: String(emp.empid) }))}
                                                        className={`probation-table-row ${isSelected ? 'selected' : ''}`}
                                                        style={{
                                                            cursor: 'pointer',
                                                            transition: 'background-color 0.15s ease'
                                                        }}
                                                    >
                                                        <td
                                                            className="probation-id-cell probation-td-cell"
                                                            style={{
                                                                padding: '14px 8px',
                                                                textAlign: 'center',
                                                                fontSize: '13px',
                                                                fontWeight: isSelected ? 700 : 500,
                                                                color: isSelected ? '#2563eb' : '#64748b',
                                                                borderLeft: isSelected ? '3.5px solid #2563eb' : '3.5px solid transparent'
                                                            }}
                                                        >
                                                            {rowNumber}
                                                        </td>
                                                        <td className="probation-td-cell" style={{ padding: '12px 14px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                                {emp.profile_image ? (
                                                                    <img
                                                                        src={emp.profile_image}
                                                                        alt=""
                                                                        style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
                                                                    />
                                                                ) : (
                                                                    <div
                                                                        style={{
                                                                            width: 36,
                                                                            height: 36,
                                                                            borderRadius: '50%',
                                                                            backgroundColor: avatarStyle.bg,
                                                                            color: avatarStyle.color,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            fontWeight: 700,
                                                                            fontSize: '12.5px',
                                                                            flexShrink: 0
                                                                        }}
                                                                    >
                                                                        {getEmployeeInitials(emp.full_name)}
                                                                    </div>
                                                                )}
                                                                <div style={{ lineHeight: 1.35 }}>
                                                                    <div className="probation-emp-name" style={{ fontWeight: 600, fontSize: '13.5px' }}>
                                                                        {emp.full_name}
                                                                    </div>
                                                                    <div className="probation-emp-sub" style={{ fontSize: '11.5px', marginTop: '2px' }}>
                                                                        {emp.empid} · {emp.team || 'General'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="probation-td-cell" style={{ padding: '12px 14px' }}>
                                                            <div className="probation-date-text" style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12.5px' }}>
                                                                <Calendar size={14} color="#3b82f6" style={{ flexShrink: 0 }} />
                                                                <span>{formatProbationDate(emp.JoiningDate)}</span>
                                                            </div>
                                                        </td>
                                                        <td className="probation-td-cell" style={{ padding: '12px 14px' }}>
                                                            <div className="probation-date-text" style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '12.5px' }}>
                                                                <Calendar size={14} color="#3b82f6" style={{ flexShrink: 0 }} />
                                                                <span>{formatProbationDate(probationEnd)}</span>
                                                            </div>
                                                        </td>
                                                        <td className="probation-td-cell" style={{ padding: '12px 14px', textAlign: 'center' }}>
                                                            <span
                                                                style={{
                                                                    display: 'inline-block',
                                                                    padding: '4px 12px',
                                                                    borderRadius: '12px',
                                                                    fontSize: '11.5px',
                                                                    fontWeight: 700,
                                                                    backgroundColor: badge.bg,
                                                                    color: badge.color
                                                                }}
                                                            >
                                                                {badge.text}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="probation-pagination-wrapper" style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: '16px',
                                paddingTop: '12px'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <button
                                        type="button"
                                        className="probation-page-btn"
                                        onClick={() => setProbationPage(p => Math.max(1, p - 1))}
                                        disabled={probationPage === 1}
                                        style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: '6px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: probationPage === 1 ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <ChevronLeft size={14} />
                                    </button>
                                    {Array.from({ length: totalProbationPages }, (_, i) => i + 1).map(pageNum => (
                                        <button
                                            key={pageNum}
                                            type="button"
                                            className={`probation-page-btn ${pageNum === probationPage ? 'active' : ''}`}
                                            onClick={() => setProbationPage(pageNum)}
                                            style={{
                                                width: 30,
                                                height: 30,
                                                borderRadius: '6px',
                                                fontSize: '12.5px',
                                                fontWeight: 600,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {pageNum}
                                        </button>
                                    ))}
                                    <button
                                        type="button"
                                        className="probation-page-btn"
                                        onClick={() => setProbationPage(p => Math.min(totalProbationPages, p + 1))}
                                        disabled={probationPage === totalProbationPages}
                                        style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: '6px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: probationPage === totalProbationPages ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <ChevronRight size={14} />
                                    </button>
                                </div>

                                <div className="probation-page-info" style={{ fontSize: '12px' }}>
                                    {filteredProbationList.length > 0
                                        ? `Showing ${(probationPage - 1) * PROBATION_PAGE_SIZE + 1} - ${Math.min(probationPage * PROBATION_PAGE_SIZE, filteredProbationList.length)} of ${filteredProbationList.length}`
                                        : '0 of 0'}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN: Feedback Form Card */}
                        <div className="okr-glass-card probation-card-container" style={{
                            padding: '24px',
                            borderRadius: '16px'
                        }}>
                            <div className="list-header" style={{ marginBottom: '20px' }}>
                                <h2 className="probation-card-title" style={{ fontSize: '1.4rem', fontWeight: 700 }}>
                                    Post <span className="blue-gradient-text">Probation Period Feedback</span>
                                </h2>
                            </div>
                            {renderActionFormContent()}
                        </div>
                    </div>
                </div>
            );
        }

        // Single centered card for Manager Review (and other tabs)
        return (
            <div className="okr-genesis-container animate-fade">
                <div className="okr-glass-card" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <div className="list-header" style={{ marginBottom: '20px' }}>
                        <h2 style={{ fontSize: '1.4rem', color: '#fff' }}>Post <span className="blue-gradient-text">{title}</span></h2>
                    </div>
                    {renderActionFormContent()}
                </div>
            </div>
        );
    };











    const renderOKRTrackerTab = () => {
        if (loading) {
            return <div className="loading-screen">ACCESSING DIRECTORY...</div>;
        }

        const flagColors = [
            "linear-gradient(to right, #e63900, #ff8c00)",
            "linear-gradient(to right, #7c3aed, #a855f7)",
            "linear-gradient(to right, #16a34a, #22c55e)",
            "linear-gradient(to right, #dc2626, #ef4444)"
        ];

        const getCurrentQuarter = () => {
            const month = new Date().getMonth() + 1;
            if (month >= 4 && month <= 6) return "Quarter 1";
            if (month >= 7 && month <= 9) return "Quarter 2";
            if (month >= 10 && month <= 12) return "Quarter 3";
            return "Quarter 4";
        };

        const autoResize = (el) => {
            if (!el) return;
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
        };

        const currentQuarter = getCurrentQuarter();

        const submittedEmpIds = new Set(
            submissions
                .filter((sub) => sub.quarter === currentQuarter)
                .map((sub) => sub.emp_id)
        );

        const submittedEmployees = allEmployees.filter((emp) =>
            submittedEmpIds.has(emp.empid)
        );

        const missingEmployees = allEmployees.filter(
            (emp) => !submittedEmpIds.has(emp.empid)
        );

        // =========================
        // 🔹 SELECTED VIEW
        // =========================
        if (selected) {
            return (
                <div className="okr-vertical-reveal-viewer animate-fade">
                    <div className="bg-subtle-grid"></div>

                    {/* HEADER */}
                    <div className="nav-strip-glass">
                        <button
                            className="back-btn-cyber"
                            onClick={() => {
                                setSelected(null);
                                setActiveObjective(null);
                            }}
                        >
                            <span className="icon">⬅</span> DIRECTORY
                        </button>

                        <div className="profile-pill">
                            <div className="p-avatar clickable-avatar">
                                {selected.profile_image ? (
                                    <img
                                        src={selected.profile_image}
                                        alt={selected.emp_name}
                                        onClick={() => setPreviewImage(selected.profile_image)}
                                    />
                                ) : (
                                    <span>{selected.emp_name?.charAt(0)}</span>
                                )}
                            </div>

                            <div className="p-info">
                                <span className="p-name">{selected.emp_name}</span>
                                <span className="p-status">
                                    {selected.workflow_status.replace(/_/g, " ")}
                                </span>
                            </div>
                        </div>

                        <div className="nav-actions">

                            {/* 1) Save Progress */}
                            {["Management_Review", "Scoring"].includes(selected.workflow_status) && (
                                <button
                                    className="btn-okr-action"
                                    onClick={handleSaveEditedOKR}
                                    disabled={isUpdating}
                                    title="Save the progress of your OKR draft changes"
                                >
                                    {isUpdating ? "SAVING..." : "Save Progress"}
                                </button>
                            )}

                            {/* 2) Send it for AR Updation */}
                            {selected.workflow_status === "Management_Review" && (
                                <button
                                    className="btn-okr-action"
                                    onClick={() => updateOKRStatus("Returned_To_Employee")}
                                    disabled={isUpdating}
                                    title="Send the OKR back to the employee for Annual Review (AR) updation"
                                >
                                    {isUpdating ? "RETURNING..." : "Send it for AR Updation"}
                                </button>
                            )}

                            {/* 3) Approve and Send for Grade Scoring */}
                            {selected.workflow_status === "Management_Review" && (
                                <button
                                    className="btn-okr-action"
                                    onClick={() => updateOKRStatus("Scoring")}
                                    disabled={isUpdating}
                                    title="Approve the current OKR and send it for grade scoring"
                                >
                                    {isUpdating ? "PROCESSING..." : "Approve and Send for Grade Scoring"}
                                </button>
                            )}

                            {/* 4) Finalize (for Manager_Scoring_Review) */}
                            {selected.workflow_status === "Manager_Scoring_Review" && (
                                <button
                                    className="btn-okr-action"
                                    onClick={() => updateOKRStatus("Sign_Off")}
                                    disabled={isUpdating}
                                    title="Finalize the OKR and sign off"
                                >
                                    {isUpdating ? "FINALIZING..." : "FINALIZE"}
                                </button>
                            )}

                            {selected.workflow_status === "Locked" && (
                                <span className="locked-label">LOCKED</span>
                            )}

                            <button
                                className="btn-delete-minimal"
                                onClick={handleDeleteEntireOKR}
                                title="Delete OKR"
                            >
                                <Trash2 size={16} />
                            </button>

                        </div>
                    </div>

                    {/* OBJECTIVES */}
                    <div className="objective-vertical-stack">
                        <button
                            onClick={handleAddObjective}
                            style={{
                                alignSelf: "flex-start",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "8px 16px",
                                // background: "linear-gradient(135deg, #00bcd4, #00838f)",
                                background: "linear-gradient(rgb(29 203 225), rgb(35 199 214))",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "50px",
                                cursor: "pointer",
                                fontWeight: "700",
                                fontSize: "13px",
                                letterSpacing: "0.5px",
                                boxShadow: "0 4px 12px rgba(0, 188, 212, 0.25)",
                                transition: "all 0.3s ease",
                                marginTop: "10px",
                                marginBottom: "5px"
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 188, 212, 0.4)";
                                e.currentTarget.style.transform = "translateY(-1px)";
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 188, 212, 0.25)";
                                e.currentTarget.style.transform = "none";
                            }}
                        >
                            + Add Objective
                        </button>

                        {Array.isArray(selected.okr_details) &&
                            selected.okr_details.map((obj, oIdx) => {

                                console.log("========== OBJECT ==========");
                                console.log(obj);
                                console.log("OBJECTIVE:", obj.objective);
                                console.log("KEY RESULTS:", obj.keyResults);

                                const isExpanded = activeObjective === oIdx;

                                const isLocked = selected.workflow_status === "Locked";

                                const isScoreEditable =
                                    selected.workflow_status === "Management_Review" ||
                                    selected.workflow_status === "Scoring" ||
                                    selected.workflow_status === "Manager_Scoring_Review";

                                return (
                                    <div
                                        key={oIdx}
                                        className={`obj-reveal-group ${isExpanded ? "is-active" : ""}`}
                                    >
                                        {/* <h1 style={{ color: "red", fontSize: "40px" }}>
                                            TEST OBJECTIVE
                                        </h1> */}

                                        {/* HEADER */}
                                        <div
                                            className="obj-header-row"
                                            onClick={() =>
                                                setActiveObjective(isExpanded ? null : oIdx)
                                            }
                                        >
                                            <div className="obj-flag-wrapper">
                                                <div className="obj-flag-fold"></div>
                                                <div
                                                    className="obj-flag-body"
                                                    style={{
                                                        background: flagColors[oIdx % flagColors.length]
                                                    }}
                                                >
                                                    {String(oIdx + 1).padStart(2, "0")}
                                                </div>
                                            </div>

                                            {/* OBJECTIVE */}
                                            <div className="obj-text-content">
                                                <textarea
                                                    value={obj.objective || ""}
                                                    rows={2}
                                                    disabled={isLocked}
                                                    onInput={(e) => autoResize(e.target)}
                                                    ref={(el) => el && autoResize(el)}
                                                    onChange={(e) => {
                                                        showEditWarning();

                                                        const updated = { ...selected };
                                                        updated.okr_details[oIdx].objective = e.target.value;
                                                        setSelected(updated);
                                                    }}
                                                    className="objective-title"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "50px",
                                                        color: "#111827",
                                                        background: "transparent",
                                                        border: "none",
                                                        resize: "none",
                                                        overflow: "hidden",
                                                        fontSize: "16px",
                                                        fontWeight: "600",
                                                        outline: "none"
                                                    }}
                                                />
                                            </div>

                                            {/* STATUS */}
                                            <div
                                                className={`obj-status-indicator ${isExpanded ? "open" : ""
                                                    }`}
                                            >
                                                {isExpanded ? "CLOSE" : "CLICK TO REVEAL RESULTS"}
                                            </div>

                                            {/* DELETE OBJECTIVE BUTTON */}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeleteObjective(oIdx);
                                                }}
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    color: "#ff4d4f",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                    marginLeft: "15px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "0"
                                                }}
                                            >
                                                <Trash2 size={16} />
                                            </button>
                                        </div>

                                        {/* KEY RESULTS */}
                                        <div className="kr-vertical-list">
                                            {[...Array(6)].map((_, kIdx) => {
                                                console.log("KR INDEX", kIdx);
                                                console.log(obj.keyResults?.[kIdx]);
                                                const kr = obj.keyResults?.[kIdx] || {
                                                    text: "",
                                                    result: "Pending",
                                                    ar_comment: ""
                                                };

                                                const hasAR = kr.ar_comment?.trim();

                                                return (
                                                    <div
                                                        key={`${oIdx}-${kIdx}`}
                                                        className={`kr-line-item ${hasAR ? "has-ar" : ""}`}
                                                    >
                                                        {/* KR TEXT */}
                                                        <div className="kr-body-wrap">
                                                            <span className="kr-index-inline">
                                                                {kIdx + 1})
                                                            </span>

                                                            <div className="kr-input-area">
                                                                <textarea
                                                                    value={kr.text}
                                                                    disabled={isLocked}
                                                                    onChange={(e) =>
                                                                        handleKRTextChange(
                                                                            oIdx,
                                                                            kIdx,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className="kr-text-minimal auto-expand"
                                                                    rows={1}
                                                                    placeholder="Key Result..."
                                                                    onInput={(e) => autoResize(e.target)}
                                                                    ref={(el) => el && autoResize(el)}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* CONTROLS */}
                                                        <div className="kr-controls">
                                                            <div className="kr-score-dropdown">
                                                                <label>SCORE</label>
                                                                <select
                                                                    value={kr.result || "Pending"}
                                                                    disabled={!isScoreEditable}
                                                                    onChange={(e) =>
                                                                        handleStatusChange(
                                                                            oIdx,
                                                                            kIdx,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    {resultOptions.map((opt) => (
                                                                        <option key={opt} value={opt}>
                                                                            {opt}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <button
                                                                className="kr-line-delete"
                                                                disabled={isLocked}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDeleteKR(oIdx, kIdx);
                                                                }}
                                                            >
                                                                <Trash2 size={16} />

                                                            </button>
                                                        </div>

                                                        {/* AR */}
                                                        {selected.workflow_status ===
                                                            "Management_Review" && (
                                                                <div style={{ marginTop: "8px" }}>
                                                                    {!(
                                                                        activeAR.includes(`${oIdx}-${kIdx}`) ||
                                                                        hasAR
                                                                    ) ? (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                setActiveAR((prev) => [
                                                                                    ...prev,
                                                                                    `${oIdx}-${kIdx}`
                                                                                ])
                                                                            }
                                                                            style={{
                                                                                background: "transparent",
                                                                                border: "none",
                                                                                cursor: "pointer",
                                                                                color: "#ff9800",
                                                                                fontSize: "13px",
                                                                                fontWeight: "600"
                                                                            }}
                                                                        >
                                                                            {hasAR ? "✏️ Edit AR" : "✏️ Add AR"}
                                                                        </button>
                                                                    ) : (
                                                                        <textarea
                                                                            value={kr.ar_comment || ""}
                                                                            onChange={(e) => {
                                                                                const updated = { ...selected };

                                                                                if (!updated.okr_details[oIdx].keyResults) {
                                                                                    updated.okr_details[oIdx].keyResults = [];
                                                                                }

                                                                                while (updated.okr_details[oIdx].keyResults.length <= kIdx) {
                                                                                    updated.okr_details[oIdx].keyResults.push({
                                                                                        text: "",
                                                                                        result: "Pending",
                                                                                        ar_comment: ""
                                                                                    });
                                                                                }

                                                                                updated.okr_details[oIdx].keyResults[kIdx].ar_comment = e.target.value;

                                                                                setSelected(updated);
                                                                            }}
                                                                            rows={2}
                                                                            autoFocus={activeAR.includes(`${oIdx}-${kIdx}`)}
                                                                            style={{
                                                                                width: "100%",
                                                                                marginTop: "6px",
                                                                                padding: "8px",
                                                                                borderRadius: "6px",
                                                                                border: "1px solid #ff9800",
                                                                                background: "rgba(255,152,0,0.05)",
                                                                                fontSize: "13px"
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            )}
                                                    </div>
                                                );
                                            })}


                                            {/* <button
                                                onClick={() => handleAddKR(oIdx)}
                                                style={{
                                                    marginTop: "10px",
                                                    background: "#4caf50",
                                                    color: "#fff",
                                                    border: "none",
                                                    padding: "6px 10px",
                                                    borderRadius: "5px",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                + Add Key Result
                                            </button> */}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>

                    {previewImage && (
                        <div
                            className="image-preview-overlay"
                            onClick={() => setPreviewImage(null)}
                        >
                            <div className="image-preview-box">
                                <img src={previewImage} alt="Preview" />
                            </div>
                        </div>
                    )}
                </div>
            );
        }

        // =========================
        // 🔹 LIST VIEW (UNCHANGED)
        // =========================

        const filteredSubmitted = Object.entries(groupedData).filter(
            ([empName, data]) => {
                const matchesSearch = empName
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());

                const dept = data?.years
                    ? data.years[Object.keys(data.years)[0]][0].department
                    : "";

                const matchesDept = selectedDept
                    ? dept === selectedDept
                    : true;

                return matchesSearch && matchesDept;
            }
        );

        console.log("=========== FILTERED SUBMITTED ===========");
        console.log(filteredSubmitted);

        filteredSubmitted.forEach(([empName, data]) => {
            console.log("Employee:", empName);
            console.log(data);
        });

        const filteredMissing = missingEmployees.filter((emp) => {
            const matchesSearch = emp.full_name
                .toLowerCase()
                .includes(searchTerm.toLowerCase());

            const matchesDept = selectedDept
                ? emp.team === selectedDept
                : true;

            return matchesSearch && matchesDept;
        });


        return (
            <div
                className="okr-genesis-container animate-fade"
                style={{
                    background: "transparent",
                    minHeight: "100vh",
                    padding: "40px 0",
                    width: "100%",
                    fontFamily: "'Inter', 'Segoe UI', sans-serif"
                }}
            >


                <div style={{ width: "95%", margin: "0 auto" }}>

                    {/* 🔍 SEARCH + FILTER + TIMELINE LOCK */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 1.5fr 1fr 1fr 0.6fr 0.6fr",
                            gap: "12px",
                            marginBottom: "12px",
                            alignItems: "center"
                        }}
                    >

                        {/* SEARCH */}
                        <input
                            type="text"
                            placeholder="Search employee..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                padding: "10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                width: "100%"
                            }}
                        />

                        {/* DEPARTMENT */}
                        <select
                            className="department-filter"
                            value={selectedDept}
                            onChange={(e) => setSelectedDept(e.target.value)}
                            style={{ padding: "10px", borderRadius: "8px" }}
                        >
                            <option value="">All Departments</option>
                            {[...new Set(submissions.map((sub) => sub.department))].map(
                                (dept, idx) => (
                                    <option key={idx} value={dept}>
                                        {dept}
                                    </option>
                                )
                            )}
                        </select>

                        {/* YEAR */}
                        <select
                            value={lockYear}
                            onChange={(e) => setLockYear(e.target.value)}
                            style={{ padding: "10px", borderRadius: "8px" }}
                        >
                            {["2024-2025", "2025-2026", "2026-2027"].map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </select>

                        {/* QUARTER */}
                        <select
                            value={lockQuarter}
                            onChange={(e) => setLockQuarter(e.target.value)}
                            style={{ padding: "10px", borderRadius: "8px" }}
                        >
                            {["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"].map((q) => {
                                const isLocked = lockedQuarters[q];

                                return (
                                    <option key={q} value={q}>
                                        {q} {isLocked ? "🔒" : ""}
                                    </option>
                                );
                            })}
                        </select>

                        {/* LOCK */}
                        <button
                            onClick={async () => {
                                try {
                                    const res = await fetch("/gt-api/lock_timeline.php", {
                                        method: "POST",
                                        credentials: "include",
                                        headers: { "Content-Type": "application/json" },
                                        body: JSON.stringify({
                                            year: lockYear,
                                            quarter: lockQuarter,
                                            locked: true
                                        })
                                    });

                                    const data = await res.json();

                                    if (data.success) {
                                        alert("Locked!");

                                        setLockedQuarters(prev => ({
                                            ...prev,
                                            [lockQuarter]: true
                                        }));
                                    }

                                } catch (err) {
                                    console.error("LOCK ERROR:", err);
                                    alert("Error locking");
                                }
                            }}
                            style={{
                                height: "40px",
                                borderRadius: "8px",
                                border: "none",
                                background: "red",
                                color: "#fff",
                                fontSize: "18px",
                                cursor: "pointer",
                                marginTop: "4px"
                            }}
                        >
                            LOCK
                        </button>

                        {/* UNLOCK */}
                        <button
                            onClick={async () => {
                                try {
                                    const res = await fetch("/gt-api/lock_timeline.php", {
                                        method: "POST",
                                        headers: { "Content-Type": "application/json" },
                                        credentials: "include",
                                        body: JSON.stringify({
                                            year: lockYear,
                                            quarter: lockQuarter,
                                            locked: false
                                        })
                                    });

                                    const text = await res.text();
                                    console.log("RAW RESPONSE:", text);

                                    let data;
                                    try {
                                        data = JSON.parse(text);
                                    } catch (e) {
                                        alert("Invalid JSON from server");
                                        return;
                                    }

                                    if (data.success) {
                                        alert("Unlocked!");

                                        setLockedQuarters(prev => ({
                                            ...prev,
                                            [lockQuarter]: false
                                        }));
                                    }

                                } catch {
                                    alert("Error unlocking");
                                }
                            }}
                            style={{
                                height: "40px",
                                borderRadius: "8px",
                                border: "none",
                                background: "green",
                                color: "#fff",
                                fontSize: "18px",
                                cursor: "pointer",
                                marginTop: "4px"
                            }}
                        >
                            UNLOCK
                        </button>

                    </div>

                    {/* HEADER */}
                    <div className="hub-header-compact">
                        <h1 className="hub-title">
                            Employee <span>Performance Hub</span>
                        </h1>
                    </div>

                    {/* TOGGLE */}
                    <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                        <button
                            onClick={() => setViewType("submitted")}
                            style={{
                                padding: "8px 16px",
                                borderRadius: "8px",
                                border:
                                    viewType === "submitted"
                                        ? "2px solid #00bcd4"
                                        : "1px solid #ccc",
                                background:
                                    viewType === "submitted" ? "#e6fafd" : "#fff",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >
                            Submitted
                        </button>

                        <button
                            onClick={() => setViewType("missing")}
                            style={{
                                padding: "8px 16px",
                                borderRadius: "8px",
                                border:
                                    viewType === "missing"
                                        ? "2px solid #ff4d4f"
                                        : "1px solid #ccc",
                                background:
                                    viewType === "missing" ? "#fff1f0" : "#fff",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >
                            Missing
                        </button>
                    </div>

                    {/* GRID */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "12px"
                        }}
                    >
                        {(viewType === "submitted"
                            ? filteredSubmitted
                            : filteredMissing.map((emp) => [emp.full_name, emp])
                        ).map(([empName, data]) => (
                            <div
                                key={empName}
                                className="employee-row-card"
                                style={{
                                    borderRadius: "12px",
                                    padding: "12px 16px",
                                    display: "grid",
                                    gridTemplateColumns: "180px 1fr",
                                    alignItems: "center",
                                    background: "#fff",
                                    border: "1px solid #eef2f6",
                                    minHeight: "75px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
                                }}
                            >
                                {/* LEFT */}
                                <div
                                    style={{
                                        borderRight: "1px solid #edf2f7",
                                        paddingRight: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px"
                                    }}
                                >
                                    <div
                                        className="emp-avatar clickable-avatar"
                                        style={{
                                            width: "38px",
                                            height: "38px",
                                            flexShrink: 0
                                        }}
                                    >
                                        {data.profile_image ? (
                                            <img
                                                src={data.profile_image}
                                                alt={empName}
                                                onClick={() =>
                                                    setPreviewImage(data.profile_image)
                                                }
                                                style={{
                                                    borderRadius: "50%",
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    background: "#f0f0f0",
                                                    borderRadius: "50%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontSize: "14px",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                {empName.charAt(0)}
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ overflow: "hidden" }}>
                                        <h3
                                            style={{
                                                margin: 0,
                                                fontSize: "0.95rem",
                                                fontWeight: "700",
                                                display: "-webkit-box",
                                                WebkitLineClamp: "2",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden"
                                            }}
                                        >
                                            {empName}
                                        </h3>
                                        <p style={{ margin: 0, fontSize: "12px" }}>
                                            ID:{" "}
                                            {viewType === "submitted"
                                                ? data.emp_id
                                                : data.empid}
                                        </p>
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div style={{ paddingLeft: "15px", display: "flex", gap: "15px" }}>
                                    {data?.years ? (
                                        Object.keys(data.years)
                                            .sort((a, b) => b - a)
                                            .map((year) => (
                                                <div key={year}>
                                                    <span>{year}</span>
                                                    <div style={{ display: "flex", gap: "5px" }}>
                                                        {data.years[year].map((sub) => {
                                                            const isLocked =
                                                                sub.workflow_status === "Locked";
                                                            const isReview = [
                                                                "Management_Review",
                                                                "Manager_Scoring_Review"
                                                            ].includes(sub.workflow_status);

                                                            return (
                                                                <button
                                                                    key={sub.id}
                                                                    onClick={() => {
                                                                        const details =
                                                                            typeof sub.okr_details === "string"
                                                                                ? JSON.parse(sub.okr_details)
                                                                                : sub.okr_details;

                                                                        setSelected({
                                                                            ...sub,
                                                                            okr_details: details
                                                                        });

                                                                        // Open first objective automatically
                                                                        setActiveObjective(null);
                                                                    }}
                                                                >
                                                                    {sub.quarter}{" "}
                                                                    {isLocked
                                                                        ? "🔒"
                                                                        : isReview
                                                                            ? "⏳"
                                                                            : "→"}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ))
                                    ) : (
                                        <div>Not Submitted</div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* IMAGE PREVIEW */}
                {previewImage && (
                    <div
                        className="image-preview-overlay"
                        onClick={() => setPreviewImage(null)}
                    >
                        <div
                            className="image-preview-box"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img src={previewImage} alt="Preview" />
                        </div>
                    </div>
                )}
            </div>
        );

    };

    const renderEmployeeReviewTab = () => {
        if (loading) return <div className="loading-screen">ACCESSING REVIEWS...</div>;

        const submittedEmpIds = new Set(
            submissions
                .filter(sub => sub.quarter === currentQuarter)
                .map(sub => sub.emp_id)
        );

        const submittedEmployees = allEmployees.filter(emp =>
            submittedEmpIds.has(emp.empid)
        );

        const missingEmployees = allEmployees.filter(emp =>
            !submittedEmpIds.has(emp.empid)
        );


        if (selectedReview) {
            return (
                <div className="okr-viewer-wrapper animate-fade">
                    <button className="back-action-btn" onClick={() => setSelectedReview(null)}>← BACK TO REVIEWS</button>
                    <div className="glass-report-container" style={{ marginTop: '20px', padding: '30px' }}>
                        <h2 className="blue-gradient-text" style={{ fontSize: '1.8rem' }}>{selectedReview.full_name}'s Self-Review</h2>
                        <p style={{ opacity: 0.6 }}>{selectedReview.review_period} | {selectedReview.team} | Submitted: {new Date(selectedReview.submission_date).toLocaleDateString()}</p>
                        <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />

                        {[
                            { label: "Key Achievements", data: selectedReview.achievements },
                            { label: "Role & Responsibilities", data: selectedReview.responsibilities },
                            { label: "Skills & Growth", data: selectedReview.skills_growth },
                            { label: "Challenges Faced", data: selectedReview.challenges },
                            { label: "Areas for Improvement", data: selectedReview.improvement_areas },
                            { label: "Goals for Next Year", data: selectedReview.goals_next_year },
                            { label: "Additional Contributions", data: selectedReview.additional_contributions },
                            { label: "Support Needed", data: selectedReview.support_needed }
                        ].map(section => (
                            <div key={section.label} style={{ marginBottom: '25px' }}>
                                <h4 style={{ color: '#00bcd4', marginBottom: '12px', fontSize: '1.1rem' }}>{section.label.toUpperCase()}</h4>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {Array.isArray(section.data) ? section.data.map((point, i) => (
                                        point && point.trim() !== "" && (
                                            <div key={i} style={{ background: 'rgba(255,255,255,0.03)', padding: '12px', borderRadius: '6px', borderLeft: '3px solid #00bcd4', fontSize: '13px', lineHeight: '1.5' }}>
                                                {point}
                                            </div>
                                        )
                                    )) : <p style={{ opacity: 0.4 }}>No entries for this section.</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return (
            <div className="okr-genesis-container animate-fade">
                <div className="okr-glass-card">
                    <div className="list-header" style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '1.6rem', color: '#fff' }}>Annual <span className="blue-gradient-text">Self-Reviews</span></h2>
                        {reviews.length === 0 && <p style={{ color: '#ff9800', fontSize: '12px' }}>No records found for department: {managedDept}</p>}
                    </div>
                    <table className="sequencer-table-view">
                        <thead>
                            <tr>
                                <th>EMPLOYEE NAME</th>
                                <th>TEAM</th>
                                <th>PERIOD</th>
                                <th>SUBMISSION DATE</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reviews.length > 0 ? reviews.map(rev => (
                                <tr key={rev.id}>
                                    <td style={{ color: '#00bcd4', fontWeight: 'bold' }}>{rev.full_name}</td>
                                    <td>{rev.team}</td>
                                    <td>{rev.review_period}</td>
                                    <td>{new Date(rev.submission_date).toLocaleDateString()}</td>
                                    <td>
                                        <button className="btn-view-sequence" onClick={() => setSelectedReview(rev)}>VIEW FULL REVIEW</button>
                                    </td>
                                </tr>
                            )) : (
                                <tr><td colSpan="5" style={{ textAlign: 'center', padding: '40px', opacity: 0.5 }}>No reviews found. Verify that employees have submitted the "Employee Review" form.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderSubModule = () => {
        switch (activeTab) {
            case "OKR Tracker": return renderOKRTrackerTab();
            case "Employee Self Performance Review": return renderEmployeeReviewTab();
            case "Manager Review": return renderManagementActionForm("Manager Review");
            case "Probation Period Feedback": return renderManagementActionForm("Probation Period Feedback");
            default: return null;
        }
    };

    return (
        <div className="pay-module">
            <div className="pay-nav-grid">
                {["OKR Tracker", "Employee Self Performance Review", "Manager Review", "Probation Period Feedback"].map((tab) => (
                    <button key={tab} className={activeTab === tab ? 'active' : ''} onClick={() => {
                        setActiveTab(tab);
                        setSelected(null);
                        setSelectedReview(null);
                        setMgmtSelection({ emp_id: "", content: "", accomplished: "", improvements: "" });
                        setMgmtEmpSearch("");
                        setShowOnlyProbation(false);
                        setProbationSearch("");
                        setProbationPage(1);
                    }}>
                        {tab.toUpperCase()}
                    </button>
                ))}
            </div>


            <div className="pay-content-area">
                {renderSubModule()}
            </div>
            {renderPasswordModal()}
            {renderCustomAlertModal()}
        </div>


    );
};

export default ManagementOKRViewer;

